import type { Question, Topic } from "./questionTypes";

export const questions = [
  {
    "section": "8.1.5.3.4",
    "manualPage": "8.1-33",
    "pdfPage": 37,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: reported parameter",
    "choices": [
      "visibility",
      "RVR",
      "ceiling",
      "wind"
    ],
    "correctIndex": 0,
    "explanation": "Runway markings On runways without lights (unserviceable or not available) runway markings shall be available as well visible so as to ensure the required guidance and orientation under the required minimum visibility/ RVR conditions.",
    "sourceQuote": "Runway markings On runways without lights (unserviceable or not available) runway markings shall be available as well visible so as to ensure the required guidance and orientation under the required minimum visibility/ RVR conditions.",
    "sourceRects": [
      [
        105.82,
        430.49,
        192.18,
        441.49
      ],
      [
        105.82,
        449.26,
        552.62,
        460.26
      ],
      [
        105.82,
        462.26,
        552.62,
        473.26
      ],
      [
        105.82,
        475.26,
        178.89,
        486.26
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-001",
    "familyId": "oma8-en-001"
  },
  {
    "section": "8.1.7.1.10",
    "manualPage": "8.1-43",
    "pdfPage": 47,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "The minimum planned block fuel is taxi fuel plus, trip fuel plus, contingency fuel plus, alternate fuel plus, final reserve fuel.",
    "sourceQuote": "The minimum planned block fuel is taxi fuel plus, trip fuel plus, contingency fuel plus, alternate fuel plus, final reserve fuel.",
    "sourceRects": [
      [
        105.83,
        509.25,
        552.63,
        520.25
      ],
      [
        105.83,
        522.25,
        206.73,
        533.25
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-002",
    "familyId": "oma8-en-002"
  },
  {
    "section": "8.1.10.1.4",
    "manualPage": "8.1-53",
    "pdfPage": 57,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "The following items must be entered or checked on the flight plan: Airplane type Take-off weight and zero fuel weight Trip fuel Required fuel Flight plan date Wind forecast date/time The Commander shall sign the flight plan indicating his approval.",
    "sourceQuote": "The following items must be entered or checked on the flight plan: Airplane type Take-off weight and zero fuel weight Trip fuel Required fuel Flight plan date Wind forecast date/time The Commander shall sign the flight plan indicating his approval.",
    "sourceRects": [
      [
        105.82,
        110.26,
        399.03,
        121.26
      ],
      [
        105.82,
        129.49,
        181.92,
        140.49
      ],
      [
        105.82,
        144.49,
        284.73,
        155.49
      ],
      [
        105.82,
        159.5,
        160.18,
        170.5
      ],
      [
        105.82,
        174.5,
        181.78,
        185.5
      ],
      [
        105.82,
        189.5,
        190.8,
        200.5
      ],
      [
        105.82,
        204.51,
        226.8,
        215.51
      ],
      [
        105.82,
        225.28,
        552.67,
        236.28
      ],
      [
        105.82,
        238.28,
        552.77,
        249.28
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-003",
    "familyId": "oma8-en-003"
  },
  {
    "section": "8.1.5.2.5",
    "manualPage": "8.1-31",
    "pdfPage": 35,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: SWW company minimums for circling shall not be lower than: MDH [VALUE] visibility 4800 meters/USA: MDH 1000 feet visibility 3.0 SM unless State minima is higher Standard minimums of MDH 700 feet visibility 3600 meters is shown on the approach chart.",
    "choices": [
      "1000 feet",
      "700 feet",
      "500 feet",
      "1500 feet"
    ],
    "correctIndex": 0,
    "explanation": "SWW company minimums for circling shall not be lower than: MDH 1000 feet visibility 4800 meters/USA: MDH 1000 feet visibility 3.0 SM unless State minima is higher Standard minimums of MDH 700 feet visibility 3600 meters is shown on the approach chart.",
    "sourceQuote": "SWW company minimums for circling shall not be lower than: MDH 1000 feet visibility 4800 meters/USA: MDH 1000 feet visibility 3.0 SM unless State minima is higher Standard minimums of MDH 700 feet visibility 3600 meters is shown on the approach chart.",
    "sourceRects": [
      [
        105.82,
        511.57,
        552.75,
        522.57
      ],
      [
        105.82,
        524.57,
        245.2,
        535.57
      ],
      [
        105.82,
        543.8,
        552.71,
        554.8
      ],
      [
        105.82,
        556.57,
        163.24,
        567.57
      ],
      [
        105.82,
        575.57,
        552.77,
        586.57
      ],
      [
        105.82,
        588.57,
        552.75,
        599.57
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-004",
    "familyId": "oma8-en-004"
  },
  {
    "section": "8.1.3.1.1",
    "manualPage": "8.1-14",
    "pdfPage": 18,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Minimum Descent Altitude (MDA) or Minimum Decent Height (MDH) A specified altitude or height in a non-precision approach or circling approach below which descent must not be made without the required visual reference.",
    "sourceQuote": "Minimum Descent Altitude (MDA) or Minimum Decent Height (MDH) A specified altitude or height in a non-precision approach or circling approach below which descent must not be made without the required visual reference.",
    "sourceRects": [
      [
        77.48,
        529.27,
        524.36,
        541.26
      ],
      [
        77.48,
        543.26,
        524.32,
        554.26
      ],
      [
        77.48,
        556.26,
        524.36,
        567.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-005",
    "familyId": "oma8-en-005"
  },
  {
    "section": "8.1.3.6.3",
    "manualPage": "8.1-26",
    "pdfPage": 30,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "NOTE: 1 The visual aids required to conduct SA CAT II Operations comprise standard runway day markings and approach and runway lighting (runway edge lights, threshold lights, runway end lights).",
    "sourceQuote": "NOTE: 1 The visual aids required to conduct SA CAT II Operations comprise standard runway day markings and approach and runway lighting (runway edge lights, threshold lights, runway end lights).",
    "sourceRects": [
      [
        77.48,
        110.49,
        524.33,
        121.49
      ],
      [
        77.48,
        123.26,
        524.21,
        134.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-006",
    "familyId": "oma8-en-006"
  },
  {
    "section": "8.1.5.5.5",
    "manualPage": "8.1-37",
    "pdfPage": 41,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "Forecast weather conditions must be at or above Canadian alternate minima Alternate planning minima for Mexico Local authorities require planning minima for an alternate, nominated to ATC, to be equal or better than the Mexican alternate minima.",
    "sourceQuote": "Forecast weather conditions must be at or above Canadian alternate minima Alternate planning minima for Mexico Local authorities require planning minima for an alternate, nominated to ATC, to be equal or better than the Mexican alternate minima.",
    "sourceRects": [
      [
        105.82,
        359.26,
        439.01,
        370.26
      ],
      [
        105.82,
        378.48,
        286.76,
        389.48
      ],
      [
        105.82,
        397.25,
        552.75,
        408.25
      ],
      [
        105.82,
        410.25,
        261.69,
        421.25
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-007",
    "familyId": "oma8-en-007"
  },
  {
    "section": "8.1.8.1",
    "manualPage": "8.1-45",
    "pdfPage": 49,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "Landing",
      "take-off",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Maximum Landing Weight (MLW) The maximum structural landing weight is the maximum permissible total airplane weight upon landing under normal circumstances.",
    "sourceQuote": "Maximum Landing Weight (MLW) The maximum structural landing weight is the maximum permissible total airplane weight upon landing under normal circumstances.",
    "sourceRects": [
      [
        105.82,
        584.28,
        261.16,
        595.28
      ],
      [
        105.82,
        603.26,
        552.71,
        614.26
      ],
      [
        105.82,
        616.26,
        552.65,
        627.26
      ],
      [
        105.82,
        629.26,
        265.53,
        640.26
      ]
    ],
    "topic": "mass-balance",
    "id": "oma8-en-008",
    "familyId": "oma8-en-008"
  },
  {
    "section": "8.1.3.3.1",
    "manualPage": "8.1-16",
    "pdfPage": 20,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Category III (CAT III): a DH lower than [VALUE] or no DH, and an RVR less than 300 m or no RVR limitation; ‘instrument approach operation’ means an approach and landing using instruments for navigation guidance based on an instrument approach procedure (IAP).",
    "choices": [
      "100 ft",
      "50 ft",
      "200 ft",
      "300 ft"
    ],
    "correctIndex": 0,
    "explanation": "Category III (CAT III): a DH lower than 100 ft or no DH, and an RVR less than 300 m or no RVR limitation; ‘instrument approach operation’ means an approach and landing using instruments for navigation guidance based on an instrument approach procedure (IAP).",
    "sourceQuote": "Category III (CAT III): a DH lower than 100 ft or no DH, and an RVR less than 300 m or no RVR limitation; ‘instrument approach operation’ means an approach and landing using instruments for navigation guidance based on an instrument approach procedure (IAP).",
    "sourceRects": [
      [
        77.48,
        110.49,
        521.53,
        121.49
      ],
      [
        93.49,
        125.26,
        520.02,
        136.26
      ],
      [
        93.49,
        140.27,
        510.32,
        151.27
      ],
      [
        93.49,
        155.27,
        295.98,
        166.27
      ],
      [
        77.48,
        176.27,
        153.99,
        187.27
      ],
      [
        77.48,
        195.26,
        524.42,
        206.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-009",
    "familyId": "oma8-en-009"
  },
  {
    "section": "8.1.3.4.1",
    "manualPage": "8.1-18",
    "pdfPage": 22,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: If the approach is flown with a level segment at or above MDA(H), [VALUE] shall be added for category D airplane to the minimum RVR/CMV value resulting from the application of Tables 7 and 8.",
    "choices": [
      "400 meters",
      "350 meters",
      "300 meters",
      "500 meters"
    ],
    "correctIndex": 0,
    "explanation": "If the approach is flown with a level segment at or above MDA(H), 400 meters shall be added for category D airplane to the minimum RVR/CMV value resulting from the application of Tables 7 and 8.",
    "sourceQuote": "If the approach is flown with a level segment at or above MDA(H), 400 meters shall be added for category D airplane to the minimum RVR/CMV value resulting from the application of Tables 7 and 8.",
    "sourceRects": [
      [
        77.48,
        541.27,
        524.37,
        553.26
      ],
      [
        77.48,
        555.26,
        517.01,
        566.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-010",
    "familyId": "oma8-en-010"
  },
  {
    "section": "8.1.5.2.4",
    "manualPage": "8.1-30",
    "pdfPage": 34,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Expressed in terms of DH and visibility/RVR CAT II The lowest approved CAT II minimums are, if no higher State minimum exists: DH [VALUE], RVR 300 meters.",
    "choices": [
      "100 feet",
      "50 feet",
      "200 feet",
      "300 feet"
    ],
    "correctIndex": 0,
    "explanation": "Expressed in terms of DH and visibility/RVR CAT II The lowest approved CAT II minimums are, if no higher State minimum exists: DH 100 feet, RVR 300 meters.",
    "sourceQuote": "Expressed in terms of DH and visibility/RVR CAT II The lowest approved CAT II minimums are, if no higher State minimum exists: DH 100 feet, RVR 300 meters.",
    "sourceRects": [
      [
        77.48,
        480.51,
        276.81,
        491.51
      ],
      [
        77.48,
        499.51,
        108.02,
        510.51
      ],
      [
        77.48,
        518.51,
        510.8,
        529.51
      ],
      [
        77.48,
        537.51,
        128.71,
        548.51
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-011",
    "familyId": "oma8-en-011"
  },
  {
    "section": "8.1.5.5.7",
    "manualPage": "8.1-39",
    "pdfPage": 43,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: At airports where an instrument approach procedure is not available the following planning minima must be applied: Ceiling: At or above the highest Minimum Sector Altitude (MSA) Visibility: [VALUE] or more.",
    "choices": [
      "8 Km",
      "7 Km",
      "9 Km",
      "10 Km"
    ],
    "correctIndex": 0,
    "explanation": "At airports where an instrument approach procedure is not available the following planning minima must be applied: Ceiling: At or above the highest Minimum Sector Altitude (MSA) Visibility: 8 Km or more.",
    "sourceQuote": "At airports where an instrument approach procedure is not available the following planning minima must be applied: Ceiling: At or above the highest Minimum Sector Altitude (MSA) Visibility: 8 Km or more.",
    "sourceRects": [
      [
        105.82,
        244.25,
        552.77,
        255.25
      ],
      [
        105.82,
        257.25,
        178.48,
        268.25
      ],
      [
        105.82,
        276.25,
        395.32,
        287.25
      ],
      [
        105.82,
        295.25,
        217.05,
        306.25
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-012",
    "familyId": "oma8-en-012"
  },
  {
    "section": "8.1.10",
    "manualPage": "8.1-72",
    "pdfPage": 76,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: FUEL FCTR / 0.970PCT Fuel mileage factor, degradation factor from the book value (fuel factor is adjusted on the first delivery and then every 3-[VALUE] or if required after maintenance actions).",
    "choices": [
      "6 month",
      "3 month",
      "2 month",
      "1 month"
    ],
    "correctIndex": 0,
    "explanation": "FUEL FCTR / 0.970PCT Fuel mileage factor, degradation factor from the book value (fuel factor is adjusted on the first delivery and then every 3-6 month or if required after maintenance actions).",
    "sourceQuote": "FUEL FCTR / 0.970PCT Fuel mileage factor, degradation factor from the book value (fuel factor is adjusted on the first delivery and then every 3-6 month or if required after maintenance actions).",
    "sourceRects": [
      [
        77.48,
        314.47,
        524.44,
        325.47
      ],
      [
        77.48,
        327.25,
        524.3,
        338.25
      ],
      [
        77.48,
        340.25,
        524.22,
        351.25
      ],
      [
        77.48,
        353.25,
        524.32,
        364.25
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-013",
    "familyId": "oma8-en-013"
  },
  {
    "section": "8.1.1.2",
    "manualPage": "8.1-5",
    "pdfPage": 9,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "take-off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "All flights, except in direct connection with take-off, approach or landing, shall be operated at an altitude/flight level which is at or above the minimum altitude.",
    "sourceQuote": "All flights, except in direct connection with take-off, approach or landing, shall be operated at an altitude/flight level which is at or above the minimum altitude.",
    "sourceRects": [
      [
        105.83,
        172.26,
        552.72,
        183.26
      ],
      [
        105.83,
        185.26,
        552.78,
        196.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-014",
    "familyId": "oma8-en-014"
  },
  {
    "section": "8.1.2.3.3",
    "manualPage": "8.1-8",
    "pdfPage": 12,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "Enroute fuel alternate (ERF) A suitable airport which must be planned if the amount of route reserve fuel is reduced from 5% to 3% of planned trip fuel.",
    "sourceQuote": "Enroute fuel alternate (ERF) A suitable airport which must be planned if the amount of route reserve fuel is reduced from 5% to 3% of planned trip fuel.",
    "sourceRects": [
      [
        77.48,
        628.25,
        202.82,
        639.25
      ],
      [
        77.48,
        647.26,
        524.38,
        658.26
      ],
      [
        77.48,
        660.26,
        460.13,
        671.26
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-015",
    "familyId": "oma8-en-015"
  },
  {
    "section": "8.1.3.1.1",
    "manualPage": "8.1-14",
    "pdfPage": 18,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Decision Altitude (DA) or Decision Height (DH) A specified altitude or height, in the precision approach at which a missed approach must be initiated if the required visual reference to continue the approach has not been established.",
    "sourceQuote": "Decision Altitude (DA) or Decision Height (DH) A specified altitude or height, in the precision approach at which a missed approach must be initiated if the required visual reference to continue the approach has not been established.",
    "sourceRects": [
      [
        77.48,
        409.26,
        292.81,
        420.26
      ],
      [
        77.48,
        428.25,
        524.32,
        439.25
      ],
      [
        77.48,
        441.26,
        435.41,
        452.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-016",
    "familyId": "oma8-en-016"
  },
  {
    "section": "8.1.3.4.1",
    "manualPage": "8.1-18",
    "pdfPage": 22,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: reported parameter",
    "choices": [
      "Visibility",
      "RVR",
      "ceiling",
      "wind"
    ],
    "correctIndex": 0,
    "explanation": "The minimum RVR/CMV/Visibility shall be the highest of the values derived from RVR/CMV vs.",
    "sourceQuote": "The minimum RVR/CMV/Visibility shall be the highest of the values derived from RVR/CMV vs.",
    "sourceRects": [
      [
        77.48,
        497.26,
        524.21,
        508.26
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-017",
    "familyId": "oma8-en-017"
  },
  {
    "section": "8.1.5.3.4",
    "manualPage": "8.1-32",
    "pdfPage": 36,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "take-off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "The minimum required availability for visual aids for take-off and approach/landing is stipulated below.",
    "sourceQuote": "The minimum required availability for visual aids for take-off and approach/landing is stipulated below.",
    "sourceRects": [
      [
        77.47,
        584.27,
        524.32,
        595.27
      ],
      [
        77.47,
        597.27,
        106.38,
        608.27
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-018",
    "familyId": "oma8-en-018"
  },
  {
    "section": "8.1.10",
    "manualPage": "8.1-70",
    "pdfPage": 74,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "Fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "Note: When a 2nd alternate is required for legal reasons, only the alternate with the highest burn off will be displayed with Fuel, Time, Distance and ETA data in the fuel summary.",
    "sourceQuote": "Note: When a 2nd alternate is required for legal reasons, only the alternate with the highest burn off will be displayed with Fuel, Time, Distance and ETA data in the fuel summary.",
    "sourceRects": [
      [
        77.48,
        607.23,
        524.4,
        618.23
      ],
      [
        77.48,
        619.24,
        524.36,
        631.23
      ],
      [
        77.48,
        633.23,
        524.43,
        644.23
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-019",
    "familyId": "oma8-en-019"
  },
  {
    "section": "8.1.10",
    "manualPage": "8.1-71",
    "pdfPage": 75,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "BLK Minimum required Block fuel EF Extra fuel requested by the Commander, stating reasons for the request (DUE).",
    "sourceQuote": "BLK Minimum required Block fuel EF Extra fuel requested by the Commander, stating reasons for the request (DUE).",
    "sourceRects": [
      [
        105.82,
        239.5,
        263.95,
        250.5
      ],
      [
        105.82,
        258.5,
        469.88,
        269.5
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-020",
    "familyId": "oma8-en-020"
  },
  {
    "section": "8.1.3.1.1",
    "manualPage": "8.1-14",
    "pdfPage": 18,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Low Visibility Take-off (LVTO) A take-off where the Runway Visual Range (RVR) is [VALUE].",
    "choices": [
      "less than 550 meters",
      "less than 500 meters",
      "less than 600 meters",
      "less than 400 meters"
    ],
    "correctIndex": 0,
    "explanation": "Low Visibility Take-off (LVTO) A take-off where the Runway Visual Range (RVR) is less than 550 meters.",
    "sourceQuote": "Low Visibility Take-off (LVTO) A take-off where the Runway Visual Range (RVR) is less than 550 meters.",
    "sourceRects": [
      [
        77.48,
        511.26,
        219.14,
        522.26
      ],
      [
        77.48,
        529.27,
        524.36,
        541.26
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-021",
    "familyId": "oma8-en-021"
  },
  {
    "section": "8.1.1.1",
    "manualPage": "8.1-4",
    "pdfPage": 8,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Minimum Safe Altitude (MSA) Altitude depicted on an instrument approach chart and identified as the minimum safe altitude which provides a [VALUE] obstacle clearance within a 25 NM radius from the navigational facility upon which the MSA is predicated.",
    "choices": [
      "1000 feet",
      "700 feet",
      "500 feet",
      "1500 feet"
    ],
    "correctIndex": 0,
    "explanation": "Minimum Safe Altitude (MSA) Altitude depicted on an instrument approach chart and identified as the minimum safe altitude which provides a 1000 feet obstacle clearance within a 25 NM radius from the navigational facility upon which the MSA is predicated.",
    "sourceQuote": "Minimum Safe Altitude (MSA) Altitude depicted on an instrument approach chart and identified as the minimum safe altitude which provides a 1000 feet obstacle clearance within a 25 NM radius from the navigational facility upon which the MSA is predicated.",
    "sourceRects": [
      [
        77.48,
        739.77,
        215.78,
        750.77
      ],
      [
        77.48,
        758.77,
        524.32,
        769.77
      ],
      [
        77.48,
        771.77,
        524.32,
        782.77
      ],
      [
        77.48,
        784.77,
        524.4,
        795.77
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-022",
    "familyId": "oma8-en-022"
  },
  {
    "section": "8.1.3.1.1",
    "manualPage": "8.1-14",
    "pdfPage": 18,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "take-off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Runway Visual Range (RVR) The distance, as assessed by either instrument or human observation over which the runway lights or surface markings may be seen in the direction of take-off or landing.",
    "sourceQuote": "Runway Visual Range (RVR) The distance, as assessed by either instrument or human observation over which the runway lights or surface markings may be seen in the direction of take-off or landing.",
    "sourceRects": [
      [
        77.48,
        588.26,
        207.14,
        599.26
      ],
      [
        77.48,
        607.26,
        524.4,
        618.26
      ],
      [
        77.48,
        620.26,
        524.32,
        631.26
      ],
      [
        77.48,
        633.26,
        517.49,
        644.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-023",
    "familyId": "oma8-en-023"
  },
  {
    "section": "8.1.3.9",
    "manualPage": "8.1-27",
    "pdfPage": 31,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: RVR of [VALUE] shall not be used for visual approach.",
    "choices": [
      "less than 800 meters",
      "less than 700 meters",
      "less than 600 meters",
      "less than 1000 meters"
    ],
    "correctIndex": 0,
    "explanation": "RVR of less than 800 meters shall not be used for visual approach.",
    "sourceQuote": "RVR of less than 800 meters shall not be used for visual approach.",
    "sourceRects": [
      [
        105.83,
        307.26,
        398.25,
        318.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-024",
    "familyId": "oma8-en-024"
  },
  {
    "section": "8.1.5.5.3",
    "manualPage": "8.1-35",
    "pdfPage": 39,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Forecast at ETA +/[VALUE] must be: Applicable Company minima or better NOTE: For CAT II operations the forecast visibility must be at least 200 meters.",
    "choices": [
      "1 hour",
      "2 hour",
      "3 hour",
      "4 hour"
    ],
    "correctIndex": 0,
    "explanation": "Forecast at ETA +/1 hour must be: Applicable Company minima or better NOTE: For CAT II operations the forecast visibility must be at least 200 meters.",
    "sourceQuote": "Forecast at ETA +/1 hour must be: Applicable Company minima or better NOTE: For CAT II operations the forecast visibility must be at least 200 meters.",
    "sourceRects": [
      [
        105.83,
        728.27,
        435.16,
        739.27
      ],
      [
        105.83,
        747.5,
        464.73,
        758.5
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-025",
    "familyId": "oma8-en-025"
  },
  {
    "section": "8.1.7.1.5",
    "manualPage": "8.1-42",
    "pdfPage": 46,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: For B747 aircraft the minimum quantity of fuel at commencement of approach is [VALUE].",
    "choices": [
      "5.5 tons",
      "5 tons",
      "6 tons",
      "4.5 tons"
    ],
    "correctIndex": 0,
    "explanation": "For B747 aircraft the minimum quantity of fuel at commencement of approach is 5.5 tons.",
    "sourceQuote": "For B747 aircraft the minimum quantity of fuel at commencement of approach is 5.5 tons.",
    "sourceRects": [
      [
        77.47,
        786.3,
        474.05,
        797.3
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-026",
    "familyId": "oma8-en-026"
  },
  {
    "section": "8.1.7.1.5",
    "manualPage": "8.1-43",
    "pdfPage": 47,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: For B777F aircraft the minimum quantity of fuel at commencement of approach is [VALUE].",
    "choices": [
      "3.5 tons",
      "3 tons",
      "4 tons",
      "4.5 tons"
    ],
    "correctIndex": 0,
    "explanation": "For B777F aircraft the minimum quantity of fuel at commencement of approach is 3.5 tons.",
    "sourceQuote": "For B777F aircraft the minimum quantity of fuel at commencement of approach is 3.5 tons.",
    "sourceRects": [
      [
        105.82,
        110.26,
        508.64,
        121.26
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-027",
    "familyId": "oma8-en-027"
  },
  {
    "section": "8.1.10.1.4",
    "manualPage": "8.1-53",
    "pdfPage": 57,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: If the Flight Plan zero fuel weight differs by [VALUE] or more, from the actual airplane ZFW, the Commander shall request a new Flight Plan.",
    "choices": [
      "5.0 tons",
      "4.5 tons",
      "5.5 tons",
      "4 tons"
    ],
    "correctIndex": 0,
    "explanation": "If the Flight Plan zero fuel weight differs by 5.0 tons or more, from the actual airplane ZFW, the Commander shall request a new Flight Plan.",
    "sourceQuote": "If the Flight Plan zero fuel weight differs by 5.0 tons or more, from the actual airplane ZFW, the Commander shall request a new Flight Plan.",
    "sourceRects": [
      [
        105.82,
        251.28,
        552.77,
        262.28
      ],
      [
        105.82,
        264.28,
        552.71,
        275.28
      ],
      [
        105.82,
        277.28,
        279.45,
        288.28
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-028",
    "familyId": "oma8-en-028"
  },
  {
    "section": "8.1.2.5.1",
    "manualPage": "8.1-10",
    "pdfPage": 14,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: type of aerodrome",
    "choices": [
      "Destination Alternate",
      "take-off alternate",
      "en-route alternate",
      "departure airport"
    ],
    "correctIndex": 0,
    "explanation": "However, for operational flexibility, the following minimum levels may be accepted: Departure, Destination, and Destination Alternate Aerodromes: Category 7 (may be temporarily reduced to Category 6 if approved by the Authority and deemed acceptable by SWW).",
    "sourceQuote": "However, for operational flexibility, the following minimum levels may be accepted: Departure, Destination, and Destination Alternate Aerodromes: Category 7 (may be temporarily reduced to Category 6 if approved by the Authority and deemed acceptable by SWW).",
    "sourceRects": [
      [
        77.48,
        251.26,
        450.36,
        262.26
      ],
      [
        77.48,
        270.49,
        514.42,
        281.49
      ],
      [
        93.49,
        285.26,
        473.03,
        296.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-029",
    "familyId": "oma8-en-029"
  },
  {
    "section": "8.1.2.5.2",
    "manualPage": "8.1-11",
    "pdfPage": 15,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: reported parameter",
    "choices": [
      "visibility",
      "RVR",
      "ceiling",
      "wind"
    ],
    "correctIndex": 0,
    "explanation": "When time permits, consideration shall be given to: Current RFFS level and response time; Nature of malfunction or damage; Runway length and surface condition; Weather, visibility, and crosswind limits.",
    "sourceQuote": "When time permits, consideration shall be given to: Current RFFS level and response time; Nature of malfunction or damage; Runway length and surface condition; Weather, visibility, and crosswind limits.",
    "sourceRects": [
      [
        105.82,
        110.26,
        332.79,
        121.26
      ],
      [
        105.82,
        129.49,
        292.89,
        140.49
      ],
      [
        105.82,
        144.49,
        271.29,
        155.49
      ],
      [
        105.82,
        159.5,
        289.05,
        170.5
      ],
      [
        105.82,
        174.5,
        300.74,
        185.5
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-030",
    "familyId": "oma8-en-030"
  },
  {
    "section": "8.1.3.2.2",
    "manualPage": "8.1-15",
    "pdfPage": 19,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "take-off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "The take-off minima must be selected to ensure sufficient guidance to control the airplane in the event of both a discontinued take-off in adverse circumstances and a continued take-off after the failure of the critical power unit.",
    "sourceQuote": "The take-off minima must be selected to ensure sufficient guidance to control the airplane in the event of both a discontinued take-off in adverse circumstances and a continued take-off after the failure of the critical power unit.",
    "sourceRects": [
      [
        105.82,
        173.26,
        552.63,
        184.26
      ],
      [
        105.82,
        186.26,
        552.75,
        197.26
      ],
      [
        105.82,
        199.92,
        205.29,
        210.92
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-031",
    "familyId": "oma8-en-031"
  },
  {
    "section": "8.1.3.3.1",
    "manualPage": "8.1-17",
    "pdfPage": 21,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Minimum Descent Height (MDH) The MDH for an approach shall be not lower than the highest of: The OCH for the category of aircraft, or The system minimum, or The MDH specified in the Airplane Flight Manual (AFM) if stated Table 5: System minima vs.",
    "sourceQuote": "Minimum Descent Height (MDH) The MDH for an approach shall be not lower than the highest of: The OCH for the category of aircraft, or The system minimum, or The MDH specified in the Airplane Flight Manual (AFM) if stated Table 5: System minima vs.",
    "sourceRects": [
      [
        105.82,
        259.28,
        256.36,
        270.28
      ],
      [
        105.82,
        278.26,
        391.35,
        289.26
      ],
      [
        105.82,
        297.49,
        298.06,
        308.49
      ],
      [
        105.82,
        312.49,
        232.3,
        323.49
      ],
      [
        105.82,
        327.49,
        414.61,
        338.49
      ],
      [
        183.63,
        347.49,
        360.44,
        358.49
      ],
      [
        354.54,
        399.16,
        393.87,
        410.16
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-032",
    "familyId": "oma8-en-032"
  },
  {
    "section": "8.1.3.4",
    "manualPage": "8.1-18",
    "pdfPage": 22,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "In order to qualify for the lowest allowable values of RVR/CMV detailed in Table 8 (Min and Max applicable RVR/CMV) the instrument approach shall meet at least the following facility requirements and associated conditions: 1.",
    "sourceQuote": "In order to qualify for the lowest allowable values of RVR/CMV detailed in Table 8 (Min and Max applicable RVR/CMV) the instrument approach shall meet at least the following facility requirements and associated conditions: 1.",
    "sourceRects": [
      [
        77.48,
        190.25,
        524.33,
        201.25
      ],
      [
        77.48,
        203.26,
        524.31,
        214.26
      ],
      [
        77.48,
        216.26,
        192.86,
        227.26
      ],
      [
        77.48,
        235.49,
        511.65,
        246.49
      ],
      [
        93.5,
        248.26,
        520.62,
        259.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-033",
    "familyId": "oma8-en-033"
  },
  {
    "section": "8.1.3.6.3",
    "manualPage": "8.1-26",
    "pdfPage": 30,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "The approach light configurations are classified and listed in Table 7 above NOTE: 2 Before conducting SA CAT II operations it must be ensure that appropriate Low Visibility Procedures are established and in operation at the intended airport of landing.",
    "sourceQuote": "The approach light configurations are classified and listed in Table 7 above NOTE: 2 Before conducting SA CAT II operations it must be ensure that appropriate Low Visibility Procedures are established and in operation at the intended airport of landing.",
    "sourceRects": [
      [
        77.48,
        136.26,
        524.28,
        147.26
      ],
      [
        77.48,
        149.27,
        321.87,
        160.27
      ],
      [
        77.48,
        166.49,
        524.33,
        177.49
      ],
      [
        77.48,
        179.26,
        417.89,
        190.26
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-034",
    "familyId": "oma8-en-034"
  },
  {
    "section": "8.1.5.3.4",
    "manualPage": "8.1-33",
    "pdfPage": 37,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "landing",
      "take-off",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Night landings For night operation (planning and actual landing) at least runway edge, threshold and runway end lights must be serviceable.",
    "sourceQuote": "Night landings For night operation (planning and actual landing) at least runway edge, threshold and runway end lights must be serviceable.",
    "sourceRects": [
      [
        105.82,
        308.26,
        170.82,
        319.26
      ],
      [
        105.82,
        327.26,
        552.67,
        338.26
      ],
      [
        105.82,
        340.26,
        552.67,
        351.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-035",
    "familyId": "oma8-en-035"
  },
  {
    "section": "8.1.5.4.1",
    "manualPage": "8.1-34",
    "pdfPage": 38,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "Take-off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Take-off weight The take-off weight of the airplane shall be taken to be its weight, including everything and everyone carried, at the commencement of the take-off run.",
    "sourceQuote": "Take-off weight The take-off weight of the airplane shall be taken to be its weight, including everything and everyone carried, at the commencement of the take-off run.",
    "sourceRects": [
      [
        77.48,
        282.26,
        524.36,
        293.26
      ],
      [
        77.48,
        295.26,
        382.38,
        306.26
      ]
    ],
    "topic": "mass-balance",
    "id": "oma8-en-036",
    "familyId": "oma8-en-036"
  },
  {
    "section": "8.1.5.4.3",
    "manualPage": "8.1-35",
    "pdfPage": 39,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "Company and/or extra fuel is often required to cater for the changing situations and for the uncertainty in forecasting and assessing weather and runway conditions.",
    "sourceQuote": "Company and/or extra fuel is often required to cater for the changing situations and for the uncertainty in forecasting and assessing weather and runway conditions.",
    "sourceRects": [
      [
        105.82,
        128.26,
        552.74,
        139.26
      ],
      [
        105.82,
        141.26,
        552.71,
        152.26
      ],
      [
        105.82,
        154.26,
        508.15,
        165.26
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-037",
    "familyId": "oma8-en-037"
  },
  {
    "section": "8.1.8.1",
    "manualPage": "8.1-45",
    "pdfPage": 49,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "landing",
      "take-off",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "The allowable, operational landing weight may be restricted to less than the Maximum Landing Weight.",
    "sourceQuote": "The allowable, operational landing weight may be restricted to less than the Maximum Landing Weight.",
    "sourceRects": [
      [
        105.82,
        584.28,
        261.16,
        595.28
      ],
      [
        105.82,
        603.26,
        552.71,
        614.26
      ],
      [
        105.82,
        616.26,
        552.65,
        627.26
      ],
      [
        105.82,
        629.26,
        265.53,
        640.26
      ]
    ],
    "topic": "mass-balance",
    "id": "oma8-en-038",
    "familyId": "oma8-en-038"
  },
  {
    "section": "8.1.8.1",
    "manualPage": "8.1-45",
    "pdfPage": 49,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "Take-Off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Maximum Take-Off Weight (MTOW) MTOW is the maximum permissible total airplane weight at start of the take-off run.",
    "sourceQuote": "Maximum Take-Off Weight (MTOW) MTOW is the maximum permissible total airplane weight at start of the take-off run.",
    "sourceRects": [
      [
        105.82,
        648.26,
        272.68,
        659.26
      ],
      [
        105.82,
        667.26,
        552.8,
        678.26
      ],
      [
        105.82,
        680.26,
        499.76,
        691.26
      ]
    ],
    "topic": "mass-balance",
    "id": "oma8-en-039",
    "familyId": "oma8-en-039"
  },
  {
    "section": "8.1.8.1",
    "manualPage": "8.1-45",
    "pdfPage": 49,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "take-off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "The allowable, operational take-off weight may be restricted to less than the Maximum Take-Off Weight.",
    "sourceQuote": "The allowable, operational take-off weight may be restricted to less than the Maximum Take-Off Weight.",
    "sourceRects": [
      [
        105.82,
        648.26,
        272.68,
        659.26
      ],
      [
        105.82,
        667.26,
        552.8,
        678.26
      ],
      [
        105.82,
        680.26,
        499.76,
        691.26
      ]
    ],
    "topic": "mass-balance",
    "id": "oma8-en-040",
    "familyId": "oma8-en-040"
  },
  {
    "section": "8.1.8.1",
    "manualPage": "8.1-45",
    "pdfPage": 49,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "Fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "Maximum Zero Fuel Weight (MZFW) MZFW is the maximum permissible weight of an airplane without usable fuel.",
    "sourceQuote": "Maximum Zero Fuel Weight (MZFW) MZFW is the maximum permissible weight of an airplane without usable fuel.",
    "sourceRects": [
      [
        105.82,
        750.26,
        274.41,
        761.26
      ],
      [
        105.83,
        769.25,
        451.04,
        780.25
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-041",
    "familyId": "oma8-en-041"
  },
  {
    "section": "8.1.3.3.1",
    "manualPage": "8.1-16",
    "pdfPage": 20,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: SA approaches SA CAT I is an operational credit applied to a CAT I operation that allows the instrument segment of a CAT I approach to be extended to a minimum DH of [VALUE].",
    "choices": [
      "150 ft",
      "100 ft",
      "200 ft",
      "50 ft"
    ],
    "correctIndex": 0,
    "explanation": "SA approaches SA CAT I is an operational credit applied to a CAT I operation that allows the instrument segment of a CAT I approach to be extended to a minimum DH of 150 ft.",
    "sourceQuote": "SA approaches SA CAT I is an operational credit applied to a CAT I operation that allows the instrument segment of a CAT I approach to be extended to a minimum DH of 150 ft.",
    "sourceRects": [
      [
        77.48,
        571.28,
        142.95,
        582.28
      ],
      [
        77.48,
        590.26,
        524.42,
        601.26
      ],
      [
        77.48,
        603.26,
        340.62,
        614.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-042",
    "familyId": "oma8-en-042"
  },
  {
    "section": "8.1.3.6.3",
    "manualPage": "8.1-26",
    "pdfPage": 30,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: For operations in RVR of [VALUE] or less, center line lights must be available.",
    "choices": [
      "400 meters",
      "350 meters",
      "300 meters",
      "500 meters"
    ],
    "correctIndex": 0,
    "explanation": "For operations in RVR of 400 meters or less, center line lights must be available.",
    "sourceQuote": "For operations in RVR of 400 meters or less, center line lights must be available.",
    "sourceRects": [
      [
        77.48,
        136.26,
        524.28,
        147.26
      ],
      [
        77.48,
        166.49,
        524.33,
        177.49
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-043",
    "familyId": "oma8-en-043"
  },
  {
    "section": "8.1.5.2.1",
    "manualPage": "8.1-28",
    "pdfPage": 32,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Lowest permissible takeoff minimum is RVR [VALUE].",
    "choices": [
      "150 meters",
      "125 meters",
      "100 meters",
      "200 meters"
    ],
    "correctIndex": 0,
    "explanation": "Lowest permissible takeoff minimum is RVR 150 meters.",
    "sourceQuote": "Lowest permissible takeoff minimum is RVR 150 meters.",
    "sourceRects": [
      [
        77.48,
        289.26,
        508.66,
        300.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-044",
    "familyId": "oma8-en-044"
  },
  {
    "section": "8.1.7.1.9",
    "manualPage": "8.1-43",
    "pdfPage": 47,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "Take-off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Take-off fuel is the fuel corresponding to block fuel minus the taxi fuel.",
    "sourceQuote": "Take-off fuel is the fuel corresponding to block fuel minus the taxi fuel.",
    "sourceRects": [
      [
        105.83,
        472.26,
        420.56,
        483.26
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-045",
    "familyId": "oma8-en-045"
  },
  {
    "section": "8.1.10",
    "manualPage": "8.1-74",
    "pdfPage": 78,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "Landing",
      "take-off",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "LDC< LDA The ‘Landing Distance’ calculated from the OPT with selected Autobrake should be noted here and the ‘Landing Distance Available’ for the arrival runway should be noted here.",
    "sourceQuote": "LDC< LDA The ‘Landing Distance’ calculated from the OPT with selected Autobrake should be noted here and the ‘Landing Distance Available’ for the arrival runway should be noted here.",
    "sourceRects": [
      [
        77.48,
        738.4,
        524.42,
        749.4
      ],
      [
        77.48,
        751.17,
        524.36,
        762.17
      ],
      [
        77.48,
        764.18,
        524.21,
        775.18
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-046",
    "familyId": "oma8-en-046"
  },
  {
    "section": "8.1.1.1",
    "manualPage": "8.1-3",
    "pdfPage": 7,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Minimum IFR Altitudes Minimum altitudes for IFR operations are published on aeronautical charts for airways, routes, and for standard instrument approach procedures.",
    "sourceQuote": "Minimum IFR Altitudes Minimum altitudes for IFR operations are published on aeronautical charts for airways, routes, and for standard instrument approach procedures.",
    "sourceRects": [
      [
        105.82,
        475.26,
        212.1,
        486.26
      ],
      [
        105.82,
        494.26,
        552.75,
        505.26
      ],
      [
        105.82,
        507.26,
        552.71,
        518.26
      ],
      [
        105.82,
        520.26,
        334.71,
        531.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-047",
    "familyId": "oma8-en-047"
  },
  {
    "section": "8.1.1.2",
    "manualPage": "8.1-5",
    "pdfPage": 9,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "The published minimum altitudes must be applied conservatively whenever difficulties regarding navigation are to be expected, e.g. unreliability of navigation aids, detours due to weather etc.",
    "sourceQuote": "The published minimum altitudes must be applied conservatively whenever difficulties regarding navigation are to be expected, e.g. unreliability of navigation aids, detours due to weather etc.",
    "sourceRects": [
      [
        105.83,
        185.26,
        552.78,
        196.26
      ],
      [
        105.83,
        198.26,
        552.68,
        209.26
      ],
      [
        105.83,
        211.26,
        552.68,
        222.26
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-048",
    "familyId": "oma8-en-048"
  },
  {
    "section": "8.1.2.2.4",
    "manualPage": "8.1-7",
    "pdfPage": 11,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "During the approach phase no noise abatement procedures shall be accepted if conflicting with the stabilised final approach procedure for the airplane type (refer to OM-B).",
    "sourceQuote": "During the approach phase no noise abatement procedures shall be accepted if conflicting with the stabilised final approach procedure for the airplane type (refer to OM-B).",
    "sourceRects": [
      [
        105.82,
        658.28,
        552.77,
        669.28
      ],
      [
        105.82,
        671.28,
        427.76,
        682.28
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-049",
    "familyId": "oma8-en-049"
  },
  {
    "section": "8.1.2.5.1",
    "manualPage": "8.1-10",
    "pdfPage": 14,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "En-route Alternates: Category 6 (minimum Category 5 may be accepted in exceptional circumstances, supported by a risk assessment and Crew Commander decision).",
    "sourceQuote": "En-route Alternates: Category 6 (minimum Category 5 may be accepted in exceptional circumstances, supported by a risk assessment and Crew Commander decision).",
    "sourceRects": [
      [
        77.48,
        300.49,
        511.52,
        311.49
      ],
      [
        93.49,
        315.27,
        413.99,
        326.27
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-050",
    "familyId": "oma8-en-050"
  },
  {
    "section": "8.1.2.5.1",
    "manualPage": "8.1-10",
    "pdfPage": 14,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "These are based on the philosophy that a localized fire (e.g. brake or engine fire) may be controlled even with less than the minimum RFFS capacity, whereas in the event of a major fire, crew shall evacuate and abandon the aircraft.",
    "sourceQuote": "These are based on the philosophy that a localized fire (e.g. brake or engine fire) may be controlled even with less than the minimum RFFS capacity, whereas in the event of a major fire, crew shall evacuate and abandon the aircraft.",
    "sourceRects": [
      [
        77.48,
        355.26,
        524.32,
        366.26
      ],
      [
        77.48,
        367.27,
        524.36,
        379.26
      ],
      [
        77.48,
        381.27,
        207.66,
        392.27
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-051",
    "familyId": "oma8-en-051"
  },
  {
    "section": "8.1.3.1",
    "manualPage": "8.1-13",
    "pdfPage": 17,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "NOTE: Each minimum published on Jeppesen charts is the lowest permissible for the particular type of operation; no reduction below the published values is authorised, except when conducting a visual approach with reduced visibility.",
    "sourceQuote": "NOTE: Each minimum published on Jeppesen charts is the lowest permissible for the particular type of operation; no reduction below the published values is authorised, except when conducting a visual approach with reduced visibility.",
    "sourceRects": [
      [
        105.83,
        722.55,
        552.79,
        733.55
      ],
      [
        105.83,
        735.32,
        552.63,
        746.32
      ],
      [
        105.83,
        748.33,
        552.78,
        759.33
      ],
      [
        105.83,
        760.34,
        552.72,
        772.33
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-052",
    "familyId": "oma8-en-052"
  },
  {
    "section": "8.1.3.2.2",
    "manualPage": "8.1-15",
    "pdfPage": 19,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "NOTE: 1: For night operation at least runway edge and runway end lights are required.",
    "sourceQuote": "NOTE: 1: For night operation at least runway edge and runway end lights are required.",
    "sourceRects": [
      [
        105.82,
        376.81,
        494.48,
        387.81
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-053",
    "familyId": "oma8-en-053"
  },
  {
    "section": "8.1.3.4",
    "manualPage": "8.1-18",
    "pdfPage": 22,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "The lateral part of the missed approach procedure must be flown via the MAPt unless otherwise stated on the approach chart.",
    "sourceQuote": "The lateral part of the missed approach procedure must be flown via the MAPt unless otherwise stated on the approach chart.",
    "sourceRects": [
      [
        77.48,
        447.26,
        524.32,
        458.26
      ],
      [
        77.48,
        460.26,
        453.41,
        471.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-054",
    "familyId": "oma8-en-054"
  },
  {
    "section": "8.1.5.4.2",
    "manualPage": "8.1-34",
    "pdfPage": 38,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: reported parameter",
    "choices": [
      "wind",
      "RVR",
      "visibility",
      "ceiling"
    ],
    "correctIndex": 0,
    "explanation": "For preflight purposes the wind speed and direction must be within the limits for the anticipated runway conditions or required by the airport operating minima.",
    "sourceQuote": "For preflight purposes the wind speed and direction must be within the limits for the anticipated runway conditions or required by the airport operating minima.",
    "sourceRects": [
      [
        77.48,
        712.26,
        524.36,
        724.25
      ],
      [
        77.48,
        726.26,
        524.43,
        737.26
      ],
      [
        77.48,
        752.26,
        524.4,
        763.26
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-055",
    "familyId": "oma8-en-055"
  },
  {
    "section": "8.1.5.5.2",
    "manualPage": "8.1-35",
    "pdfPage": 39,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "take-off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "A take-off alternate shall be specified if meteorological, operational and/or other performance conditions preclude return to the departure airport.",
    "sourceQuote": "A take-off alternate shall be specified if meteorological, operational and/or other performance conditions preclude return to the departure airport.",
    "sourceRects": [
      [
        105.82,
        444.25,
        552.71,
        455.25
      ],
      [
        105.82,
        457.26,
        552.71,
        468.26
      ],
      [
        105.82,
        489.49,
        427.53,
        500.49
      ]
    ],
    "topic": "flight-planning",
    "id": "oma8-en-056",
    "familyId": "oma8-en-056"
  },
  {
    "section": "8.1.5.5.5",
    "manualPage": "8.1-37",
    "pdfPage": 41,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "take-off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "This take-off alternate shall be located within two hours one-engine inoperative cruise speed according to the AFM in still air, standard conditions based on the actual TOW.",
    "sourceQuote": "This take-off alternate shall be located within two hours one-engine inoperative cruise speed according to the AFM in still air, standard conditions based on the actual TOW.",
    "sourceRects": [
      [
        105.82,
        327.26,
        552.71,
        338.26
      ],
      [
        105.82,
        340.26,
        424.64,
        351.26
      ]
    ],
    "topic": "flight-planning",
    "id": "oma8-en-057",
    "familyId": "oma8-en-057"
  },
  {
    "section": "8.1.5.5.6",
    "manualPage": "8.1-37",
    "pdfPage": 41,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Holding clearances will be issued as required and an approach clearance will be provided at the appropriate time.",
    "sourceQuote": "Holding clearances will be issued as required and an approach clearance will be provided at the appropriate time.",
    "sourceRects": [
      [
        105.82,
        667.27,
        552.71,
        679.26
      ],
      [
        105.82,
        694.26,
        552.71,
        705.26
      ],
      [
        105.82,
        707.26,
        234.81,
        718.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-058",
    "familyId": "oma8-en-058"
  },
  {
    "section": "8.1.5.6.1",
    "manualPage": "8.1-39",
    "pdfPage": 43,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: type of aerodrome",
    "choices": [
      "destination alternate",
      "take-off alternate",
      "en-route alternate",
      "departure airport"
    ],
    "correctIndex": 0,
    "explanation": "The weather minima for regular/provisional destination and its destination alternate must be in accordance with preflight planning rules.",
    "sourceQuote": "The weather minima for regular/provisional destination and its destination alternate must be in accordance with preflight planning rules.",
    "sourceRects": [
      [
        105.82,
        406.25,
        552.71,
        418.24
      ],
      [
        105.82,
        420.24,
        552.67,
        431.24
      ],
      [
        105.82,
        433.24,
        286.17,
        444.24
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-059",
    "familyId": "oma8-en-059"
  },
  {
    "section": "8.1.7.1.1",
    "manualPage": "8.1-41",
    "pdfPage": 45,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "take-off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Taxi fuel which shall not be less than the amount expected to be used prior to take-off.",
    "sourceQuote": "Taxi fuel which shall not be less than the amount expected to be used prior to take-off.",
    "sourceRects": [
      [
        105.83,
        760.28,
        552.72,
        771.28
      ],
      [
        105.83,
        773.28,
        455.13,
        784.28
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-060",
    "familyId": "oma8-en-060"
  },
  {
    "section": "8.1.8.1",
    "manualPage": "8.1-46",
    "pdfPage": 50,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "Fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "Maximum payload Maximum Zero Fuel Weight minus Operational Empty Weight.",
    "sourceQuote": "Maximum payload Maximum Zero Fuel Weight minus Operational Empty Weight.",
    "sourceRects": [
      [
        77.48,
        148.26,
        160.73,
        159.26
      ],
      [
        77.48,
        167.26,
        355.98,
        178.26
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-061",
    "familyId": "oma8-en-061"
  },
  {
    "section": "8.1.8.1",
    "manualPage": "8.1-46",
    "pdfPage": 50,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "Trip fuel distribution must correspond to the standard fuel loading procedure.",
    "sourceQuote": "Trip fuel distribution must correspond to the standard fuel loading procedure.",
    "sourceRects": [
      [
        77.48,
        275.26,
        184.45,
        286.26
      ],
      [
        77.48,
        294.26,
        524.36,
        305.26
      ],
      [
        77.48,
        307.26,
        276.06,
        318.26
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-062",
    "familyId": "oma8-en-062"
  },
  {
    "section": "8.1.8.4.3",
    "manualPage": "8.1-47",
    "pdfPage": 51,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "Only the new fuel figures with the index must be entered in the respective places to calculate the new TOW CG In case of a load change at the techstop station, a new loadsheet shall be completed.",
    "sourceQuote": "Only the new fuel figures with the index must be entered in the respective places to calculate the new TOW CG In case of a load change at the techstop station, a new loadsheet shall be completed.",
    "sourceRects": [
      [
        121.84,
        347.27,
        545.64,
        358.27
      ],
      [
        121.84,
        361.28,
        544.73,
        373.27
      ],
      [
        121.84,
        377.27,
        518.33,
        388.27
      ],
      [
        105.82,
        392.51,
        489.38,
        403.51
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-063",
    "familyId": "oma8-en-063"
  },
  {
    "section": "8.1.9.3.2",
    "manualPage": "8.1-50",
    "pdfPage": 54,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "In the event of route change required by either the Commander or ATC, Flight Dispatch should be contacted for assistance.",
    "sourceQuote": "In the event of route change required by either the Commander or ATC, Flight Dispatch should be contacted for assistance.",
    "sourceRects": [
      [
        77.49,
        498.25,
        524.44,
        509.25
      ],
      [
        77.49,
        511.25,
        184.63,
        522.25
      ]
    ],
    "topic": "flight-planning",
    "id": "oma8-en-064",
    "familyId": "oma8-en-064"
  },
  {
    "section": "8.1.10",
    "manualPage": "8.1-71",
    "pdfPage": 75,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "The amount of fuel required to achieve this rounding up is called RUP Fuel.",
    "sourceQuote": "The amount of fuel required to achieve this rounding up is called RUP Fuel.",
    "sourceRects": [
      [
        105.82,
        181.26,
        552.77,
        192.26
      ],
      [
        105.82,
        194.27,
        552.65,
        205.27
      ],
      [
        105.82,
        207.27,
        552.67,
        218.27
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-065",
    "familyId": "oma8-en-065"
  },
  {
    "section": "8.1.12.2",
    "manualPage": "8.1-95",
    "pdfPage": 99,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "flight crew",
      "Commander",
      "First Officer",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "Each flight crew member must possess and, when on duty, carry with him a valid flight crew license and medical certificate for the duty he is performing, as well as valid travel documents.",
    "sourceQuote": "Each flight crew member must possess and, when on duty, carry with him a valid flight crew license and medical certificate for the duty he is performing, as well as valid travel documents.",
    "sourceRects": [
      [
        105.86,
        535.27,
        552.81,
        546.27
      ],
      [
        105.86,
        547.28,
        552.75,
        559.27
      ]
    ],
    "topic": "flight-planning",
    "id": "oma8-en-066",
    "familyId": "oma8-en-066"
  },
  {
    "section": "8.1.3.3.1",
    "manualPage": "8.1-15",
    "pdfPage": 19,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: TYPE A and TYPE B approaches “Type A instrument approach operation” means an instrument approach operation with an MDH or a DH [VALUE]; “Type B instrument approach operation” means an operation with a DH below 250 ft.",
    "choices": [
      "at or above 250 ft",
      "at or above 200 ft",
      "at or above 300 ft",
      "at or above 100 ft"
    ],
    "correctIndex": 0,
    "explanation": "TYPE A and TYPE B approaches “Type A instrument approach operation” means an instrument approach operation with an MDH or a DH at or above 250 ft; “Type B instrument approach operation” means an operation with a DH below 250 ft.",
    "sourceQuote": "TYPE A and TYPE B approaches “Type A instrument approach operation” means an instrument approach operation with an MDH or a DH at or above 250 ft; “Type B instrument approach operation” means an operation with a DH below 250 ft.",
    "sourceRects": [
      [
        105.82,
        651.58,
        253.62,
        662.58
      ],
      [
        105.82,
        670.59,
        552.77,
        681.59
      ],
      [
        105.82,
        683.59,
        204.88,
        694.59
      ],
      [
        105.82,
        702.59,
        552.71,
        713.59
      ],
      [
        105.82,
        734.82,
        547.89,
        745.82
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-067",
    "familyId": "oma8-en-067"
  },
  {
    "section": "8.1.3.6.1",
    "manualPage": "8.1-25",
    "pdfPage": 29,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: SA CAT II operation Precision instrument approach and landing using ILS or MLS which meets facility requirements as established below with: DH [VALUE] but not lower than 100 feet (see Table 13 below), and RVR of not less than 350/400 meters.",
    "choices": [
      "below 200 feet",
      "below 100 feet",
      "below 300 feet",
      "below 50 feet"
    ],
    "correctIndex": 0,
    "explanation": "SA CAT II operation Precision instrument approach and landing using ILS or MLS which meets facility requirements as established below with: DH below 200 feet but not lower than 100 feet (see Table 13 below), and RVR of not less than 350/400 meters.",
    "sourceQuote": "SA CAT II operation Precision instrument approach and landing using ILS or MLS which meets facility requirements as established below with: DH below 200 feet but not lower than 100 feet (see Table 13 below), and RVR of not less than 350/400 meters.",
    "sourceRects": [
      [
        105.82,
        110.26,
        196.76,
        121.26
      ],
      [
        105.82,
        129.26,
        552.65,
        140.26
      ],
      [
        105.82,
        142.26,
        209.68,
        153.26
      ],
      [
        105.82,
        161.49,
        442.84,
        172.49
      ],
      [
        105.81,
        176.49,
        381.04,
        187.49
      ],
      [
        105.81,
        191.5,
        550.03,
        202.5
      ],
      [
        121.83,
        206.27,
        394.85,
        217.27
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-068",
    "familyId": "oma8-en-068"
  },
  {
    "section": "8.1.5.5.4",
    "manualPage": "8.1-36",
    "pdfPage": 40,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Planning of alternate minima The table below shows the planning minima for destination alternate airport, 3% ERF at ETA +/[VALUE] or enroute alternate airport from earliest until latest possible ETA.",
    "choices": [
      "1 hour",
      "2 hour",
      "3 hour",
      "4 hour"
    ],
    "correctIndex": 0,
    "explanation": "Planning of alternate minima The table below shows the planning minima for destination alternate airport, 3% ERF at ETA +/1 hour or enroute alternate airport from earliest until latest possible ETA.",
    "sourceQuote": "Planning of alternate minima The table below shows the planning minima for destination alternate airport, 3% ERF at ETA +/1 hour or enroute alternate airport from earliest until latest possible ETA.",
    "sourceRects": [
      [
        77.47,
        128.49,
        214.97,
        139.49
      ],
      [
        77.47,
        147.25,
        524.32,
        158.25
      ],
      [
        77.47,
        160.25,
        389.81,
        171.25
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-069",
    "familyId": "oma8-en-069"
  },
  {
    "section": "8.1.3.1.1",
    "manualPage": "8.1-14",
    "pdfPage": 18,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Circling The visual phase of an instrument approach to bring an aircraft into position for landing on a runway which is not suitably located for a straight-in approach.",
    "sourceQuote": "Circling The visual phase of an instrument approach to bring an aircraft into position for landing on a runway which is not suitably located for a straight-in approach.",
    "sourceRects": [
      [
        77.48,
        230.26,
        113.46,
        241.26
      ],
      [
        77.48,
        249.26,
        524.32,
        260.26
      ],
      [
        77.48,
        262.26,
        319.98,
        273.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-070",
    "familyId": "oma8-en-070"
  },
  {
    "section": "8.1.3.1.1",
    "manualPage": "8.1-14",
    "pdfPage": 18,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "Take-Off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Low Visibility Procedures Procedures applied at an airport for the purpose of ensuring safe operations during SA Category I, SA Category II, Category II and III approach and Low Visibility Take-Off.",
    "sourceQuote": "Low Visibility Procedures Procedures applied at an airport for the purpose of ensuring safe operations during SA Category I, SA Category II, Category II and III approach and Low Visibility Take-Off.",
    "sourceRects": [
      [
        77.48,
        460.25,
        192.63,
        471.25
      ],
      [
        77.48,
        479.26,
        524.36,
        490.26
      ],
      [
        77.48,
        492.26,
        389.1,
        503.26
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-071",
    "familyId": "oma8-en-071"
  },
  {
    "section": "8.1.3.1.1",
    "manualPage": "8.1-14",
    "pdfPage": 18,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: reported parameter",
    "choices": [
      "visibility",
      "RVR",
      "ceiling",
      "wind"
    ],
    "correctIndex": 0,
    "explanation": "Applying an appropriate factor to the reported meteorological visibility (Converted Met Visibility) may be used to derive RVR values.",
    "sourceQuote": "Applying an appropriate factor to the reported meteorological visibility (Converted Met Visibility) may be used to derive RVR values.",
    "sourceRects": [
      [
        77.48,
        620.26,
        524.32,
        631.26
      ],
      [
        77.48,
        633.26,
        517.49,
        644.26
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-072",
    "familyId": "oma8-en-072"
  },
  {
    "section": "8.1.6.2.1",
    "manualPage": "8.1-41",
    "pdfPage": 45,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: reported parameter",
    "choices": [
      "RVR",
      "visibility",
      "ceiling",
      "wind"
    ],
    "correctIndex": 0,
    "explanation": "Recent RVR tendency The recent RVR tendency, if reported in the RVR group, should not be misunderstood as an outlook or forecast.",
    "sourceQuote": "Recent RVR tendency The recent RVR tendency, if reported in the RVR group, should not be misunderstood as an outlook or forecast.",
    "sourceRects": [
      [
        105.82,
        360.26,
        203.24,
        371.26
      ],
      [
        105.82,
        379.26,
        552.75,
        390.26
      ],
      [
        105.82,
        392.26,
        143.37,
        403.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-073",
    "familyId": "oma8-en-073"
  },
  {
    "section": "8.1.7.1.6",
    "manualPage": "8.1-43",
    "pdfPage": 47,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "take-off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "An amount of fuel in excess of the planned take-off fuel generated by the flight planning system to cover anticipated deviations from planned operating conditions (also for economical reasons i.e. fuel cost savings/supply difficulties).",
    "sourceQuote": "An amount of fuel in excess of the planned take-off fuel generated by the flight planning system to cover anticipated deviations from planned operating conditions (also for economical reasons i.e. fuel cost savings/supply difficulties).",
    "sourceRects": [
      [
        105.82,
        147.25,
        552.67,
        158.25
      ],
      [
        105.82,
        160.25,
        552.62,
        171.25
      ],
      [
        105.82,
        173.26,
        248.01,
        184.26
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-074",
    "familyId": "oma8-en-074"
  },
  {
    "section": "8.1.10.1.3",
    "manualPage": "8.1-52",
    "pdfPage": 56,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "The destination alternate fuel is calculated via the missed approach, followed by the expected arrival procedure at destination alternate.",
    "sourceQuote": "The destination alternate fuel is calculated via the missed approach, followed by the expected arrival procedure at destination alternate.",
    "sourceRects": [
      [
        77.48,
        635.27,
        524.28,
        646.27
      ],
      [
        77.48,
        648.27,
        226.38,
        659.27
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-075",
    "familyId": "oma8-en-075"
  },
  {
    "section": "8.1.10",
    "manualPage": "8.1-69",
    "pdfPage": 73,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: As this number is unique within [VALUE], it is the best reference to use if discussion with Flight Dispatch is required,to avoid ambiguity.",
    "choices": [
      "approximately 24 hours",
      "approximately 12 hours",
      "approximately 36 hours",
      "approximately 8 hours"
    ],
    "correctIndex": 0,
    "explanation": "As this number is unique within approximately 24 hours, it is the best reference to use if discussion with Flight Dispatch is required,to avoid ambiguity.",
    "sourceQuote": "As this number is unique within approximately 24 hours, it is the best reference to use if discussion with Flight Dispatch is required,to avoid ambiguity.",
    "sourceRects": [
      [
        105.83,
        676.41,
        552.65,
        687.64
      ],
      [
        105.83,
        689.41,
        552.67,
        700.41
      ],
      [
        105.83,
        702.41,
        240.34,
        713.41
      ]
    ],
    "topic": "flight-planning",
    "id": "oma8-en-076",
    "familyId": "oma8-en-076"
  },
  {
    "section": "8.1.10",
    "manualPage": "8.1-70",
    "pdfPage": 74,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "The filed and operationally preferred will be listed as the first alternate, this may be different from the fuel alternate.",
    "sourceQuote": "The filed and operationally preferred will be listed as the first alternate, this may be different from the fuel alternate.",
    "sourceRects": [
      [
        77.48,
        619.24,
        524.36,
        631.23
      ],
      [
        77.48,
        633.23,
        524.43,
        644.23
      ],
      [
        77.48,
        646.23,
        319.98,
        657.23
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-077",
    "familyId": "oma8-en-077"
  },
  {
    "section": "8.1.10",
    "manualPage": "8.1-71",
    "pdfPage": 75,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: 250 or minimum clean speed is used to [VALUE], thereafter at the speed defined in this space.",
    "choices": [
      "10,000 feet",
      "50 feet",
      "100 feet",
      "200 feet"
    ],
    "correctIndex": 0,
    "explanation": "250 or minimum clean speed is used to 10,000 feet, thereafter at the speed defined in this space.",
    "sourceQuote": "250 or minimum clean speed is used to 10,000 feet, thereafter at the speed defined in this space.",
    "sourceRects": [
      [
        105.82,
        683.21,
        552.64,
        694.21
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-078",
    "familyId": "oma8-en-078"
  },
  {
    "section": "8.1.10",
    "manualPage": "8.1-73",
    "pdfPage": 77,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: FLVL Planned flight level MORA Segment Minimum Off-Route Altitude x [VALUE] 25 NM on each side of the segment centerline.",
    "choices": [
      "100 feet",
      "50 feet",
      "200 feet",
      "300 feet"
    ],
    "correctIndex": 0,
    "explanation": "FLVL Planned flight level MORA Segment Minimum Off-Route Altitude x 100 feet 25 NM on each side of the segment centerline.",
    "sourceQuote": "FLVL Planned flight level MORA Segment Minimum Off-Route Altitude x 100 feet 25 NM on each side of the segment centerline.",
    "sourceRects": [
      [
        105.82,
        666.46,
        222.85,
        677.46
      ],
      [
        105.82,
        685.46,
        552.71,
        696.46
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-079",
    "familyId": "oma8-en-079"
  },
  {
    "section": "8.1",
    "manualPage": "8.1-1",
    "pdfPage": 5,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Flight Dispatcher",
      "Commander",
      "First Officer",
      "flight crew"
    ],
    "correctIndex": 0,
    "explanation": "Flight Dispatcher shall ensure that a common set of flight documents is utilized by the Flight Dispatcher and Commander for all flight preparation and planning.",
    "sourceQuote": "Flight Dispatcher shall ensure that a common set of flight documents is utilized by the Flight Dispatcher and Commander for all flight preparation and planning.",
    "sourceRects": [
      [
        105.82,
        622.3,
        552.71,
        633.3
      ],
      [
        105.82,
        635.3,
        552.8,
        646.3
      ],
      [
        105.82,
        648.3,
        465.92,
        659.3
      ]
    ],
    "topic": "flight-planning",
    "id": "oma8-en-080",
    "familyId": "oma8-en-080"
  },
  {
    "section": "8.2.4.1",
    "manualPage": "8.2-24",
    "pdfPage": 126,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: One step De-icing / Anti-icing refers to the removal of light frost or light snow using hot fluid at a [VALUE] and a maximum of 92°C with the fluid providing anti-icing protection for a limited period of time (Holdover Time).",
    "choices": [
      "minimum of 60°C",
      "minimum of 55°C",
      "minimum of 65°C",
      "minimum of 70°C"
    ],
    "correctIndex": 0,
    "explanation": "One step De-icing / Anti-icing refers to the removal of light frost or light snow using hot fluid at a minimum of 60°C and a maximum of 92°C with the fluid providing anti-icing protection for a limited period of time (Holdover Time).",
    "sourceQuote": "One step De-icing / Anti-icing refers to the removal of light frost or light snow using hot fluid at a minimum of 60°C and a maximum of 92°C with the fluid providing anti-icing protection for a limited period of time (Holdover Time).",
    "sourceRects": [
      [
        77.48,
        378.26,
        524.43,
        389.26
      ],
      [
        77.48,
        391.27,
        524.33,
        402.27
      ],
      [
        77.48,
        404.27,
        394.86,
        415.27
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-081",
    "familyId": "oma8-en-081"
  },
  {
    "section": "8.2.4.6",
    "manualPage": "8.2-27",
    "pdfPage": 129,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "Two-step de-icing/anti-icing shall be performed with heated fluid to remove deposits of frost, ice or snow (de-icing), immediately followed with the application of a cold anti-icing fluid.",
    "sourceQuote": "Two-step de-icing/anti-icing shall be performed with heated fluid to remove deposits of frost, ice or snow (de-icing), immediately followed with the application of a cold anti-icing fluid.",
    "sourceRects": [
      [
        105.84,
        640.28,
        552.73,
        652.27
      ],
      [
        105.84,
        654.28,
        552.68,
        665.28
      ],
      [
        105.84,
        667.28,
        552.68,
        678.28
      ],
      [
        105.84,
        680.28,
        347.14,
        691.28
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-082",
    "familyId": "oma8-en-082"
  },
  {
    "section": "8.2.4.9",
    "manualPage": "8.2-28",
    "pdfPage": 130,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "The following information (anti-icing code) shall be recorded and communicated to the Commander to confirm that the post de-icing/anti-icing inspection has been successfully completed and the aircraft is clean: The fluid type, i.e.",
    "sourceQuote": "The following information (anti-icing code) shall be recorded and communicated to the Commander to confirm that the post de-icing/anti-icing inspection has been successfully completed and the aircraft is clean: The fluid type, i.e.",
    "sourceRects": [
      [
        77.49,
        671.24,
        524.42,
        682.24
      ],
      [
        77.49,
        684.25,
        524.29,
        695.25
      ],
      [
        77.49,
        697.25,
        113.67,
        708.25
      ],
      [
        77.49,
        716.48,
        295.84,
        727.48
      ],
      [
        77.49,
        731.48,
        514.77,
        742.48
      ],
      [
        77.49,
        761.49,
        426.83,
        772.49
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-083",
    "familyId": "oma8-en-083"
  },
  {
    "section": "8.2.4.1",
    "manualPage": "8.2-24",
    "pdfPage": 126,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Only four items of information are required: Type of fluid Fluid concentration Outside Air Temperature (OAT) Weather conditions Example: The weather conditions are snowing with an OAT between [VALUE] and 3 °C and the type of fluid in use is TYPE II.",
    "choices": [
      "0 °C",
      "1 °C",
      "3 °C",
      "5 °C"
    ],
    "correctIndex": 0,
    "explanation": "Only four items of information are required: Type of fluid Fluid concentration Outside Air Temperature (OAT) Weather conditions Example: The weather conditions are snowing with an OAT between 0 °C and 3 °C and the type of fluid in use is TYPE II.",
    "sourceQuote": "Only four items of information are required: Type of fluid Fluid concentration Outside Air Temperature (OAT) Weather conditions Example: The weather conditions are snowing with an OAT between 0 °C and 3 °C and the type of fluid in use is TYPE II.",
    "sourceRects": [
      [
        77.48,
        610.28,
        521.17,
        621.28
      ],
      [
        77.48,
        629.5,
        150.6,
        640.5
      ],
      [
        77.48,
        644.51,
        179.16,
        655.51
      ],
      [
        77.48,
        659.51,
        233.72,
        670.51
      ],
      [
        77.48,
        674.52,
        178.18,
        685.52
      ],
      [
        77.48,
        695.28,
        524.41,
        706.28
      ],
      [
        77.48,
        708.29,
        524.41,
        719.29
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-084",
    "familyId": "oma8-en-084"
  },
  {
    "section": "8.2.4.10",
    "manualPage": "8.2-29",
    "pdfPage": 131,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "off",
      "ON",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "De-icing/ anti-icing should be accomplished as near as possible to the aircraft estimated time of departure, considering the prevailing weather conditions, weather forecast, the de-icing fluid holdover times and takeoff slots.",
    "sourceQuote": "De-icing/ anti-icing should be accomplished as near as possible to the aircraft estimated time of departure, considering the prevailing weather conditions, weather forecast, the de-icing fluid holdover times and takeoff slots.",
    "sourceRects": [
      [
        105.83,
        127.25,
        552.72,
        138.25
      ],
      [
        105.83,
        140.26,
        552.76,
        151.26
      ],
      [
        105.83,
        153.26,
        207.46,
        164.26
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-085",
    "familyId": "oma8-en-085"
  },
  {
    "section": "8.2.4.11",
    "manualPage": "8.2-30",
    "pdfPage": 132,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: If holdover times are not required, a temperature of [VALUE] (140 °F) at the nozzle is desirable If holdover times are required, the temperature of water or fluid/water mixtures shall be at least 60 °C (140 °F) at the nozzle.",
    "choices": [
      "60 °C",
      "55 °C",
      "65 °C",
      "70 °C"
    ],
    "correctIndex": 0,
    "explanation": "If holdover times are not required, a temperature of 60 °C (140 °F) at the nozzle is desirable If holdover times are required, the temperature of water or fluid/water mixtures shall be at least 60 °C (140 °F) at the nozzle.",
    "sourceQuote": "If holdover times are not required, a temperature of 60 °C (140 °F) at the nozzle is desirable If holdover times are required, the temperature of water or fluid/water mixtures shall be at least 60 °C (140 °F) at the nozzle.",
    "sourceRects": [
      [
        77.48,
        187.49,
        519.22,
        198.49
      ],
      [
        93.49,
        202.26,
        509.84,
        213.26
      ],
      [
        93.49,
        217.27,
        132.94,
        228.27
      ],
      [
        77.48,
        232.27,
        521.86,
        243.5
      ],
      [
        93.49,
        247.28,
        521.5,
        258.28
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-086",
    "familyId": "oma8-en-086"
  },
  {
    "section": "8.2.4.3",
    "manualPage": "8.2-26",
    "pdfPage": 128,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: reported parameter",
    "choices": [
      "visibility",
      "RVR",
      "ceiling",
      "wind"
    ],
    "correctIndex": 0,
    "explanation": "Any contamination check shall cover all critical parts of the aircraft and shall be performed from points offering sufficient visibility of theses parts (e.g. from the de-icing vehicle itself or any other suitable piece of equipment).",
    "sourceQuote": "Any contamination check shall cover all critical parts of the aircraft and shall be performed from points offering sufficient visibility of theses parts (e.g. from the de-icing vehicle itself or any other suitable piece of equipment).",
    "sourceRects": [
      [
        77.5,
        373.27,
        524.45,
        384.27
      ],
      [
        77.5,
        385.28,
        524.39,
        397.27
      ],
      [
        77.5,
        399.27,
        524.42,
        410.27
      ],
      [
        77.5,
        412.28,
        248.96,
        423.28
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-087",
    "familyId": "oma8-en-087"
  },
  {
    "section": "8.2.4.6",
    "manualPage": "8.2-27",
    "pdfPage": 129,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "On",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "One-step de-icing/anti-icing shall be performed with heated water-fluid mixture to remove light frost or light snow, with the fluid providing anti-icing protection.",
    "sourceQuote": "One-step de-icing/anti-icing shall be performed with heated water-fluid mixture to remove light frost or light snow, with the fluid providing anti-icing protection.",
    "sourceRects": [
      [
        105.84,
        609.27,
        552.64,
        620.27
      ],
      [
        105.84,
        622.28,
        368.26,
        633.28
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-088",
    "familyId": "oma8-en-088"
  },
  {
    "section": "8.2.4.7",
    "manualPage": "8.2-27",
    "pdfPage": 129,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "De-icing/anti-icing fluids shall not be directed into the orifices of pitot heads, TAT probes, fuel vents, static ports or directly onto airstream direction detectors, probes/angle of attack airflow sensors.",
    "sourceQuote": "De-icing/anti-icing fluids shall not be directed into the orifices of pitot heads, TAT probes, fuel vents, static ports or directly onto airstream direction detectors, probes/angle of attack airflow sensors.",
    "sourceRects": [
      [
        105.85,
        748.27,
        552.83,
        759.27
      ],
      [
        105.85,
        761.27,
        526.91,
        772.27
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-089",
    "familyId": "oma8-en-089"
  },
  {
    "section": "8.2.4.11",
    "manualPage": "8.2-31",
    "pdfPage": 133,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "Whenever frost or ice occurs on the lower surface of the wing in the area of the fuel tank, indicating a cold-soaked wing, the 50/50 dilutions of Type II or IV shall not be used for the anti-icing step because fluid freezing may occur.",
    "sourceQuote": "Whenever frost or ice occurs on the lower surface of the wing in the area of the fuel tank, indicating a cold-soaked wing, the 50/50 dilutions of Type II or IV shall not be used for the anti-icing step because fluid freezing may occur.",
    "sourceRects": [
      [
        105.82,
        565.17,
        550.8,
        576.17
      ],
      [
        121.84,
        579.94,
        537.0,
        590.94
      ],
      [
        121.84,
        594.95,
        290.18,
        605.95
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-090",
    "familyId": "oma8-en-090"
  },
  {
    "section": "8.2.4.11",
    "manualPage": "8.2-33",
    "pdfPage": 135,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "Whenever frost or ice occurs on the lower surface of the wing in the area of the fuel tank, indicating a cold-soaked wing, the 50/50 dilutions of Type III shall not be used for the anti-icing step because fluid freezing may occur.",
    "sourceQuote": "Whenever frost or ice occurs on the lower surface of the wing in the area of the fuel tank, indicating a cold-soaked wing, the 50/50 dilutions of Type III shall not be used for the anti-icing step because fluid freezing may occur.",
    "sourceRects": [
      [
        105.82,
        109.27,
        550.8,
        121.49
      ],
      [
        121.84,
        125.26,
        535.08,
        136.26
      ],
      [
        121.84,
        140.27,
        269.78,
        151.27
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-091",
    "familyId": "oma8-en-091"
  },
  {
    "section": "8.2.2.6.8",
    "manualPage": "8.2-14",
    "pdfPage": 116,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: 1.0 to [VALUE]) fuselage length measured parallel to the aircraft's centerline should meet the maximum running load limitation specified in the Weight and Balance Manual for the lower, main or upper deck position it is to be loaded on in the aircraft.",
    "choices": [
      "1.2 m",
      "1 m",
      "2.2 m",
      "3.2 m"
    ],
    "correctIndex": 0,
    "explanation": "1.0 to 1.2 m) fuselage length measured parallel to the aircraft's centerline should meet the maximum running load limitation specified in the Weight and Balance Manual for the lower, main or upper deck position it is to be loaded on in the aircraft.",
    "sourceQuote": "1.0 to 1.2 m) fuselage length measured parallel to the aircraft's centerline should meet the maximum running load limitation specified in the Weight and Balance Manual for the lower, main or upper deck position it is to be loaded on in the aircraft.",
    "sourceRects": [
      [
        77.48,
        434.52,
        141.19,
        445.52
      ],
      [
        77.48,
        453.28,
        524.43,
        464.28
      ],
      [
        77.48,
        466.29,
        524.32,
        477.29
      ],
      [
        77.48,
        479.29,
        524.42,
        490.29
      ],
      [
        77.48,
        492.29,
        185.1,
        503.29
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-092",
    "familyId": "oma8-en-092"
  },
  {
    "section": "8.2.4.11",
    "manualPage": "8.2-29",
    "pdfPage": 131,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "2 When anti-icing using the one-step procedure, a minimum quantity of 1 litre/m2 (~2 gal./100 sq.",
    "sourceQuote": "2 When anti-icing using the one-step procedure, a minimum quantity of 1 litre/m2 (~2 gal./100 sq.",
    "sourceRects": [
      [
        105.84,
        738.23,
        546.03,
        749.23
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-093",
    "familyId": "oma8-en-093"
  },
  {
    "section": "8.2.2.1.3",
    "manualPage": "8.2-4",
    "pdfPage": 106,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "The marshaller must stand clear of other staff and maintain visual contact with the Commander at all times during taxi approach.",
    "sourceQuote": "The marshaller must stand clear of other staff and maintain visual contact with the Commander at all times during taxi approach.",
    "sourceRects": [
      [
        77.48,
        110.26,
        524.32,
        121.26
      ],
      [
        77.48,
        123.26,
        524.4,
        134.26
      ],
      [
        77.48,
        136.26,
        440.93,
        147.26
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-094",
    "familyId": "oma8-en-094"
  },
  {
    "section": "8.2.2.1.3",
    "manualPage": "8.2-5",
    "pdfPage": 107,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "After fueling is completed, ground personnel shall make a walk around the fuel truck to make sure that fuel hoses are NOT attached to the aircraft.",
    "sourceQuote": "After fueling is completed, ground personnel shall make a walk around the fuel truck to make sure that fuel hoses are NOT attached to the aircraft.",
    "sourceRects": [
      [
        105.82,
        110.26,
        552.67,
        121.26
      ],
      [
        105.82,
        123.26,
        552.62,
        134.26
      ],
      [
        105.82,
        136.26,
        398.72,
        147.26
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-095",
    "familyId": "oma8-en-095"
  },
  {
    "section": "8.2.2.6.5",
    "manualPage": "8.2-10",
    "pdfPage": 112,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "When required, the position(s) shall also be disinfected, using an approved disinfectant Complete disinfection is required after any aircraft, on which animals were carried, returns to GYD.",
    "sourceQuote": "When required, the position(s) shall also be disinfected, using an approved disinfectant Complete disinfection is required after any aircraft, on which animals were carried, returns to GYD.",
    "sourceRects": [
      [
        77.48,
        438.26,
        459.72,
        449.26
      ],
      [
        77.48,
        457.25,
        517.01,
        468.25
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-096",
    "familyId": "oma8-en-096"
  },
  {
    "section": "8.2.2.6.8",
    "manualPage": "8.2-14",
    "pdfPage": 116,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "NOTE: The maximum area load in a certain aircraft floor area, divided by the maximum running load in that area, provides the maximum transverse (lateral) linear load, which it is in some instances also necessary to use in shoring calculations.",
    "sourceQuote": "NOTE: The maximum area load in a certain aircraft floor area, divided by the maximum running load in that area, provides the maximum transverse (lateral) linear load, which it is in some instances also necessary to use in shoring calculations.",
    "sourceRects": [
      [
        77.48,
        595.29,
        524.33,
        606.52
      ],
      [
        77.48,
        608.3,
        524.3,
        619.3
      ],
      [
        77.48,
        621.3,
        274.14,
        632.3
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-097",
    "familyId": "oma8-en-097"
  },
  {
    "section": "8.2.2.6.8",
    "manualPage": "8.2-19",
    "pdfPage": 121,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "NOTE: In such a case, the minimum required stiffness of the free span cross members vs the maximum transverse linear load can be calculated using the same general equations and calculation steps.",
    "sourceQuote": "NOTE: In such a case, the minimum required stiffness of the free span cross members vs the maximum transverse linear load can be calculated using the same general equations and calculation steps.",
    "sourceRects": [
      [
        105.82,
        277.12,
        552.71,
        288.12
      ],
      [
        105.82,
        289.89,
        548.48,
        300.89
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-098",
    "familyId": "oma8-en-098"
  },
  {
    "section": "8.2.4.1",
    "manualPage": "8.2-24",
    "pdfPage": 126,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "If both de-icing and antiicing is required, the procedure may be performed in one or two steps.",
    "sourceQuote": "If both de-icing and antiicing is required, the procedure may be performed in one or two steps.",
    "sourceRects": [
      [
        77.48,
        204.25,
        524.37,
        215.25
      ],
      [
        77.48,
        217.26,
        524.41,
        228.26
      ],
      [
        77.48,
        230.26,
        524.33,
        241.26
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-099",
    "familyId": "oma8-en-099"
  },
  {
    "section": "8.2.4.1",
    "manualPage": "8.2-24",
    "pdfPage": 126,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "To comply with the clean airplane concept, operators must use deicing/anti-icing fluids that have holdover times long enough to permit safe winter operations during ground icing conditions and acceptable aerodynamic characteristics.",
    "sourceQuote": "To comply with the clean airplane concept, operators must use deicing/anti-icing fluids that have holdover times long enough to permit safe winter operations during ground icing conditions and acceptable aerodynamic characteristics.",
    "sourceRects": [
      [
        77.48,
        565.27,
        524.43,
        576.27
      ],
      [
        77.48,
        578.28,
        524.33,
        589.28
      ],
      [
        77.48,
        591.28,
        251.59,
        602.28
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-100",
    "familyId": "oma8-en-100"
  },
  {
    "section": "8.2.4.6",
    "manualPage": "8.2-27",
    "pdfPage": 129,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: de/anti-icing fluid type",
    "choices": [
      "Type II",
      "Type I",
      "Type III",
      "Type IV"
    ],
    "correctIndex": 0,
    "explanation": "Unheated Type II or IV fluid, pure or mixed (50%) with water, should be used For effective anti-icing, an even layer of sufficient thickness of fluids is required over the surfaces, which are clean of frozen deposits.",
    "sourceQuote": "Unheated Type II or IV fluid, pure or mixed (50%) with water, should be used For effective anti-icing, an even layer of sufficient thickness of fluids is required over the surfaces, which are clean of frozen deposits.",
    "sourceRects": [
      [
        105.84,
        355.48,
        543.34,
        366.48
      ],
      [
        105.84,
        385.49,
        550.09,
        396.49
      ],
      [
        121.86,
        400.26,
        311.19,
        411.26
      ],
      [
        105.84,
        421.26,
        552.81,
        432.26
      ],
      [
        105.84,
        434.26,
        552.77,
        445.26
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-101",
    "familyId": "oma8-en-101"
  },
  {
    "section": "8.2.4.7",
    "manualPage": "8.2-27",
    "pdfPage": 129,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "De-icing/anti-icing fluids shall not be sprayed directly on wiring harnesses and electrical components, onto brakes, wheels, exhausts or thrust reversers.",
    "sourceQuote": "De-icing/anti-icing fluids shall not be sprayed directly on wiring harnesses and electrical components, onto brakes, wheels, exhausts or thrust reversers.",
    "sourceRects": [
      [
        105.85,
        716.27,
        552.83,
        727.27
      ],
      [
        105.85,
        729.27,
        320.99,
        740.27
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-102",
    "familyId": "oma8-en-102"
  },
  {
    "section": "8.2.4.11",
    "manualPage": "8.2-45",
    "pdfPage": 147,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: reported parameter",
    "choices": [
      "visibility",
      "RVR",
      "ceiling",
      "wind"
    ],
    "correctIndex": 0,
    "explanation": "The use of Runway Visual Range (RVR) is not permitted for determining visibility used with the holdover tables.",
    "sourceQuote": "The use of Runway Visual Range (RVR) is not permitted for determining visibility used with the holdover tables.",
    "sourceRects": [
      [
        105.83,
        704.08,
        546.96,
        715.08
      ],
      [
        121.85,
        718.85,
        192.04,
        729.85
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-103",
    "familyId": "oma8-en-103"
  },
  {
    "section": "8.2.2.6.5",
    "manualPage": "8.2-10",
    "pdfPage": 112,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "The attendants may, with the permission of the Commander have access to the animals during flight except during taxi, take-off and landing.",
    "sourceQuote": "The attendants may, with the permission of the Commander have access to the animals during flight except during taxi, take-off and landing.",
    "sourceRects": [
      [
        77.48,
        142.26,
        524.28,
        153.26
      ],
      [
        77.48,
        155.26,
        524.32,
        166.26
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-104",
    "familyId": "oma8-en-104"
  },
  {
    "section": "8.2.2.6.9",
    "manualPage": "8.2-21",
    "pdfPage": 123,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Intermodal containers nominally sized at [VALUE] long, 8 feet wide and 8.5 feet tall must be concentrically loaded on a pallet and restrained to the aircraft in accordance with the Weight and Balance Manual.",
    "choices": [
      "20 feet",
      "50 feet",
      "100 feet",
      "200 feet"
    ],
    "correctIndex": 0,
    "explanation": "Intermodal containers nominally sized at 20 feet long, 8 feet wide and 8.5 feet tall must be concentrically loaded on a pallet and restrained to the aircraft in accordance with the Weight and Balance Manual.",
    "sourceQuote": "Intermodal containers nominally sized at 20 feet long, 8 feet wide and 8.5 feet tall must be concentrically loaded on a pallet and restrained to the aircraft in accordance with the Weight and Balance Manual.",
    "sourceRects": [
      [
        105.82,
        392.89,
        552.71,
        403.89
      ],
      [
        105.82,
        405.9,
        552.71,
        416.9
      ],
      [
        105.82,
        418.9,
        552.67,
        429.9
      ],
      [
        105.82,
        431.9,
        323.37,
        442.9
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-105",
    "familyId": "oma8-en-105"
  },
  {
    "section": "8.2.2.8.1",
    "manualPage": "8.2-23",
    "pdfPage": 125,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Complete passport information for each supernumerary shall be forwarded to the destination/departure station [VALUE] in advance of the flight.",
    "choices": [
      "not less than 72 hours",
      "not less than 48 hours",
      "not less than 36 hours",
      "not less than 24 hours"
    ],
    "correctIndex": 0,
    "explanation": "Complete passport information for each supernumerary shall be forwarded to the destination/departure station not less than 72 hours in advance of the flight.",
    "sourceQuote": "Complete passport information for each supernumerary shall be forwarded to the destination/departure station not less than 72 hours in advance of the flight.",
    "sourceRects": [
      [
        105.82,
        304.27,
        552.71,
        315.27
      ],
      [
        105.82,
        317.27,
        360.8,
        328.27
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-106",
    "familyId": "oma8-en-106"
  },
  {
    "section": "8.2.4.1",
    "manualPage": "8.2-24",
    "pdfPage": 126,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "A clean aircraft may require anti-icing only, however, the continual repeated use of cold anti-icing only should be avoided.",
    "sourceQuote": "A clean aircraft may require anti-icing only, however, the continual repeated use of cold anti-icing only should be avoided.",
    "sourceRects": [
      [
        77.48,
        320.49,
        524.38,
        331.49
      ],
      [
        77.48,
        333.26,
        524.37,
        344.26
      ],
      [
        77.48,
        346.26,
        524.43,
        357.26
      ],
      [
        77.48,
        359.27,
        115.03,
        370.27
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-107",
    "familyId": "oma8-en-107"
  },
  {
    "section": "8.2.4.11",
    "manualPage": "8.2-30",
    "pdfPage": 132,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: When conducting aircraft deicing using a Type I fluid and not using the [VALUE]/18 °F buffer, procedures must be developed and approved to ensure refreezing does not occur prior to takeoff.",
    "choices": [
      "10 °C",
      "5 °C",
      "15 °C",
      "20 °C"
    ],
    "correctIndex": 0,
    "explanation": "When conducting aircraft deicing using a Type I fluid and not using the 10 °C/18 °F buffer, procedures must be developed and approved to ensure refreezing does not occur prior to takeoff.",
    "sourceQuote": "When conducting aircraft deicing using a Type I fluid and not using the 10 °C/18 °F buffer, procedures must be developed and approved to ensure refreezing does not occur prior to takeoff.",
    "sourceRects": [
      [
        77.48,
        487.34,
        524.36,
        498.57
      ],
      [
        93.49,
        502.34,
        493.19,
        513.34
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-108",
    "familyId": "oma8-en-108"
  },
  {
    "section": "8.2.4.11",
    "manualPage": "8.2-33",
    "pdfPage": 135,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: 2 Type I Fluid / Water Mixture must be selected so that the freezing point of the mixture is [VALUE] (18 °F) below outside air temperature.",
    "choices": [
      "at least 10 °C",
      "at least 5 °C",
      "at least 15 °C",
      "at least 20 °C"
    ],
    "correctIndex": 0,
    "explanation": "2 Type I Fluid / Water Mixture must be selected so that the freezing point of the mixture is at least 10 °C (18 °F) below outside air temperature.",
    "sourceQuote": "2 Type I Fluid / Water Mixture must be selected so that the freezing point of the mixture is at least 10 °C (18 °F) below outside air temperature.",
    "sourceRects": [
      [
        105.82,
        687.52,
        544.4,
        698.52
      ],
      [
        121.84,
        700.29,
        317.78,
        711.29
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-109",
    "familyId": "oma8-en-109"
  },
  {
    "section": "8.2.4.11",
    "manualPage": "8.2-34",
    "pdfPage": 136,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: NOTES 1 Type I fluid / water mixture must be selected so that the freezing point of the mixture is [VALUE] (18 °F) below outside air temperature.",
    "choices": [
      "at least 10 °C",
      "at least 5 °C",
      "at least 15 °C",
      "at least 20 °C"
    ],
    "correctIndex": 0,
    "explanation": "NOTES 1 Type I fluid / water mixture must be selected so that the freezing point of the mixture is at least 10 °C (18 °F) below outside air temperature.",
    "sourceQuote": "NOTES 1 Type I fluid / water mixture must be selected so that the freezing point of the mixture is at least 10 °C (18 °F) below outside air temperature.",
    "sourceRects": [
      [
        77.48,
        602.84,
        114.79,
        613.84
      ],
      [
        77.48,
        615.84,
        521.62,
        626.84
      ],
      [
        93.49,
        628.61,
        275.76,
        639.61
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-110",
    "familyId": "oma8-en-110"
  },
  {
    "section": "8.2.4.11",
    "manualPage": "8.2-40",
    "pdfPage": 142,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: The OAT must not decrease during the [VALUE] to use this guidance in conditions of light ice pellets mixed with either: light freezing drizzle, moderate freezing drizzle, light freezing rain, or light rain.",
    "choices": [
      "90 minutes",
      "60 minutes",
      "120 minutes",
      "45 minutes"
    ],
    "correctIndex": 0,
    "explanation": "The OAT must not decrease during the 90 minutes to use this guidance in conditions of light ice pellets mixed with either: light freezing drizzle, moderate freezing drizzle, light freezing rain, or light rain.",
    "sourceQuote": "The OAT must not decrease during the 90 minutes to use this guidance in conditions of light ice pellets mixed with either: light freezing drizzle, moderate freezing drizzle, light freezing rain, or light rain.",
    "sourceRects": [
      [
        77.48,
        562.78,
        514.5,
        573.78
      ],
      [
        93.49,
        575.55,
        519.22,
        586.55
      ],
      [
        93.49,
        588.55,
        524.36,
        599.55
      ],
      [
        93.49,
        601.55,
        368.39,
        612.55
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-111",
    "familyId": "oma8-en-111"
  },
  {
    "section": "8.2.1.4",
    "manualPage": "8.2-2",
    "pdfPage": 104,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "The crew, as appropriate, must brief supernumeraries onboard of required procedures in the event of an evacuation.",
    "sourceQuote": "The crew, as appropriate, must brief supernumeraries onboard of required procedures in the event of an evacuation.",
    "sourceRects": [
      [
        77.48,
        556.31,
        524.41,
        567.31
      ],
      [
        77.48,
        569.31,
        524.43,
        580.31
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-112",
    "familyId": "oma8-en-112"
  },
  {
    "section": "8.2.2.1.3",
    "manualPage": "8.2-4",
    "pdfPage": 106,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "Position of equipment Ground personnel shall check that there is sufficient fuel in case ground support equipment needs to be removed at short notice.",
    "sourceQuote": "Position of equipment Ground personnel shall check that there is sufficient fuel in case ground support equipment needs to be removed at short notice.",
    "sourceRects": [
      [
        77.48,
        449.26,
        174.37,
        460.26
      ],
      [
        77.48,
        468.26,
        524.32,
        479.26
      ],
      [
        77.48,
        481.26,
        524.43,
        492.26
      ],
      [
        77.48,
        494.26,
        524.42,
        505.26
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-113",
    "familyId": "oma8-en-113"
  },
  {
    "section": "8.2.2.1.3",
    "manualPage": "8.2-4",
    "pdfPage": 106,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "The fuel truck must be bonded to the main gear door by a cable.",
    "sourceQuote": "The fuel truck must be bonded to the main gear door by a cable.",
    "sourceRects": [
      [
        77.48,
        750.26,
        524.32,
        761.26
      ],
      [
        77.48,
        763.26,
        524.36,
        774.26
      ],
      [
        77.48,
        776.26,
        524.42,
        787.26
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-114",
    "familyId": "oma8-en-114"
  },
  {
    "section": "8.2.2.1.3",
    "manualPage": "8.2-5",
    "pdfPage": 107,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "When using a fuel truck it must be guided by marshallers to the fueling position in order to avoid aircraft damage.",
    "sourceQuote": "When using a fuel truck it must be guided by marshallers to the fueling position in order to avoid aircraft damage.",
    "sourceRects": [
      [
        105.82,
        110.26,
        552.67,
        121.26
      ],
      [
        105.82,
        123.26,
        552.62,
        134.26
      ],
      [
        105.82,
        136.26,
        398.72,
        147.26
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-115",
    "familyId": "oma8-en-115"
  },
  {
    "section": "8.2.2.2",
    "manualPage": "8.2-5",
    "pdfPage": 107,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "landing",
      "take-off",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "The last meters of aircraft movement must be in a straight line to reduce stress on the landing gear Marshalling signals will be given in a deliberate, positive manner without personal variations or interpretations.",
    "sourceQuote": "The last meters of aircraft movement must be in a straight line to reduce stress on the landing gear Marshalling signals will be given in a deliberate, positive manner without personal variations or interpretations.",
    "sourceRects": [
      [
        105.83,
        553.33,
        552.7,
        564.56
      ],
      [
        105.83,
        568.33,
        543.58,
        579.57
      ],
      [
        121.85,
        583.34,
        522.33,
        594.34
      ],
      [
        121.85,
        598.34,
        532.45,
        609.34
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-116",
    "familyId": "oma8-en-116"
  },
  {
    "section": "8.2.2.3",
    "manualPage": "8.2-6",
    "pdfPage": 108,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "landing",
      "take-off",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "The crew will shut down all engines and leave the APU running CAUTION Maintenance and other ground personnel and equipment must remain clear of the aircraft engines and landing gear until engines have been shut down and the anticollision beacon turned off.",
    "sourceQuote": "The crew will shut down all engines and leave the APU running CAUTION Maintenance and other ground personnel and equipment must remain clear of the aircraft engines and landing gear until engines have been shut down and the anticollision beacon turned off.",
    "sourceRects": [
      [
        77.48,
        110.49,
        500.22,
        121.49
      ],
      [
        93.49,
        125.26,
        248.75,
        136.26
      ],
      [
        77.48,
        140.5,
        517.73,
        151.5
      ],
      [
        133.18,
        155.5,
        513.87,
        166.5
      ],
      [
        133.18,
        170.51,
        260.01,
        181.51
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-117",
    "familyId": "oma8-en-117"
  },
  {
    "section": "8.2.2.6.2",
    "manualPage": "8.2-8",
    "pdfPage": 110,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: reported parameter",
    "choices": [
      "visibility",
      "RVR",
      "ceiling",
      "wind"
    ],
    "correctIndex": 0,
    "explanation": "Personnel meeting the aircraft must wear approved hearing protection and high visibility clothing.",
    "sourceQuote": "Personnel meeting the aircraft must wear approved hearing protection and high visibility clothing.",
    "sourceRects": [
      [
        77.48,
        123.26,
        524.32,
        134.26
      ],
      [
        77.48,
        136.26,
        199.02,
        147.26
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-118",
    "familyId": "oma8-en-118"
  },
  {
    "section": "8.2.2.6.5",
    "manualPage": "8.2-9",
    "pdfPage": 111,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "These kits may contain items listed as prohibited.",
    "sourceQuote": "These kits may contain items listed as prohibited.",
    "sourceRects": [
      [
        105.82,
        697.32,
        552.67,
        708.32
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-119",
    "familyId": "oma8-en-119"
  },
  {
    "section": "8.2.2.6.5",
    "manualPage": "8.2-10",
    "pdfPage": 112,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "The Commander shall ensure that the attendants are informed that smoking is absolutely forbidden in the cargo area.",
    "sourceQuote": "The Commander shall ensure that the attendants are informed that smoking is absolutely forbidden in the cargo area.",
    "sourceRects": [
      [
        77.48,
        206.26,
        524.32,
        217.26
      ],
      [
        77.48,
        219.26,
        141.66,
        230.26
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-120",
    "familyId": "oma8-en-120"
  },
  {
    "section": "8.2.2.6.5",
    "manualPage": "8.2-10",
    "pdfPage": 112,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "off",
      "ON",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "This is not required for the following animals unless a spillage has occurred: Domestic cats and dogs Reptiles and amphibians Aquatics Insects and bees Local cleaning is required immediately after the animals are offloaded.",
    "sourceQuote": "This is not required for the following animals unless a spillage has occurred: Domestic cats and dogs Reptiles and amphibians Aquatics Insects and bees Local cleaning is required immediately after the animals are offloaded.",
    "sourceRects": [
      [
        77.48,
        308.25,
        413.64,
        319.25
      ],
      [
        77.48,
        327.48,
        197.37,
        338.48
      ],
      [
        77.48,
        342.48,
        201.45,
        353.48
      ],
      [
        77.48,
        357.48,
        132.33,
        368.48
      ],
      [
        77.48,
        372.49,
        164.73,
        383.49
      ],
      [
        77.48,
        393.26,
        524.36,
        404.26
      ],
      [
        77.48,
        419.26,
        216.78,
        430.26
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-121",
    "familyId": "oma8-en-121"
  },
  {
    "section": "8.2.2.6.8",
    "manualPage": "8.2-14",
    "pdfPage": 116,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "Elementary shoring procedures such as using wooden pallets to enlarge cargo's footprint on the pallet should be considered first and are in many circumstances sufficient to ensure compliance with the maximum area load restriction.",
    "sourceQuote": "Elementary shoring procedures such as using wooden pallets to enlarge cargo's footprint on the pallet should be considered first and are in many circumstances sufficient to ensure compliance with the maximum area load restriction.",
    "sourceRects": [
      [
        77.48,
        376.28,
        524.28,
        387.28
      ],
      [
        77.48,
        389.29,
        524.42,
        400.29
      ],
      [
        77.48,
        402.29,
        524.32,
        413.29
      ],
      [
        77.48,
        415.29,
        411.89,
        426.29
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-122",
    "familyId": "oma8-en-122"
  },
  {
    "section": "8.2.2.6.8",
    "manualPage": "8.2-14",
    "pdfPage": 116,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "In very heavy or concentrated load cases, however, the study and implementation of a proper shoring arrangement may be required to meet it.",
    "sourceQuote": "In very heavy or concentrated load cases, however, the study and implementation of a proper shoring arrangement may be required to meet it.",
    "sourceRects": [
      [
        77.48,
        376.28,
        524.28,
        387.28
      ],
      [
        77.48,
        389.29,
        524.42,
        400.29
      ],
      [
        77.48,
        402.29,
        524.32,
        413.29
      ],
      [
        77.48,
        415.29,
        411.89,
        426.29
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-123",
    "familyId": "oma8-en-123"
  },
  {
    "section": "8.2.2.6.8",
    "manualPage": "8.2-16",
    "pdfPage": 118,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "Such elementary shoring may also be required on aluminum pallets: For concentrated loads likely to cause local bending of the aluminum sheet and result in difficulties to freely move over rollers, or to engage the aircraft's latches due to edge bending.",
    "sourceQuote": "Such elementary shoring may also be required on aluminum pallets: For concentrated loads likely to cause local bending of the aluminum sheet and result in difficulties to freely move over rollers, or to engage the aircraft's latches due to edge bending.",
    "sourceRects": [
      [
        77.48,
        384.51,
        376.68,
        395.51
      ],
      [
        77.48,
        402.52,
        518.35,
        414.74
      ],
      [
        93.49,
        418.51,
        514.85,
        429.51
      ],
      [
        93.49,
        433.52,
        521.62,
        444.52
      ],
      [
        93.49,
        448.52,
        133.99,
        459.52
      ],
      [
        77.48,
        463.76,
        514.26,
        474.76
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-124",
    "familyId": "oma8-en-124"
  },
  {
    "section": "8.2.2.6.8",
    "manualPage": "8.2-17",
    "pdfPage": 119,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "Accordingly, in such a case a calculation is required to determine the minimum shoring requirements.",
    "sourceQuote": "Accordingly, in such a case a calculation is required to determine the minimum shoring requirements.",
    "sourceRects": [
      [
        105.82,
        136.26,
        552.32,
        147.26
      ]
    ],
    "topic": "ground",
    "id": "oma8-en-125",
    "familyId": "oma8-en-125"
  },
  {
    "section": "8.3.7.2.1",
    "manualPage": "8.3-88",
    "pdfPage": 252,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "The Commander shall ensure that in all phases of flight at least the following fuel quantities are remaining on board: Trip Fuel for the remaining portion of flight + Alternate Fuel (if required) + Final Reserve Fuel.",
    "sourceQuote": "The Commander shall ensure that in all phases of flight at least the following fuel quantities are remaining on board: Trip Fuel for the remaining portion of flight + Alternate Fuel (if required) + Final Reserve Fuel.",
    "sourceRects": [
      [
        77.48,
        443.26,
        524.28,
        454.26
      ],
      [
        77.48,
        456.26,
        343.08,
        467.26
      ],
      [
        77.48,
        475.26,
        498.05,
        486.26
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-126",
    "familyId": "oma8-en-126"
  },
  {
    "section": "8.3.7.1",
    "manualPage": "8.3-88",
    "pdfPage": 252,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "Fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "Enroute Fuel Alternate (ERF) Suitable airport which must be planned if the amount of route reserve fuel is reduced from 5% to 3% of planned trip fuel (For location of enroute fuel alternate refer to paragraph 8.1.7.1.3).",
    "sourceQuote": "Enroute Fuel Alternate (ERF) Suitable airport which must be planned if the amount of route reserve fuel is reduced from 5% to 3% of planned trip fuel (For location of enroute fuel alternate refer to paragraph 8.1.7.1.3).",
    "sourceRects": [
      [
        77.48,
        302.26,
        207.62,
        313.26
      ],
      [
        77.48,
        321.26,
        524.38,
        332.26
      ],
      [
        77.48,
        334.26,
        458.69,
        345.26
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-127",
    "familyId": "oma8-en-127"
  },
  {
    "section": "8.3.7.2.1",
    "manualPage": "8.3-88",
    "pdfPage": 252,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "The Commander shall declare an emergency \"MAYDAY, MAYDAY, MAYDAY FUEL\" when calculated usable fuel on landing, at the nearest adequate airport where a safe landing can be performed, is less than Final Reserve fuel.",
    "sourceQuote": "The Commander shall declare an emergency \"MAYDAY, MAYDAY, MAYDAY FUEL\" when calculated usable fuel on landing, at the nearest adequate airport where a safe landing can be performed, is less than Final Reserve fuel.",
    "sourceRects": [
      [
        77.48,
        688.28,
        524.36,
        699.28
      ],
      [
        77.48,
        701.28,
        524.3,
        712.28
      ],
      [
        77.48,
        714.28,
        201.66,
        725.28
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-128",
    "familyId": "oma8-en-128"
  },
  {
    "section": "8.3.7.3",
    "manualPage": "8.3-90",
    "pdfPage": 254,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "landing",
      "take-off",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Exceptions: If the forecast weather is below applicable minimum but the actual weather indicates a reasonable chance for a landing, replanning may be based on the actual reported visibility/RVR.",
    "sourceQuote": "Exceptions: If the forecast weather is below applicable minimum but the actual weather indicates a reasonable chance for a landing, replanning may be based on the actual reported visibility/RVR.",
    "sourceRects": [
      [
        77.48,
        689.71,
        524.43,
        700.71
      ],
      [
        77.48,
        702.71,
        505.5,
        713.71
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-129",
    "familyId": "oma8-en-129"
  },
  {
    "section": "8.3.8.2.3",
    "manualPage": "8.3-94",
    "pdfPage": 258,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "The Commander shall further make sure that the airplane has been treated with de-icing/anti-icing fluid as necessary with regard to actual weather conditions.",
    "sourceQuote": "The Commander shall further make sure that the airplane has been treated with de-icing/anti-icing fluid as necessary with regard to actual weather conditions.",
    "sourceRects": [
      [
        77.48,
        522.26,
        524.21,
        533.26
      ],
      [
        77.48,
        535.26,
        524.43,
        546.26
      ],
      [
        77.48,
        547.27,
        524.36,
        559.26
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-130",
    "familyId": "oma8-en-130"
  },
  {
    "section": "8.3.12",
    "manualPage": "8.3-113",
    "pdfPage": 277,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Flight crew",
      "Commander",
      "First Officer",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "Flight crew During take-off and landing, and whenever the Commander considers it necessary in the interest of safety, crew members shall be at their assigned crew stations, properly secured by the safety belts and shoulder harnesses.",
    "sourceQuote": "Flight crew During take-off and landing, and whenever the Commander considers it necessary in the interest of safety, crew members shall be at their assigned crew stations, properly secured by the safety belts and shoulder harnesses.",
    "sourceRects": [
      [
        105.86,
        393.28,
        156.28,
        404.28
      ],
      [
        105.82,
        412.26,
        552.75,
        423.26
      ],
      [
        105.82,
        425.26,
        552.67,
        436.26
      ],
      [
        105.82,
        438.26,
        191.13,
        449.26
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-131",
    "familyId": "oma8-en-131"
  },
  {
    "section": "8.3.16.3",
    "manualPage": "8.3-117",
    "pdfPage": 281,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "Prior to each visit to the cargo area, the Commander shall brief the supernumerarie(s) on the procedure to be used.In case of minimum crew, the maximum time allowed in the cargo area shall be agreed on.",
    "sourceQuote": "Prior to each visit to the cargo area, the Commander shall brief the supernumerarie(s) on the procedure to be used.In case of minimum crew, the maximum time allowed in the cargo area shall be agreed on.",
    "sourceRects": [
      [
        105.83,
        201.26,
        552.72,
        212.26
      ],
      [
        105.83,
        214.26,
        552.68,
        225.26
      ],
      [
        105.83,
        227.26,
        119.62,
        238.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-132",
    "familyId": "oma8-en-132"
  },
  {
    "section": "8.3.8.2.2",
    "manualPage": "8.3-94",
    "pdfPage": 258,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "Fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "The result of such ice is loss of power and, if no de-icing is used, surge and stall of the compressor may occur; Fuel icing Jet fuel contains small amounts of water which are liable to freeze in the fine mesh of the fuel filters.",
    "sourceQuote": "The result of such ice is loss of power and, if no de-icing is used, surge and stall of the compressor may occur; Fuel icing Jet fuel contains small amounts of water which are liable to freeze in the fine mesh of the fuel filters.",
    "sourceRects": [
      [
        93.49,
        401.32,
        521.7,
        412.32
      ],
      [
        93.49,
        416.32,
        142.39,
        427.32
      ],
      [
        77.47,
        431.56,
        521.46,
        442.56
      ],
      [
        93.49,
        448.32,
        520.63,
        459.32
      ],
      [
        93.49,
        463.26,
        307.65,
        474.26
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-133",
    "familyId": "oma8-en-133"
  },
  {
    "section": "8.3.2.2.1",
    "manualPage": "8.3-4",
    "pdfPage": 168,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Because the final approach course is not aligned with the runway centerline, additional maneuvering will be required compared to an ILS approach.",
    "sourceQuote": "Because the final approach course is not aligned with the runway centerline, additional maneuvering will be required compared to an ILS approach.",
    "sourceRects": [
      [
        77.48,
        671.27,
        524.32,
        682.27
      ],
      [
        77.48,
        684.28,
        524.36,
        695.28
      ],
      [
        77.48,
        697.28,
        422.94,
        708.28
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-134",
    "familyId": "oma8-en-134"
  },
  {
    "section": "8.3.2.4.3",
    "manualPage": "8.3-15",
    "pdfPage": 179,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "Such an arrangement may meet track-keeping parameters but does not provide the required redundancy should the FMCS fail, therefore, to obtain/maintain NAT HLA certification, dual FMCS shall be carried.",
    "sourceQuote": "Such an arrangement may meet track-keeping parameters but does not provide the required redundancy should the FMCS fail, therefore, to obtain/maintain NAT HLA certification, dual FMCS shall be carried.",
    "sourceRects": [
      [
        105.82,
        674.27,
        552.63,
        685.27
      ],
      [
        105.82,
        687.27,
        552.71,
        698.27
      ],
      [
        105.82,
        700.27,
        442.88,
        711.27
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-135",
    "familyId": "oma8-en-135"
  },
  {
    "section": "8.3.2.4.18",
    "manualPage": "8.3-35",
    "pdfPage": 199,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "A rapid response may be obtained by requesting a weather deviation using a CPDLC downlink message or stating \"WEATHER DEVIATION REQUIRED\" to indicate that priority is desired on the frequency and for ATC response.",
    "sourceQuote": "A rapid response may be obtained by requesting a weather deviation using a CPDLC downlink message or stating \"WEATHER DEVIATION REQUIRED\" to indicate that priority is desired on the frequency and for ATC response.",
    "sourceRects": [
      [
        105.82,
        617.3,
        552.66,
        628.3
      ],
      [
        105.82,
        630.31,
        552.75,
        641.31
      ],
      [
        105.82,
        643.31,
        552.67,
        654.31
      ],
      [
        105.82,
        656.31,
        552.58,
        667.31
      ],
      [
        105.82,
        669.31,
        511.75,
        680.31
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-136",
    "familyId": "oma8-en-136"
  },
  {
    "section": "8.3.2.4.23",
    "manualPage": "8.3-41",
    "pdfPage": 205,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "flight crew",
      "Commander",
      "First Officer",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "The flight crew must operate with caution and not automatically assume that the freezing point of the uplifted fuel is the actual freezing point of the fuel on board.",
    "sourceQuote": "The flight crew must operate with caution and not automatically assume that the freezing point of the uplifted fuel is the actual freezing point of the fuel on board.",
    "sourceRects": [
      [
        105.82,
        580.28,
        552.71,
        591.28
      ],
      [
        105.82,
        593.28,
        552.77,
        604.28
      ],
      [
        105.82,
        606.28,
        552.62,
        617.28
      ],
      [
        105.82,
        619.28,
        552.8,
        630.28
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-137",
    "familyId": "oma8-en-137"
  },
  {
    "section": "8.3.2.5.5",
    "manualPage": "8.3-52",
    "pdfPage": 216,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "flight crew",
      "Commander",
      "First Officer",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "Route modifications in the terminal area may take the form of radar headings or 'direct to' clearances and the flight crew must be capable of reacting in a timely fashion.This may include the insertion of tactical waypoints loaded from the database.",
    "sourceQuote": "Route modifications in the terminal area may take the form of radar headings or 'direct to' clearances and the flight crew must be capable of reacting in a timely fashion.This may include the insertion of tactical waypoints loaded from the database.",
    "sourceRects": [
      [
        77.48,
        349.28,
        515.2,
        360.28
      ],
      [
        77.48,
        364.28,
        521.88,
        375.28
      ],
      [
        77.48,
        379.28,
        521.68,
        390.28
      ],
      [
        77.48,
        394.29,
        507.28,
        405.29
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-138",
    "familyId": "oma8-en-138"
  },
  {
    "section": "8.3.6.1",
    "manualPage": "8.3-86",
    "pdfPage": 250,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "Pilots must be aware of the limitations of the particular equipment, as the full range of TAs and RAs may not be produced beyond the minimum and maximum altitudes specified for its operation.",
    "sourceQuote": "Pilots must be aware of the limitations of the particular equipment, as the full range of TAs and RAs may not be produced beyond the minimum and maximum altitudes specified for its operation.",
    "sourceRects": [
      [
        77.48,
        194.27,
        524.32,
        205.27
      ],
      [
        77.48,
        207.27,
        512.93,
        218.27
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-139",
    "familyId": "oma8-en-139"
  },
  {
    "section": "8.3.7.3",
    "manualPage": "8.3-91",
    "pdfPage": 255,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "Final Reserve fuel Required Meteorological Conditions Destination forecast at least \"OPEN 5\" (for definition refer to paragraph 8.1.6.2.2) covering a validity period required.",
    "sourceQuote": "Final Reserve fuel Required Meteorological Conditions Destination forecast at least \"OPEN 5\" (for definition refer to paragraph 8.1.6.2.2) covering a validity period required.",
    "sourceRects": [
      [
        105.82,
        225.51,
        202.41,
        236.51
      ],
      [
        105.82,
        246.27,
        266.82,
        257.27
      ],
      [
        105.82,
        265.27,
        552.67,
        276.27
      ],
      [
        105.82,
        277.28,
        552.71,
        289.27
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-140",
    "familyId": "oma8-en-140"
  },
  {
    "section": "8.3.8.7.1",
    "manualPage": "8.3-99",
    "pdfPage": 263,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "Commander shall report the runway braking action special air-report (AIREP) when the runway braking action encoutered is not as good as reported.",
    "sourceQuote": "Commander shall report the runway braking action special air-report (AIREP) when the runway braking action encoutered is not as good as reported.",
    "sourceRects": [
      [
        105.82,
        238.27,
        552.71,
        249.27
      ],
      [
        105.82,
        251.27,
        317.85,
        262.27
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-141",
    "familyId": "oma8-en-141"
  },
  {
    "section": "8.3.8.7.2",
    "manualPage": "8.3-101",
    "pdfPage": 265,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "Where some sections of the runway, or sections of a runway third, are not contaminated, the reported runway contaminants are not required to add up to 100%.",
    "sourceQuote": "Where some sections of the runway, or sections of a runway third, are not contaminated, the reported runway contaminants are not required to add up to 100%.",
    "sourceRects": [
      [
        105.82,
        720.28,
        552.67,
        731.28
      ],
      [
        105.82,
        733.28,
        358.4,
        744.28
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-142",
    "familyId": "oma8-en-142"
  },
  {
    "section": "8.3.8.11",
    "manualPage": "8.3-105",
    "pdfPage": 269,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "landing",
      "take-off",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Similarly if the airplane is operating to a maximum landing weight limited by go-around climb performance considerations, the required gradient may not be achieved.",
    "sourceQuote": "Similarly if the airplane is operating to a maximum landing weight limited by go-around climb performance considerations, the required gradient may not be achieved.",
    "sourceRects": [
      [
        105.85,
        666.27,
        552.79,
        677.27
      ],
      [
        105.85,
        679.27,
        552.73,
        690.27
      ],
      [
        105.85,
        692.27,
        215.39,
        703.27
      ]
    ],
    "topic": "mass-balance",
    "id": "oma8-en-143",
    "familyId": "oma8-en-143"
  },
  {
    "section": "8.3.8.12",
    "manualPage": "8.3-106",
    "pdfPage": 270,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "1 Supplemental Procedures, bearing in mind that extra fuel may be required to carry out the recommended procedures to keep fuel temperatures above limits.",
    "sourceQuote": "1 Supplemental Procedures, bearing in mind that extra fuel may be required to carry out the recommended procedures to keep fuel temperatures above limits.",
    "sourceRects": [
      [
        77.48,
        194.27,
        524.33,
        205.27
      ],
      [
        77.48,
        207.27,
        524.41,
        218.27
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-144",
    "familyId": "oma8-en-144"
  },
  {
    "section": "8.3.2.5.1",
    "manualPage": "8.3-44",
    "pdfPage": 208,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Planned for CAT III Precision Approach and Landing including 0.003/z +/[VALUE] (+/z feet) touchdown, landing roll and take-off roll requirements.",
    "choices": [
      "0.003 NM",
      "1 NM",
      "2 NM",
      "3 NM"
    ],
    "correctIndex": 0,
    "explanation": "Planned for CAT III Precision Approach and Landing including 0.003/z +/0.003 NM (+/z feet) touchdown, landing roll and take-off roll requirements.",
    "sourceQuote": "Planned for CAT III Precision Approach and Landing including 0.003/z +/0.003 NM (+/z feet) touchdown, landing roll and take-off roll requirements.",
    "sourceRects": [
      [
        272.29,
        213.78,
        499.11,
        222.78
      ],
      [
        93.56,
        224.78,
        511.35,
        233.78
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-145",
    "familyId": "oma8-en-145"
  },
  {
    "section": "8.3.2.4.7",
    "manualPage": "8.3-21",
    "pdfPage": 185,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "cruise",
      "take-off",
      "landing",
      "approach"
    ],
    "correctIndex": 0,
    "explanation": "Climb/descent through RVSM levels NAT HLA MNPS approved but NON-RVSM approved aircraft may be cleared, subject to traffic, to climb/ descend through RVSM levels to cruise at levels above or below RVSM Airspace.",
    "sourceQuote": "Climb/descent through RVSM levels NAT HLA MNPS approved but NON-RVSM approved aircraft may be cleared, subject to traffic, to climb/ descend through RVSM levels to cruise at levels above or below RVSM Airspace.",
    "sourceRects": [
      [
        105.82,
        174.49,
        276.42,
        185.49
      ],
      [
        105.82,
        193.25,
        552.67,
        204.25
      ],
      [
        105.82,
        206.26,
        552.63,
        217.26
      ],
      [
        105.82,
        219.26,
        552.62,
        230.26
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-146",
    "familyId": "oma8-en-146"
  },
  {
    "section": "8.3.2.4.11",
    "manualPage": "8.3-28",
    "pdfPage": 192,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: If oceanic clearance is not required prior to departure, pilots are reminded that they should request clearance between 90 and [VALUE] prior to the Shanwick boundary.",
    "choices": [
      "30 minutes",
      "20 minutes",
      "15 minutes",
      "45 minutes"
    ],
    "correctIndex": 0,
    "explanation": "If oceanic clearance is not required prior to departure, pilots are reminded that they should request clearance between 90 and 30 minutes prior to the Shanwick boundary.",
    "sourceQuote": "If oceanic clearance is not required prior to departure, pilots are reminded that they should request clearance between 90 and 30 minutes prior to the Shanwick boundary.",
    "sourceRects": [
      [
        77.48,
        649.26,
        524.28,
        660.26
      ],
      [
        77.48,
        662.26,
        524.42,
        673.26
      ],
      [
        77.48,
        675.26,
        524.43,
        686.26
      ],
      [
        77.48,
        688.27,
        524.32,
        699.27
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-147",
    "familyId": "oma8-en-147"
  },
  {
    "section": "8.3.2.4.23",
    "manualPage": "8.3-41",
    "pdfPage": 205,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Data show that the freezing point of delivered Jet A fuel is [VALUE] lower than the specification maximum of -40°C.",
    "choices": [
      "approximately 3°C",
      "approximately 2°C",
      "approximately 4°C",
      "approximately 5°C"
    ],
    "correctIndex": 0,
    "explanation": "Data show that the freezing point of delivered Jet A fuel is approximately 3°C lower than the specification maximum of -40°C.",
    "sourceQuote": "Data show that the freezing point of delivered Jet A fuel is approximately 3°C lower than the specification maximum of -40°C.",
    "sourceRects": [
      [
        105.82,
        334.27,
        552.71,
        346.26
      ],
      [
        105.82,
        348.27,
        223.77,
        359.27
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-148",
    "familyId": "oma8-en-148"
  },
  {
    "section": "8.3.2.5.7",
    "manualPage": "8.3-55",
    "pdfPage": 219,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: The crew must check the RNAV approach mode annunciator (or equivalent) is properly indicating approachmode integrity [VALUE] before the FAF.",
    "choices": [
      "2 NM",
      "1 NM",
      "3 NM",
      "5 NM"
    ],
    "correctIndex": 0,
    "explanation": "The crew must check the RNAV approach mode annunciator (or equivalent) is properly indicating approachmode integrity 2 NM before the FAF.",
    "sourceQuote": "The crew must check the RNAV approach mode annunciator (or equivalent) is properly indicating approachmode integrity 2 NM before the FAF.",
    "sourceRects": [
      [
        105.82,
        285.28,
        552.67,
        296.28
      ],
      [
        105.82,
        298.28,
        316.41,
        309.28
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-149",
    "familyId": "oma8-en-149"
  },
  {
    "section": "8.3.2.10.1",
    "manualPage": "8.3-79",
    "pdfPage": 243,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: RVSM refers to a separation [VALUE] in the vertical dimension between FL 290 and FL 410 instead of the conventional 2000 feet vertical separation.",
    "choices": [
      "minimum of 1000 feet",
      "minimum of 700 feet",
      "minimum of 500 feet",
      "minimum of 1500 feet"
    ],
    "correctIndex": 0,
    "explanation": "RVSM refers to a separation minimum of 1000 feet in the vertical dimension between FL 290 and FL 410 instead of the conventional 2000 feet vertical separation.",
    "sourceQuote": "RVSM refers to a separation minimum of 1000 feet in the vertical dimension between FL 290 and FL 410 instead of the conventional 2000 feet vertical separation.",
    "sourceRects": [
      [
        105.82,
        148.25,
        552.68,
        159.25
      ],
      [
        105.82,
        161.26,
        552.77,
        172.26
      ],
      [
        105.82,
        187.26,
        552.62,
        198.26
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-150",
    "familyId": "oma8-en-150"
  },
  {
    "section": "8.3.7.1",
    "manualPage": "8.3-87",
    "pdfPage": 251,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "landing",
      "take-off",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "The policy is to plan fuel and weatherwise with the availability of at least two landing possibilities (i.e. destination and alternate or destination with one other landing possibility) should be maintained as long as possible during flight.",
    "sourceQuote": "The policy is to plan fuel and weatherwise with the availability of at least two landing possibilities (i.e. destination and alternate or destination with one other landing possibility) should be maintained as long as possible during flight.",
    "sourceRects": [
      [
        105.84,
        358.36,
        552.77,
        369.36
      ],
      [
        105.84,
        370.37,
        552.73,
        382.36
      ],
      [
        105.84,
        384.37,
        552.79,
        395.37
      ],
      [
        105.84,
        397.37,
        300.1,
        408.37
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-151",
    "familyId": "oma8-en-151"
  },
  {
    "section": "8.3.7.2.2",
    "manualPage": "8.3-89",
    "pdfPage": 253,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "Weather deterioration Enroute Alternate (ERA): The weather at the Enroute Alternate (ERA) may decrease below applicable minima.",
    "sourceQuote": "Weather deterioration Enroute Alternate (ERA): The weather at the Enroute Alternate (ERA) may decrease below applicable minima.",
    "sourceRects": [
      [
        105.82,
        168.26,
        201.08,
        179.26
      ],
      [
        105.82,
        187.26,
        552.71,
        198.26
      ],
      [
        105.82,
        200.26,
        400.17,
        211.26
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-152",
    "familyId": "oma8-en-152"
  },
  {
    "section": "8.3.8.12",
    "manualPage": "8.3-106",
    "pdfPage": 270,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: The rate of cooling of the fuel can be expected to be [VALUE] per hour with a maximum of 12°C per hour possible under the most extreme conditions.",
    "choices": [
      "3°C",
      "2°C",
      "4°C",
      "5°C"
    ],
    "correctIndex": 0,
    "explanation": "The rate of cooling of the fuel can be expected to be 3°C per hour with a maximum of 12°C per hour possible under the most extreme conditions.",
    "sourceQuote": "The rate of cooling of the fuel can be expected to be 3°C per hour with a maximum of 12°C per hour possible under the most extreme conditions.",
    "sourceRects": [
      [
        77.48,
        246.27,
        524.43,
        257.27
      ],
      [
        77.48,
        259.28,
        524.29,
        270.28
      ],
      [
        77.48,
        272.28,
        524.33,
        283.28
      ],
      [
        77.48,
        340.28,
        524.33,
        351.28
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-153",
    "familyId": "oma8-en-153"
  },
  {
    "section": "8.3.11.1",
    "manualPage": "8.3-112",
    "pdfPage": 276,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: After engine start and until the airplane has reached [VALUE] during climb and from 10,000 feet during descent and until engine shut down, all flight crew members shall be alert and be occupied only with the conduct of the flight.",
    "choices": [
      "10,000 feet",
      "50 feet",
      "100 feet",
      "200 feet"
    ],
    "correctIndex": 0,
    "explanation": "After engine start and until the airplane has reached 10,000 feet during climb and from 10,000 feet during descent and until engine shut down, all flight crew members shall be alert and be occupied only with the conduct of the flight.",
    "sourceQuote": "After engine start and until the airplane has reached 10,000 feet during climb and from 10,000 feet during descent and until engine shut down, all flight crew members shall be alert and be occupied only with the conduct of the flight.",
    "sourceRects": [
      [
        77.49,
        330.27,
        524.29,
        341.27
      ],
      [
        77.49,
        343.27,
        524.33,
        354.27
      ],
      [
        77.49,
        356.27,
        524.29,
        367.27
      ],
      [
        77.49,
        369.28,
        374.23,
        380.28
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-154",
    "familyId": "oma8-en-154"
  },
  {
    "section": "8.3.1.1.3",
    "manualPage": "8.3-1",
    "pdfPage": 165,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "The final approach must be flown visually or in accordance with an established instrument approach procedure.",
    "sourceQuote": "The final approach must be flown visually or in accordance with an established instrument approach procedure.",
    "sourceRects": [
      [
        105.82,
        497.28,
        552.66,
        508.28
      ],
      [
        105.82,
        510.28,
        152.49,
        521.28
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-155",
    "familyId": "oma8-en-155"
  },
  {
    "section": "8.3.2.3.1",
    "manualPage": "8.3-8",
    "pdfPage": 172,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "Further-more, when a deviation from track is discovered, air traffic control must be informed so that appropriate actions may be taken to resolve any potential hazards to other aircraft which may have been created by the deviation.",
    "sourceQuote": "Further-more, when a deviation from track is discovered, air traffic control must be informed so that appropriate actions may be taken to resolve any potential hazards to other aircraft which may have been created by the deviation.",
    "sourceRects": [
      [
        77.48,
        329.28,
        524.28,
        340.28
      ],
      [
        77.48,
        342.28,
        524.42,
        353.28
      ],
      [
        77.48,
        355.28,
        208.86,
        366.28
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-156",
    "familyId": "oma8-en-156"
  },
  {
    "section": "8.3.2.4.3",
    "manualPage": "8.3-16",
    "pdfPage": 180,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "Auto",
      "ON",
      "OFF",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "Altimetry equipment required for operation in RVSM airspace TWO fully serviceable independent primary altitude measurement systems One Automatic Altitude Control system One Altitude Alerting system Standard pre-flight checks of altimeters are required.",
    "sourceQuote": "Altimetry equipment required for operation in RVSM airspace TWO fully serviceable independent primary altitude measurement systems One Automatic Altitude Control system One Altitude Alerting system Standard pre-flight checks of altimeters are required.",
    "sourceRects": [
      [
        77.48,
        393.49,
        372.03,
        404.49
      ],
      [
        77.48,
        412.49,
        422.72,
        423.49
      ],
      [
        77.48,
        427.49,
        267.89,
        438.49
      ],
      [
        77.48,
        442.49,
        221.81,
        453.49
      ],
      [
        77.48,
        463.26,
        524.28,
        474.26
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-157",
    "familyId": "oma8-en-157"
  },
  {
    "section": "8.3.2.4.3",
    "manualPage": "8.3-16",
    "pdfPage": 180,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "Required Navigation Performance (RNP) / PBN statement For NAT HLA operations, SWW shall operate to RNAV 10 (RNP 10) as a minimum approval standard.",
    "sourceQuote": "Required Navigation Performance (RNP) / PBN statement For NAT HLA operations, SWW shall operate to RNAV 10 (RNP 10) as a minimum approval standard.",
    "sourceRects": [
      [
        77.48,
        508.49,
        350.66,
        519.49
      ],
      [
        77.48,
        526.27,
        524.37,
        538.26
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-158",
    "familyId": "oma8-en-158"
  },
  {
    "section": "8.3.2.4.18",
    "manualPage": "8.3-35",
    "pdfPage": 199,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "When weather deviation is required, the pilot should contact ATC via CPDLC or voice.",
    "sourceQuote": "When weather deviation is required, the pilot should contact ATC via CPDLC or voice.",
    "sourceRects": [
      [
        105.82,
        617.3,
        552.66,
        628.3
      ],
      [
        105.82,
        630.31,
        552.75,
        641.31
      ],
      [
        105.82,
        643.31,
        552.67,
        654.31
      ],
      [
        105.82,
        656.31,
        552.58,
        667.31
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-159",
    "familyId": "oma8-en-159"
  },
  {
    "section": "8.3.2.5.7",
    "manualPage": "8.3-54",
    "pdfPage": 218,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "This check must include: The waypoint sequence Reasonableness of the tracks and distances of the approach legs, and the accuracy of the inbound course and mileage of the final approach segment.",
    "sourceQuote": "This check must include: The waypoint sequence Reasonableness of the tracks and distances of the approach legs, and the accuracy of the inbound course and mileage of the final approach segment.",
    "sourceRects": [
      [
        77.47,
        388.3,
        388.43,
        399.3
      ],
      [
        77.47,
        407.53,
        197.0,
        418.53
      ],
      [
        77.47,
        422.53,
        519.21,
        433.53
      ],
      [
        93.48,
        437.31,
        314.38,
        448.31
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-160",
    "familyId": "oma8-en-160"
  },
  {
    "section": "8.3.2.5.7",
    "manualPage": "8.3-54",
    "pdfPage": 218,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "For multi-sensor systems, the crew must verify during the approach that GNSS sensor is used for position computation For APV BARO-VNAV operation, the crew must confirm the correct altimeter setting.",
    "sourceQuote": "For multi-sensor systems, the crew must verify during the approach that GNSS sensor is used for position computation For APV BARO-VNAV operation, the crew must confirm the correct altimeter setting.",
    "sourceRects": [
      [
        77.47,
        467.54,
        516.29,
        478.54
      ],
      [
        93.48,
        482.32,
        296.74,
        493.32
      ],
      [
        77.47,
        503.32,
        524.41,
        514.32
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-161",
    "familyId": "oma8-en-161"
  },
  {
    "section": "8.3.2.9",
    "manualPage": "8.3-78",
    "pdfPage": 242,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "landing",
      "take-off",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Any downgrading of onboard equipment must be assessed with regard to possible increased landing minima at destination or alternate airports.",
    "sourceQuote": "Any downgrading of onboard equipment must be assessed with regard to possible increased landing minima at destination or alternate airports.",
    "sourceRects": [
      [
        77.49,
        687.4,
        524.33,
        698.4
      ],
      [
        77.49,
        700.4,
        264.07,
        711.4
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-162",
    "familyId": "oma8-en-162"
  },
  {
    "section": "8.3.2.10.5",
    "manualPage": "8.3-82",
    "pdfPage": 246,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "An aircraft rendered non-RVSM approved shall normally be cleared out of the RVSM airspace by ATC, when possible.",
    "sourceQuote": "An aircraft rendered non-RVSM approved shall normally be cleared out of the RVSM airspace by ATC, when possible.",
    "sourceRects": [
      [
        77.48,
        187.26,
        524.32,
        198.26
      ],
      [
        77.48,
        200.26,
        465.17,
        211.26
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-163",
    "familyId": "oma8-en-163"
  },
  {
    "section": "8.3.2.10.5",
    "manualPage": "8.3-82",
    "pdfPage": 246,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "This shall also apply to aircraft unable to maintain the navigation accuracy required for MNPS and RVSM operations to maintain safe separation between airplanes.",
    "sourceQuote": "This shall also apply to aircraft unable to maintain the navigation accuracy required for MNPS and RVSM operations to maintain safe separation between airplanes.",
    "sourceRects": [
      [
        77.48,
        426.26,
        524.32,
        437.26
      ],
      [
        77.48,
        439.26,
        361.5,
        450.26
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-164",
    "familyId": "oma8-en-164"
  },
  {
    "section": "8.3.3.1.3",
    "manualPage": "8.3-83",
    "pdfPage": 247,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "QFE operations are prohibited With respect to altitude corrections the following procedures apply: IFR assigned altitudes may be either accepted or refused at the Commander's discretion.",
    "sourceQuote": "QFE operations are prohibited With respect to altitude corrections the following procedures apply: IFR assigned altitudes may be either accepted or refused at the Commander's discretion.",
    "sourceRects": [
      [
        105.82,
        653.52,
        255.02,
        664.52
      ],
      [
        105.82,
        674.28,
        402.63,
        685.28
      ],
      [
        105.82,
        693.51,
        545.36,
        704.51
      ],
      [
        121.84,
        708.28,
        552.62,
        719.28
      ],
      [
        105.82,
        738.52,
        542.62,
        749.52
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-165",
    "familyId": "oma8-en-165"
  },
  {
    "section": "8.3.7.2.3",
    "manualPage": "8.3-89",
    "pdfPage": 253,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "Commitment to stay Once consumption of the alternate fuel at the destination airport has commenced, such decision shall be understood as a \"Commitment to Stay\".",
    "sourceQuote": "Commitment to stay Once consumption of the alternate fuel at the destination airport has commenced, such decision shall be understood as a \"Commitment to Stay\".",
    "sourceRects": [
      [
        105.82,
        467.28,
        195.56,
        478.28
      ],
      [
        105.82,
        486.26,
        552.62,
        497.26
      ],
      [
        105.82,
        499.26,
        293.37,
        510.26
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-166",
    "familyId": "oma8-en-166"
  },
  {
    "section": "8.3.8.2.3",
    "manualPage": "8.3-94",
    "pdfPage": 258,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "Before take-off The Commander shall ensure that no frost, ice or snow adheres to the airplane.",
    "sourceQuote": "Before take-off The Commander shall ensure that no frost, ice or snow adheres to the airplane.",
    "sourceRects": [
      [
        77.48,
        503.26,
        144.74,
        514.26
      ],
      [
        77.48,
        522.26,
        524.21,
        533.26
      ],
      [
        77.48,
        535.26,
        524.43,
        546.26
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-167",
    "familyId": "oma8-en-167"
  },
  {
    "section": "8.3.8.7.2",
    "manualPage": "8.3-99",
    "pdfPage": 263,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "The runway surface conditions whenever water or sand is present on an operational runway shall be assessed.",
    "sourceQuote": "The runway surface conditions whenever water or sand is present on an operational runway shall be assessed.",
    "sourceRects": [
      [
        105.82,
        431.27,
        552.77,
        442.27
      ],
      [
        105.82,
        444.27,
        552.67,
        455.27
      ],
      [
        105.82,
        457.28,
        552.77,
        468.28
      ],
      [
        105.82,
        470.28,
        552.67,
        481.28
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-168",
    "familyId": "oma8-en-168"
  },
  {
    "section": "8.3.10.3",
    "manualPage": "8.3-109",
    "pdfPage": 273,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "Pilots should not fly the airplane using stabilizer trim, and should stop trimming nose down when they feel the g force on the airplane lessen or the required elevator force lessen.",
    "sourceQuote": "Pilots should not fly the airplane using stabilizer trim, and should stop trimming nose down when they feel the g force on the airplane lessen or the required elevator force lessen.",
    "sourceRects": [
      [
        105.87,
        666.28,
        552.71,
        677.28
      ],
      [
        105.87,
        679.29,
        552.71,
        690.29
      ],
      [
        105.87,
        691.3,
        552.75,
        703.29
      ],
      [
        105.87,
        705.29,
        552.75,
        716.29
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-169",
    "familyId": "oma8-en-169"
  },
  {
    "section": "8.3.11.1",
    "manualPage": "8.3-112",
    "pdfPage": 276,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "flight crew",
      "Commander",
      "First Officer",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "During this time, there shall be no other activity such as filling out forms, which may distract or reduce the alertness of the flight crew.",
    "sourceQuote": "During this time, there shall be no other activity such as filling out forms, which may distract or reduce the alertness of the flight crew.",
    "sourceRects": [
      [
        77.49,
        343.27,
        524.33,
        354.27
      ],
      [
        77.49,
        356.27,
        524.29,
        367.27
      ],
      [
        77.49,
        369.28,
        374.23,
        380.28
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-170",
    "familyId": "oma8-en-170"
  },
  {
    "section": "8.3.12",
    "manualPage": "8.3-113",
    "pdfPage": 277,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "Supernumeraries The Commander shall ensure that each person on board is briefed before take-off on how to fasten and unfasten the safety belt/harness.",
    "sourceQuote": "Supernumeraries The Commander shall ensure that each person on board is briefed before take-off on how to fasten and unfasten the safety belt/harness.",
    "sourceRects": [
      [
        105.82,
        489.26,
        180.18,
        500.26
      ],
      [
        105.82,
        508.26,
        552.67,
        519.26
      ],
      [
        105.82,
        521.26,
        246.09,
        532.26
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-171",
    "familyId": "oma8-en-171"
  },
  {
    "section": "8.3.18",
    "manualPage": "8.3-117",
    "pdfPage": 281,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "flight crew",
      "Commander",
      "First Officer",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "The flight crew must be aware of what automation is doing, and if it is not understood or airplane response is not appropriate or adequate, a reversion to basic modes of operations should be made immediately.",
    "sourceQuote": "The flight crew must be aware of what automation is doing, and if it is not understood or airplane response is not appropriate or adequate, a reversion to basic modes of operations should be made immediately.",
    "sourceRects": [
      [
        105.82,
        586.27,
        552.63,
        597.27
      ],
      [
        105.82,
        599.27,
        552.77,
        610.27
      ],
      [
        105.82,
        612.27,
        406.64,
        623.27
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-172",
    "familyId": "oma8-en-172"
  },
  {
    "section": "8.3.7.1",
    "manualPage": "8.3-87",
    "pdfPage": 251,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: During operations beyond [VALUE], from a point on a route to an en route alternate airport, meteorological information for en route alternates should be monitored (ERA-max time is 180 min from a point on a route to an alternate).",
    "choices": [
      "60 minutes",
      "45 minutes",
      "30 minutes",
      "90 minutes"
    ],
    "correctIndex": 0,
    "explanation": "During operations beyond 60 minutes, from a point on a route to an en route alternate airport, meteorological information for en route alternates should be monitored (ERA-max time is 180 min from a point on a route to an alternate).",
    "sourceQuote": "During operations beyond 60 minutes, from a point on a route to an en route alternate airport, meteorological information for en route alternates should be monitored (ERA-max time is 180 min from a point on a route to an alternate).",
    "sourceRects": [
      [
        105.82,
        561.37,
        552.71,
        572.37
      ],
      [
        105.82,
        574.37,
        552.77,
        585.37
      ],
      [
        105.82,
        587.38,
        246.57,
        598.38
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-173",
    "familyId": "oma8-en-173"
  },
  {
    "section": "8.3.8.2.1",
    "manualPage": "8.3-93",
    "pdfPage": 257,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Icing conditions exist when the OAT on the ground and for take-off, or TAT inflight is 10oC or below, and visible moisture in any form is present (such as clouds, fog with visibility of [VALUE] (1 SM) or less, rain, snow, sleet and ice crystals).",
    "choices": [
      "1600 meters",
      "1500 meters",
      "1800 meters",
      "1200 meters"
    ],
    "correctIndex": 0,
    "explanation": "Icing conditions exist when the OAT on the ground and for take-off, or TAT inflight is 10oC or below, and visible moisture in any form is present (such as clouds, fog with visibility of 1600 meters (1 SM) or less, rain, snow, sleet and ice crystals).",
    "sourceQuote": "Icing conditions exist when the OAT on the ground and for take-off, or TAT inflight is 10oC or below, and visible moisture in any form is present (such as clouds, fog with visibility of 1600 meters (1 SM) or less, rain, snow, sleet and ice crystals).",
    "sourceRects": [
      [
        105.82,
        706.39,
        552.79,
        719.31
      ],
      [
        105.83,
        721.31,
        552.75,
        732.31
      ],
      [
        105.83,
        734.31,
        287.13,
        745.31
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-174",
    "familyId": "oma8-en-174"
  },
  {
    "section": "8.3.9.2",
    "manualPage": "8.3-108",
    "pdfPage": 272,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Landing on a parallel opposite direction runway separated by [VALUE] NOTE: At airports where a grass strip is in use, in addition to paved runways, the strip will be counted as a runway for wake vortex separation minima.",
    "choices": [
      "less than 760 metres",
      "less than 660 metres",
      "less than 860 metres",
      "less than 960 metres"
    ],
    "correctIndex": 0,
    "explanation": "Landing on a parallel opposite direction runway separated by less than 760 metres NOTE: At airports where a grass strip is in use, in addition to paved runways, the strip will be counted as a runway for wake vortex separation minima.",
    "sourceQuote": "Landing on a parallel opposite direction runway separated by less than 760 metres NOTE: At airports where a grass strip is in use, in addition to paved runways, the strip will be counted as a runway for wake vortex separation minima.",
    "sourceRects": [
      [
        77.48,
        529.49,
        454.64,
        540.49
      ],
      [
        77.48,
        544.5,
        497.07,
        555.5
      ],
      [
        77.48,
        559.27,
        326.7,
        570.27
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-175",
    "familyId": "oma8-en-175"
  },
  {
    "section": "8.3.2.2.1",
    "manualPage": "8.3-5",
    "pdfPage": 169,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Because of this, the angle of convergence be-tween the final approach course and the runway bearing should be determined by reference to the instrument approach procedure chart.",
    "sourceQuote": "Because of this, the angle of convergence be-tween the final approach course and the runway bearing should be determined by reference to the instrument approach procedure chart.",
    "sourceRects": [
      [
        105.82,
        162.27,
        552.67,
        173.27
      ],
      [
        105.82,
        175.27,
        552.71,
        186.27
      ],
      [
        105.82,
        188.27,
        552.65,
        199.27
      ],
      [
        105.82,
        201.27,
        552.67,
        212.27
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-176",
    "familyId": "oma8-en-176"
  },
  {
    "section": "8.3.2.2.2",
    "manualPage": "8.3-7",
    "pdfPage": 171,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Speed reduction requested by ATC to assure separation shall be done with [VALUE]/ second and has priority over rate restriction.",
    "choices": [
      "1 knot",
      "5 knot",
      "10 knot",
      "15 knot"
    ],
    "correctIndex": 0,
    "explanation": "Speed reduction requested by ATC to assure separation shall be done with 1 knot/ second and has priority over rate restriction.",
    "sourceQuote": "Speed reduction requested by ATC to assure separation shall be done with 1 knot/ second and has priority over rate restriction.",
    "sourceRects": [
      [
        105.82,
        181.5,
        226.6,
        192.5
      ],
      [
        105.82,
        200.26,
        552.63,
        211.26
      ],
      [
        105.82,
        213.26,
        552.63,
        224.26
      ],
      [
        105.82,
        226.27,
        552.8,
        237.27
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-177",
    "familyId": "oma8-en-177"
  },
  {
    "section": "8.3.2.4.3",
    "manualPage": "8.3-16",
    "pdfPage": 180,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: At least two primary altimeters must agree at all times within plus or minus [VALUE].",
    "choices": [
      "200 feet",
      "100 feet",
      "300 feet",
      "50 feet"
    ],
    "correctIndex": 0,
    "explanation": "At least two primary altimeters must agree at all times within plus or minus 200 feet.",
    "sourceQuote": "At least two primary altimeters must agree at all times within plus or minus 200 feet.",
    "sourceRects": [
      [
        77.48,
        463.26,
        524.28,
        474.26
      ],
      [
        77.48,
        476.26,
        524.43,
        487.26
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-178",
    "familyId": "oma8-en-178"
  },
  {
    "section": "8.3.2.4.5",
    "manualPage": "8.3-18",
    "pdfPage": 182,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Prior to entry into NAT HLA Crosscheck the primary altimeters of which at least two must agree within plus or minus [VALUE]; record the readings to be available for use in possible contingency situations.",
    "choices": [
      "200 feet",
      "100 feet",
      "300 feet",
      "50 feet"
    ],
    "correctIndex": 0,
    "explanation": "Prior to entry into NAT HLA Crosscheck the primary altimeters of which at least two must agree within plus or minus 200 feet; record the readings to be available for use in possible contingency situations.",
    "sourceQuote": "Prior to entry into NAT HLA Crosscheck the primary altimeters of which at least two must agree within plus or minus 200 feet; record the readings to be available for use in possible contingency situations.",
    "sourceRects": [
      [
        77.48,
        311.48,
        214.54,
        322.48
      ],
      [
        77.48,
        330.25,
        524.28,
        341.25
      ],
      [
        77.48,
        343.25,
        415.5,
        354.25
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-179",
    "familyId": "oma8-en-179"
  },
  {
    "section": "8.3.2.4.8",
    "manualPage": "8.3-23",
    "pdfPage": 187,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: The distance between significant points shall normally equate to not less than 30 and [VALUE] of flying time.",
    "choices": [
      "not more than 60 minutes",
      "not more than 45 minutes",
      "not more than 30 minutes",
      "not more than 90 minutes"
    ],
    "correctIndex": 0,
    "explanation": "The distance between significant points shall normally equate to not less than 30 and not more than 60 minutes of flying time.",
    "sourceQuote": "The distance between significant points shall normally equate to not less than 30 and not more than 60 minutes of flying time.",
    "sourceRects": [
      [
        105.82,
        473.28,
        552.65,
        484.28
      ],
      [
        105.82,
        486.29,
        552.65,
        497.29
      ],
      [
        105.82,
        499.29,
        552.65,
        510.29
      ],
      [
        105.82,
        512.29,
        338.01,
        523.29
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-180",
    "familyId": "oma8-en-180"
  },
  {
    "section": "8.3.2.4.8",
    "manualPage": "8.3-24",
    "pdfPage": 188,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Adherence to ATC approved route If an aircraft has inadvertently deviated from the route specified in its ATC clearance, it shall take action to regain such route [VALUE] from the position at which the deviation was observed.",
    "choices": [
      "within 100 NM",
      "within 120 NM",
      "within 60 NM",
      "within 50 NM"
    ],
    "correctIndex": 0,
    "explanation": "Adherence to ATC approved route If an aircraft has inadvertently deviated from the route specified in its ATC clearance, it shall take action to regain such route within 100 NM from the position at which the deviation was observed.",
    "sourceQuote": "Adherence to ATC approved route If an aircraft has inadvertently deviated from the route specified in its ATC clearance, it shall take action to regain such route within 100 NM from the position at which the deviation was observed.",
    "sourceRects": [
      [
        77.48,
        200.49,
        239.08,
        211.49
      ],
      [
        77.48,
        219.26,
        524.43,
        230.26
      ],
      [
        77.48,
        232.26,
        507.89,
        243.26
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-181",
    "familyId": "oma8-en-181"
  },
  {
    "section": "8.3.2.4.10",
    "manualPage": "8.3-26",
    "pdfPage": 190,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Any Estimate found to be in error by [VALUE] or more for the Oceanic Boundary originally given at the time of initial contact with ATC/OCA must be passed on to ATC.",
    "choices": [
      "3 minutes",
      "2 minutes",
      "1 minutes",
      "5 minutes"
    ],
    "correctIndex": 0,
    "explanation": "Any Estimate found to be in error by 3 minutes or more for the Oceanic Boundary originally given at the time of initial contact with ATC/OCA must be passed on to ATC.",
    "sourceQuote": "Any Estimate found to be in error by 3 minutes or more for the Oceanic Boundary originally given at the time of initial contact with ATC/OCA must be passed on to ATC.",
    "sourceRects": [
      [
        77.48,
        585.27,
        524.28,
        596.27
      ],
      [
        77.48,
        598.27,
        378.54,
        609.27
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-182",
    "familyId": "oma8-en-182"
  },
  {
    "section": "8.3.2.4.11",
    "manualPage": "8.3-28",
    "pdfPage": 192,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Departures from all other aerodromes, if the elapsed time to the Shanwick entry point is [VALUE], or less, oceanic clearance required prior to departure.",
    "choices": [
      "40 minutes",
      "45 minutes",
      "30 minutes",
      "20 minutes"
    ],
    "correctIndex": 0,
    "explanation": "Departures from all other aerodromes, if the elapsed time to the Shanwick entry point is 40 minutes, or less, oceanic clearance required prior to departure.",
    "sourceQuote": "Departures from all other aerodromes, if the elapsed time to the Shanwick entry point is 40 minutes, or less, oceanic clearance required prior to departure.",
    "sourceRects": [
      [
        77.48,
        617.26,
        524.21,
        628.26
      ],
      [
        77.48,
        630.26,
        310.86,
        641.26
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-183",
    "familyId": "oma8-en-183"
  },
  {
    "section": "8.3.2.4.12",
    "manualPage": "8.3-33",
    "pdfPage": 197,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Utilization of this procedure will enable ATC, under specific conditions, to allow aircraft to climb/descend through the altitude of another aircraft when separated longitudinally by [VALUE] where previously 10 minutes was required.",
    "choices": [
      "5 minutes",
      "3 minutes",
      "2 minutes",
      "1 minutes"
    ],
    "correctIndex": 0,
    "explanation": "Utilization of this procedure will enable ATC, under specific conditions, to allow aircraft to climb/descend through the altitude of another aircraft when separated longitudinally by 5 minutes where previously 10 minutes was required.",
    "sourceQuote": "Utilization of this procedure will enable ATC, under specific conditions, to allow aircraft to climb/descend through the altitude of another aircraft when separated longitudinally by 5 minutes where previously 10 minutes was required.",
    "sourceRects": [
      [
        105.82,
        655.27,
        552.67,
        666.27
      ],
      [
        105.82,
        668.27,
        552.67,
        679.27
      ],
      [
        105.82,
        681.27,
        222.57,
        692.27
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-184",
    "familyId": "oma8-en-184"
  },
  {
    "section": "8.3.2.4.14",
    "manualPage": "8.3-34",
    "pdfPage": 198,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: In November 2015, Gander and Shanwick area control centers (ACCs) commenced participation in the trial of a [VALUE] lateral separation minimum in portions of the Gander and Shanwick Oceanic Control Areas (OCA).",
    "choices": [
      "25NM",
      "30NM",
      "15NM",
      "10NM"
    ],
    "correctIndex": 0,
    "explanation": "In November 2015, Gander and Shanwick area control centers (ACCs) commenced participation in the trial of a 25NM lateral separation minimum in portions of the Gander and Shanwick Oceanic Control Areas (OCA).",
    "sourceQuote": "In November 2015, Gander and Shanwick area control centers (ACCs) commenced participation in the trial of a 25NM lateral separation minimum in portions of the Gander and Shanwick Oceanic Control Areas (OCA).",
    "sourceRects": [
      [
        77.47,
        270.25,
        524.32,
        281.25
      ],
      [
        77.47,
        283.26,
        524.36,
        294.26
      ],
      [
        77.47,
        296.26,
        524.26,
        307.26
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-185",
    "familyId": "oma8-en-185"
  },
  {
    "section": "8.3.2.4.23",
    "manualPage": "8.3-41",
    "pdfPage": 205,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "Properties of fuel at very low temperatures The fuel freezing point is the temperature at which wax crystals, which form in the fuel as it cools, completely disappear when the fuel is rewarmed.",
    "sourceQuote": "Properties of fuel at very low temperatures The fuel freezing point is the temperature at which wax crystals, which form in the fuel as it cools, completely disappear when the fuel is rewarmed.",
    "sourceRects": [
      [
        105.82,
        142.49,
        306.66,
        153.49
      ],
      [
        105.82,
        161.26,
        552.8,
        172.26
      ],
      [
        105.82,
        174.26,
        552.67,
        185.26
      ],
      [
        105.82,
        187.26,
        552.75,
        198.26
      ],
      [
        105.82,
        200.26,
        552.64,
        211.26
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-186",
    "familyId": "oma8-en-186"
  },
  {
    "section": "8.3.2.4.23",
    "manualPage": "8.3-41",
    "pdfPage": 205,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: In Russia, the fuels are TS-1 and RT, which have a maximum freezing point of [VALUE].",
    "choices": [
      "50°C",
      "45°C",
      "55°C",
      "60°C"
    ],
    "correctIndex": 0,
    "explanation": "In Russia, the fuels are TS-1 and RT, which have a maximum freezing point of 50°C.",
    "sourceQuote": "In Russia, the fuels are TS-1 and RT, which have a maximum freezing point of 50°C.",
    "sourceRects": [
      [
        105.82,
        213.26,
        552.63,
        224.26
      ],
      [
        105.82,
        226.27,
        552.75,
        237.27
      ],
      [
        105.82,
        239.27,
        131.37,
        250.27
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-187",
    "familyId": "oma8-en-187"
  },
  {
    "section": "8.3.2.4.23",
    "manualPage": "8.3-41",
    "pdfPage": 205,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "Because specifications may vary by country, operators should ensure that they are using the appropriate fuel procurement specification for the fuel being dispensed.",
    "sourceQuote": "Because specifications may vary by country, operators should ensure that they are using the appropriate fuel procurement specification for the fuel being dispensed.",
    "sourceRects": [
      [
        105.82,
        258.26,
        552.71,
        269.26
      ],
      [
        105.82,
        271.27,
        383.12,
        282.27
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-188",
    "familyId": "oma8-en-188"
  },
  {
    "section": "8.3.2.5.7",
    "manualPage": "8.3-56",
    "pdfPage": 220,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Deviations above and below the vertical path must not exceed ±[VALUE].",
    "choices": [
      "75 feet",
      "50 feet",
      "100 feet",
      "200 feet"
    ],
    "correctIndex": 0,
    "explanation": "Deviations above and below the vertical path must not exceed ±75 feet.",
    "sourceQuote": "Deviations above and below the vertical path must not exceed ±75 feet.",
    "sourceRects": [
      [
        77.48,
        245.53,
        503.48,
        256.53
      ],
      [
        93.49,
        260.3,
        517.01,
        271.3
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-189",
    "familyId": "oma8-en-189"
  },
  {
    "section": "8.3.2.10.2",
    "manualPage": "8.3-79",
    "pdfPage": 243,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "flight crew",
      "Commander",
      "First Officer",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "Flight planning During flight planning the flight crew should pay particular attention to conditions that may affect operation in RVSM airspace.",
    "sourceQuote": "Flight planning During flight planning the flight crew should pay particular attention to conditions that may affect operation in RVSM airspace.",
    "sourceRects": [
      [
        105.82,
        367.26,
        173.24,
        378.26
      ],
      [
        105.82,
        386.26,
        552.62,
        397.26
      ],
      [
        105.82,
        399.26,
        416.31,
        410.26
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-190",
    "familyId": "oma8-en-190"
  },
  {
    "section": "8.3.2.10.3",
    "manualPage": "8.3-80",
    "pdfPage": 244,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "The following actions should be accomplished while in flight: Pilots should be aware of, and use correctly the RVSM related phraseology in communications with ATC Height keeping accuracy is important in RVSM environment.",
    "sourceQuote": "The following actions should be accomplished while in flight: Pilots should be aware of, and use correctly the RVSM related phraseology in communications with ATC Height keeping accuracy is important in RVSM environment.",
    "sourceRects": [
      [
        77.48,
        563.27,
        350.29,
        574.27
      ],
      [
        77.48,
        582.5,
        509.84,
        593.5
      ],
      [
        93.49,
        597.27,
        135.87,
        608.27
      ],
      [
        77.48,
        612.51,
        518.98,
        623.51
      ],
      [
        93.49,
        627.28,
        506.6,
        638.28
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-191",
    "familyId": "oma8-en-191"
  },
  {
    "section": "8.3.6.3",
    "manualPage": "8.3-86",
    "pdfPage": 250,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Continued operation in TA/RA mode may result in RAs for aircraft on approach to the adjacent runway, and may cause unnecessary go-around.",
    "sourceQuote": "Continued operation in TA/RA mode may result in RAs for aircraft on approach to the adjacent runway, and may cause unnecessary go-around.",
    "sourceRects": [
      [
        77.5,
        614.27,
        524.34,
        625.27
      ],
      [
        77.5,
        627.27,
        524.34,
        638.27
      ],
      [
        77.5,
        640.93,
        396.8,
        651.93
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-192",
    "familyId": "oma8-en-192"
  },
  {
    "section": "8.3.8.2.3",
    "manualPage": "8.3-95",
    "pdfPage": 259,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "Approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Approach and landing During approach and landing be very conservative when estimating the risk of ice.",
    "sourceQuote": "Approach and landing During approach and landing be very conservative when estimating the risk of ice.",
    "sourceRects": [
      [
        105.82,
        359.29,
        203.48,
        370.29
      ],
      [
        105.82,
        378.49,
        534.56,
        389.49
      ],
      [
        121.84,
        393.26,
        550.05,
        404.26
      ],
      [
        105.82,
        423.5,
        542.76,
        434.5
      ],
      [
        121.84,
        438.27,
        353.03,
        449.27
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-193",
    "familyId": "oma8-en-193"
  },
  {
    "section": "8.3.8.12",
    "manualPage": "8.3-106",
    "pdfPage": 270,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "Fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "Fuel freeze should not be confused with fuel ice caused by frozen water particles, but is the formation of wax crystals suspended in the fuel which can accumulate below the freeze point.",
    "sourceQuote": "Fuel freeze should not be confused with fuel ice caused by frozen water particles, but is the formation of wax crystals suspended in the fuel which can accumulate below the freeze point.",
    "sourceRects": [
      [
        77.48,
        142.26,
        524.33,
        153.26
      ],
      [
        77.48,
        155.26,
        524.43,
        166.26
      ],
      [
        77.48,
        168.26,
        524.37,
        179.26
      ],
      [
        77.48,
        181.26,
        524.37,
        192.26
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-194",
    "familyId": "oma8-en-194"
  },
  {
    "section": "8.3.8.12",
    "manualPage": "8.3-106",
    "pdfPage": 270,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: In the more severe case a descent to altitudes of [VALUE] to 30,000 feet might be required.",
    "choices": [
      "25,000 feet",
      "50 feet",
      "100 feet",
      "200 feet"
    ],
    "correctIndex": 0,
    "explanation": "In the more severe case a descent to altitudes of 25,000 feet to 30,000 feet might be required.",
    "sourceQuote": "In the more severe case a descent to altitudes of 25,000 feet to 30,000 feet might be required.",
    "sourceRects": [
      [
        77.48,
        353.28,
        524.43,
        364.28
      ],
      [
        77.48,
        366.28,
        524.29,
        377.28
      ],
      [
        77.48,
        379.29,
        274.63,
        390.29
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-195",
    "familyId": "oma8-en-195"
  },
  {
    "section": "8.3.11.1",
    "manualPage": "8.3-112",
    "pdfPage": 276,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: A crew member shall not vacate his seat for the purpose of transferring duties to another crew member [VALUE].",
    "choices": [
      "below 20,000 feet",
      "below 50 feet",
      "below 100 feet",
      "below 200 feet"
    ],
    "correctIndex": 0,
    "explanation": "A crew member shall not vacate his seat for the purpose of transferring duties to another crew member below 20,000 feet.",
    "sourceQuote": "A crew member shall not vacate his seat for the purpose of transferring duties to another crew member below 20,000 feet.",
    "sourceRects": [
      [
        77.49,
        285.27,
        524.41,
        296.27
      ],
      [
        77.49,
        298.27,
        524.31,
        309.27
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-196",
    "familyId": "oma8-en-196"
  },
  {
    "section": "8.3.15",
    "manualPage": "8.3-114",
    "pdfPage": 278,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "flight crew",
      "Commander",
      "First Officer",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "While incapacitation may occur at any stage of flight, fatal collapse among flight crew has most commonly occurred in the critical stages of approach and landing when ground proximity presents a direct hazard.",
    "sourceQuote": "While incapacitation may occur at any stage of flight, fatal collapse among flight crew has most commonly occurred in the critical stages of approach and landing when ground proximity presents a direct hazard.",
    "sourceRects": [
      [
        77.48,
        511.26,
        524.42,
        522.26
      ],
      [
        77.48,
        524.26,
        524.32,
        535.26
      ],
      [
        77.48,
        537.26,
        524.36,
        548.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-197",
    "familyId": "oma8-en-197"
  },
  {
    "section": "8.3.1.1.2",
    "manualPage": "8.3-1",
    "pdfPage": 165,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "This approach must be authorized and controlled by the appropriate air traffic control facility.",
    "sourceQuote": "This approach must be authorized and controlled by the appropriate air traffic control facility.",
    "sourceRects": [
      [
        105.82,
        384.28,
        550.0,
        395.28
      ],
      [
        105.82,
        399.28,
        494.47,
        410.28
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-198",
    "familyId": "oma8-en-198"
  },
  {
    "section": "8.3.1.1.3",
    "manualPage": "8.3-1",
    "pdfPage": 165,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Instrument departure and approach procedures established by the state in which the airport is located shall be used.",
    "sourceQuote": "Instrument departure and approach procedures established by the state in which the airport is located shall be used.",
    "sourceRects": [
      [
        105.82,
        439.28,
        552.66,
        450.28
      ],
      [
        105.82,
        452.28,
        552.75,
        463.28
      ],
      [
        105.82,
        465.28,
        552.71,
        476.28
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-199",
    "familyId": "oma8-en-199"
  },
  {
    "section": "8.3.2.2.1",
    "manualPage": "8.3-4",
    "pdfPage": 168,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "Pilots must be aware not to track a wrong runway centerline.",
    "sourceQuote": "Pilots must be aware not to track a wrong runway centerline.",
    "sourceRects": [
      [
        77.48,
        259.28,
        524.42,
        270.28
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-200",
    "familyId": "oma8-en-200"
  },
  {
    "section": "8.3.2.2.2",
    "manualPage": "8.3-5",
    "pdfPage": 169,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "If a radio navigation aid on which adjacent route segments are based or by which an intersection is defined is found unreliable or out of service, the highest minimum safe MOCA/MORA concerned shall apply to maintain adequate terrain clearance.",
    "sourceQuote": "If a radio navigation aid on which adjacent route segments are based or by which an intersection is defined is found unreliable or out of service, the highest minimum safe MOCA/MORA concerned shall apply to maintain adequate terrain clearance.",
    "sourceRects": [
      [
        105.82,
        689.32,
        552.64,
        700.32
      ],
      [
        105.82,
        702.32,
        552.67,
        713.32
      ],
      [
        105.82,
        715.32,
        326.48,
        726.32
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-201",
    "familyId": "oma8-en-201"
  },
  {
    "section": "8.3.2.2.2",
    "manualPage": "8.3-7",
    "pdfPage": 171,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "High rate of descent (ROD) or rate of climb (ROC), especially in the phase in which the aircraft approaches its cleared FL, may trigger TCAS RAs, even though the required vertical separation is ensured by the controller.",
    "sourceQuote": "High rate of descent (ROD) or rate of climb (ROC), especially in the phase in which the aircraft approaches its cleared FL, may trigger TCAS RAs, even though the required vertical separation is ensured by the controller.",
    "sourceRects": [
      [
        105.82,
        258.26,
        552.62,
        269.26
      ],
      [
        105.82,
        271.27,
        552.65,
        282.27
      ],
      [
        105.82,
        284.27,
        217.53,
        295.27
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-202",
    "familyId": "oma8-en-202"
  },
  {
    "section": "8.3.2.2.2",
    "manualPage": "8.3-7",
    "pdfPage": 171,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "flight crew",
      "Commander",
      "First Officer",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "Emergency descent If due to a aircraft decompression an emergency descent becomes necessary the flight crew must transmit a distress message on the air to ground frequency in use (ATC, 121.500 or 123.450 mHz).",
    "sourceQuote": "Emergency descent If due to a aircraft decompression an emergency descent becomes necessary the flight crew must transmit a distress message on the air to ground frequency in use (ATC, 121.500 or 123.450 mHz).",
    "sourceRects": [
      [
        105.82,
        480.29,
        191.44,
        491.29
      ],
      [
        105.82,
        499.26,
        552.62,
        510.26
      ],
      [
        105.82,
        512.26,
        552.75,
        523.26
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-203",
    "familyId": "oma8-en-203"
  },
  {
    "section": "8.3.2.3.1",
    "manualPage": "8.3-7",
    "pdfPage": 171,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "To standardize global navigation procedures and policies, SWW has adopted a minimum required navigation performance of RNP-10 for worldwide oceanic long range navigation.",
    "sourceQuote": "To standardize global navigation procedures and policies, SWW has adopted a minimum required navigation performance of RNP-10 for worldwide oceanic long range navigation.",
    "sourceRects": [
      [
        105.82,
        764.27,
        552.67,
        775.27
      ],
      [
        105.82,
        777.27,
        464.0,
        788.27
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-204",
    "familyId": "oma8-en-204"
  },
  {
    "section": "8.3.2.3.4",
    "manualPage": "8.3-9",
    "pdfPage": 173,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "The terms HLA or RNPC (Required Navigation Capability) in this chapter are used in association with all minimum navigation requirement areas, such as North Atlantic HLA, NOPAC, SOPAC, EUR/SAM corridor.",
    "sourceQuote": "The terms HLA or RNPC (Required Navigation Capability) in this chapter are used in association with all minimum navigation requirement areas, such as North Atlantic HLA, NOPAC, SOPAC, EUR/SAM corridor.",
    "sourceRects": [
      [
        105.82,
        608.28,
        552.67,
        619.28
      ],
      [
        105.82,
        621.29,
        552.8,
        632.29
      ],
      [
        105.82,
        634.29,
        194.97,
        645.29
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-205",
    "familyId": "oma8-en-205"
  },
  {
    "section": "8.3.2.3.8",
    "manualPage": "8.3-10",
    "pdfPage": 174,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "Correct insertion of the initial position must therefore be checked before inertial systems are aligned and the position should be recorded on the OFP.",
    "sourceQuote": "Correct insertion of the initial position must therefore be checked before inertial systems are aligned and the position should be recorded on the OFP.",
    "sourceRects": [
      [
        77.47,
        515.54,
        268.11,
        526.54
      ],
      [
        77.47,
        534.31,
        524.32,
        545.31
      ],
      [
        77.47,
        547.31,
        524.27,
        558.31
      ],
      [
        77.47,
        560.31,
        524.42,
        571.31
      ],
      [
        77.47,
        573.32,
        524.36,
        584.32
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-206",
    "familyId": "oma8-en-206"
  },
  {
    "section": "8.3.2.3.9",
    "manualPage": "8.3-12",
    "pdfPage": 176,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "RNP5 in European BRNAV airspace), crews should use all aids (including VOR's and DME's) to confirm that the in-use navigation system is operating to the required accuracy.",
    "sourceQuote": "RNP5 in European BRNAV airspace), crews should use all aids (including VOR's and DME's) to confirm that the in-use navigation system is operating to the required accuracy.",
    "sourceRects": [
      [
        77.48,
        643.26,
        524.32,
        654.26
      ],
      [
        77.48,
        656.26,
        524.32,
        667.26
      ],
      [
        77.48,
        669.26,
        524.28,
        680.26
      ],
      [
        77.48,
        682.26,
        524.36,
        693.26
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-207",
    "familyId": "oma8-en-207"
  },
  {
    "section": "8.3.2.4.3",
    "manualPage": "8.3-15",
    "pdfPage": 179,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "Lateral Navigation Navigation performance (PBN) NAT HLA navigation performance requirements shall be based on the PBN specifications: RNAV 10 (RNP 10); and/or RNP 4 (where authorized/required).",
    "sourceQuote": "Lateral Navigation Navigation performance (PBN) NAT HLA navigation performance requirements shall be based on the PBN specifications: RNAV 10 (RNP 10); and/or RNP 4 (where authorized/required).",
    "sourceRects": [
      [
        105.82,
        366.52,
        194.5,
        377.52
      ],
      [
        105.82,
        385.28,
        244.36,
        396.28
      ],
      [
        105.82,
        404.26,
        503.91,
        415.26
      ],
      [
        105.82,
        423.26,
        227.56,
        434.26
      ],
      [
        105.82,
        442.48,
        279.38,
        453.48
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-208",
    "familyId": "oma8-en-208"
  },
  {
    "section": "8.3.2.4.3",
    "manualPage": "8.3-15",
    "pdfPage": 179,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "flight crew",
      "Commander",
      "First Officer",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "Each LRNS shall be capable of providing to the flight crew a continuous indication of the aircraft position relative to the desired track.",
    "sourceQuote": "Each LRNS shall be capable of providing to the flight crew a continuous indication of the aircraft position relative to the desired track.",
    "sourceRects": [
      [
        105.82,
        610.27,
        552.63,
        621.27
      ],
      [
        105.82,
        623.27,
        266.25,
        634.27
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-209",
    "familyId": "oma8-en-209"
  },
  {
    "section": "8.3.2.4.3",
    "manualPage": "8.3-16",
    "pdfPage": 180,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Flight crew",
      "Commander",
      "First Officer",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "Flight crew shall comply with any additional State of Registry requirements regarding carriage and use of GPS (e.g.",
    "sourceQuote": "Flight crew shall comply with any additional State of Registry requirements regarding carriage and use of GPS (e.g.",
    "sourceRects": [
      [
        77.48,
        110.26,
        524.32,
        121.26
      ],
      [
        77.48,
        123.26,
        288.3,
        134.26
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-210",
    "familyId": "oma8-en-210"
  },
  {
    "section": "8.3.2.4.3",
    "manualPage": "8.3-16",
    "pdfPage": 180,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: operational designator",
    "choices": [
      "W",
      "R",
      "X",
      "N"
    ],
    "correctIndex": 0,
    "explanation": "If the flight is approved to operate at RVSM levels, a ‘W’ shall also be included in Item 10.",
    "sourceQuote": "If the flight is approved to operate at RVSM levels, a ‘W’ shall also be included in Item 10.",
    "sourceRects": [
      [
        77.48,
        572.49,
        161.12,
        583.49
      ],
      [
        77.48,
        591.26,
        524.33,
        602.26
      ],
      [
        77.48,
        604.26,
        524.28,
        615.26
      ],
      [
        77.48,
        617.26,
        524.43,
        628.26
      ],
      [
        77.48,
        630.26,
        524.21,
        641.26
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-211",
    "familyId": "oma8-en-211"
  },
  {
    "section": "8.3.2.4.9",
    "manualPage": "8.3-24",
    "pdfPage": 188,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "On",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "On first contact with the initial aeradio station crews of participating aircraft should expect to receive the instruction \"VOICE POSITION REPORTS NOT REQUIRED\".",
    "sourceQuote": "On first contact with the initial aeradio station crews of participating aircraft should expect to receive the instruction \"VOICE POSITION REPORTS NOT REQUIRED\".",
    "sourceRects": [
      [
        77.48,
        747.28,
        524.42,
        758.28
      ],
      [
        77.48,
        760.28,
        375.18,
        771.28
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-212",
    "familyId": "oma8-en-212"
  },
  {
    "section": "8.3.2.4.15",
    "manualPage": "8.3-34",
    "pdfPage": 198,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "A report must always be made to ATC as soon as possible on reaching any new cruising level Position reports for aircraft operating on tracks through successive points on each boundary should also be made to the ACC serving the adjacent OCA (In practice e.g.",
    "sourceQuote": "A report must always be made to ATC as soon as possible on reaching any new cruising level Position reports for aircraft operating on tracks through successive points on each boundary should also be made to the ACC serving the adjacent OCA (In practice e.g.",
    "sourceRects": [
      [
        77.47,
        606.54,
        503.09,
        617.54
      ],
      [
        77.47,
        621.54,
        496.17,
        632.54
      ],
      [
        93.49,
        636.31,
        521.72,
        647.31
      ],
      [
        77.47,
        666.55,
        516.1,
        677.55
      ],
      [
        93.49,
        681.32,
        497.13,
        692.32
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-213",
    "familyId": "oma8-en-213"
  },
  {
    "section": "8.3.2.4.16",
    "manualPage": "8.3-35",
    "pdfPage": 199,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "Should an aircraft desire to register a request for one or more future step climbs the word \"REQUEST\" must be substituted for the word \"ABLE\" in the report.",
    "sourceQuote": "Should an aircraft desire to register a request for one or more future step climbs the word \"REQUEST\" must be substituted for the word \"ABLE\" in the report.",
    "sourceRects": [
      [
        121.84,
        268.27,
        549.92,
        279.27
      ],
      [
        121.84,
        283.28,
        539.96,
        294.28
      ],
      [
        121.84,
        298.28,
        550.2,
        309.28
      ],
      [
        121.84,
        313.29,
        526.2,
        324.29
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-214",
    "familyId": "oma8-en-214"
  },
  {
    "section": "8.3.2.4.18",
    "manualPage": "8.3-35",
    "pdfPage": 199,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "The pilot shall inform ATC when weather deviation has been completed and the aircraft has returned to its cleared route.",
    "sourceQuote": "The pilot shall inform ATC when weather deviation has been completed and the aircraft has returned to its cleared route.",
    "sourceRects": [
      [
        105.82,
        688.31,
        552.66,
        699.31
      ],
      [
        105.82,
        701.31,
        189.93,
        712.31
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-215",
    "familyId": "oma8-en-215"
  },
  {
    "section": "8.3.2.4.22",
    "manualPage": "8.3-40",
    "pdfPage": 204,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "VOR radials are displayed according to the orientation of the VOR station, either true or magnetic Crews should be prepared to operate metric altitude where required.",
    "sourceQuote": "VOR radials are displayed according to the orientation of the VOR station, either true or magnetic Crews should be prepared to operate metric altitude where required.",
    "sourceRects": [
      [
        77.48,
        568.28,
        524.32,
        579.28
      ],
      [
        77.48,
        581.28,
        524.32,
        592.28
      ],
      [
        77.48,
        594.28,
        524.4,
        605.28
      ],
      [
        77.48,
        607.28,
        117.64,
        618.28
      ],
      [
        77.48,
        626.28,
        524.36,
        637.28
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-216",
    "familyId": "oma8-en-216"
  },
  {
    "section": "8.3.2.4.23",
    "manualPage": "8.3-41",
    "pdfPage": 205,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "The maximum freezing point for some jet fuels can vary by the geographical region in which the fuel is refined or uplifted.",
    "sourceQuote": "The maximum freezing point for some jet fuels can vary by the geographical region in which the fuel is refined or uplifted.",
    "sourceRects": [
      [
        105.82,
        290.26,
        552.63,
        301.26
      ],
      [
        105.82,
        303.27,
        552.62,
        314.27
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-217",
    "familyId": "oma8-en-217"
  },
  {
    "section": "8.3.2.5.5",
    "manualPage": "8.3-51",
    "pdfPage": 215,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "Preflight planning During the pre-flight planning phase, the availability of the navigation infrastructure required for the intended operation, including any non-RNAV contingencies, must be confirmed for the period of intended operation.",
    "sourceQuote": "Preflight planning During the pre-flight planning phase, the availability of the navigation infrastructure required for the intended operation, including any non-RNAV contingencies, must be confirmed for the period of intended operation.",
    "sourceRects": [
      [
        105.82,
        372.88,
        185.48,
        383.88
      ],
      [
        105.82,
        391.89,
        552.77,
        402.89
      ],
      [
        105.82,
        404.89,
        552.75,
        415.89
      ],
      [
        105.82,
        417.89,
        190.65,
        428.89
      ]
    ],
    "topic": "navigation",
    "id": "oma8-en-218",
    "familyId": "oma8-en-218"
  },
  {
    "section": "8.3.2.5.5",
    "manualPage": "8.3-51",
    "pdfPage": 215,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "For minimum equipment required for P-RNAV operations, refer to OM-B, FCOM Vol.",
    "sourceQuote": "For minimum equipment required for P-RNAV operations, refer to OM-B, FCOM Vol.",
    "sourceRects": [
      [
        105.82,
        468.89,
        552.8,
        479.89
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-219",
    "familyId": "oma8-en-219"
  },
  {
    "section": "8.3.2.5.7",
    "manualPage": "8.3-54",
    "pdfPage": 218,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Procedures using a remote (regional) altimeter setting source cannot support APV BARO-VNAV approach For APV BARO-VNAV operation, pilots are responsible for any necessary cold temperature compensations to all published minimum altitudes/heights.",
    "sourceQuote": "Procedures using a remote (regional) altimeter setting source cannot support APV BARO-VNAV approach For APV BARO-VNAV operation, pilots are responsible for any necessary cold temperature compensations to all published minimum altitudes/heights.",
    "sourceRects": [
      [
        77.47,
        550.32,
        519.97,
        561.55
      ],
      [
        93.48,
        565.32,
        133.54,
        576.32
      ],
      [
        77.47,
        586.32,
        524.35,
        597.32
      ],
      [
        77.47,
        599.32,
        365.88,
        610.32
      ],
      [
        77.47,
        618.55,
        372.66,
        629.55
      ],
      [
        77.47,
        648.56,
        295.03,
        659.56
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-220",
    "familyId": "oma8-en-220"
  },
  {
    "section": "8.4.2.9",
    "manualPage": "8.4-40",
    "pdfPage": 326,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Approach and landing operations are not authorized when the prevailing visibility is [VALUE] or the Converted Meteorological Visibility (CMV) is below 800 RVR unless RVR reporting is available for the runway of intended use.",
    "choices": [
      "below 800 meters",
      "below 700 meters",
      "below 600 meters",
      "below 1000 meters"
    ],
    "correctIndex": 0,
    "explanation": "Approach and landing operations are not authorized when the prevailing visibility is below 800 meters or the Converted Meteorological Visibility (CMV) is below 800 RVR unless RVR reporting is available for the runway of intended use.",
    "sourceQuote": "Approach and landing operations are not authorized when the prevailing visibility is below 800 meters or the Converted Meteorological Visibility (CMV) is below 800 RVR unless RVR reporting is available for the runway of intended use.",
    "sourceRects": [
      [
        77.47,
        538.26,
        524.32,
        549.26
      ],
      [
        77.47,
        551.26,
        524.3,
        562.26
      ],
      [
        77.47,
        564.26,
        257.1,
        575.26
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-221",
    "familyId": "oma8-en-221"
  },
  {
    "section": "8.4.3.1",
    "manualPage": "8.4-41",
    "pdfPage": 327,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Low Visibility Procedures (LVP) Critical areas must be protected if the weather conditions are [VALUE] cloud base or 3000 meters visibility when instrument approach operations are being carried out.",
    "choices": [
      "less than 800 feet",
      "less than 700 feet",
      "less than 1000 feet",
      "less than 500 feet"
    ],
    "correctIndex": 0,
    "explanation": "Low Visibility Procedures (LVP) Critical areas must be protected if the weather conditions are less than 800 feet cloud base or 3000 meters visibility when instrument approach operations are being carried out.",
    "sourceQuote": "Low Visibility Procedures (LVP) Critical areas must be protected if the weather conditions are less than 800 feet cloud base or 3000 meters visibility when instrument approach operations are being carried out.",
    "sourceRects": [
      [
        105.82,
        526.26,
        250.6,
        537.26
      ],
      [
        105.82,
        545.26,
        552.67,
        556.26
      ],
      [
        105.82,
        558.26,
        552.77,
        569.26
      ],
      [
        105.82,
        571.26,
        552.67,
        582.26
      ],
      [
        105.82,
        583.27,
        552.71,
        595.26
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-222",
    "familyId": "oma8-en-222"
  },
  {
    "section": "8.4.3.3.7",
    "manualPage": "8.4-47",
    "pdfPage": 333,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: [VALUE] AGL, in case of aircraft or approach system discrepancy, the crew shall elect either to continue or abandon the approach in accordance with criteria as set out in OM-B, QRH Ops Info and FCTM Chapter 5 Approach and Missed Approach.",
    "choices": [
      "Below 500 feet",
      "Below 400 feet",
      "Below 300 feet",
      "Below 700 feet"
    ],
    "correctIndex": 0,
    "explanation": "Below 500 feet AGL, in case of aircraft or approach system discrepancy, the crew shall elect either to continue or abandon the approach in accordance with criteria as set out in OM-B, QRH Ops Info and FCTM Chapter 5 Approach and Missed Approach.",
    "sourceQuote": "Below 500 feet AGL, in case of aircraft or approach system discrepancy, the crew shall elect either to continue or abandon the approach in accordance with criteria as set out in OM-B, QRH Ops Info and FCTM Chapter 5 Approach and Missed Approach.",
    "sourceRects": [
      [
        105.82,
        215.25,
        552.67,
        226.25
      ],
      [
        105.82,
        228.26,
        552.67,
        239.26
      ],
      [
        105.82,
        241.26,
        328.17,
        252.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-223",
    "familyId": "oma8-en-223"
  },
  {
    "section": "8.4.1.10.15",
    "manualPage": "8.4-28",
    "pdfPage": 314,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "landing",
      "take-off",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "When landing during night time reverse thrust should only be applied to such an extent as is required in the interest of safety, paying due regard to landing weight, length of runway, wind and runway condition.",
    "sourceQuote": "When landing during night time reverse thrust should only be applied to such an extent as is required in the interest of safety, paying due regard to landing weight, length of runway, wind and runway condition.",
    "sourceRects": [
      [
        77.48,
        298.26,
        524.36,
        310.25
      ],
      [
        77.48,
        312.25,
        524.32,
        323.25
      ],
      [
        77.48,
        325.25,
        524.21,
        336.25
      ],
      [
        77.48,
        338.26,
        200.7,
        349.26
      ]
    ],
    "topic": "mass-balance",
    "id": "oma8-en-224",
    "familyId": "oma8-en-224"
  },
  {
    "section": "8.4.3.3.1",
    "manualPage": "8.4-43",
    "pdfPage": 329,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "take-off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "The weather conditions at the alternate airport must meet the take-off alternate minima but shall not be less than CAT l.",
    "sourceQuote": "The weather conditions at the alternate airport must meet the take-off alternate minima but shall not be less than CAT l.",
    "sourceRects": [
      [
        105.82,
        473.26,
        552.63,
        484.26
      ],
      [
        105.82,
        486.26,
        188.97,
        497.26
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-225",
    "familyId": "oma8-en-225"
  },
  {
    "section": "8.4.3.3.4",
    "manualPage": "8.4-45",
    "pdfPage": 331,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "flight crew",
      "Commander",
      "First Officer",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "When the RVR is close to, or below minimum the flight crew should bear in mind that the RVR quoted on Volmet and ATIS is the reading at the time of that observation, which may not be representative of the current conditions.",
    "sourceQuote": "When the RVR is close to, or below minimum the flight crew should bear in mind that the RVR quoted on Volmet and ATIS is the reading at the time of that observation, which may not be representative of the current conditions.",
    "sourceRects": [
      [
        105.82,
        446.26,
        552.58,
        457.26
      ],
      [
        105.82,
        459.26,
        552.71,
        470.26
      ],
      [
        105.82,
        472.26,
        243.45,
        483.26
      ]
    ],
    "topic": "lvo",
    "id": "oma8-en-226",
    "familyId": "oma8-en-226"
  },
  {
    "section": "8.4.3.3.2",
    "manualPage": "8.4-44",
    "pdfPage": 330,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Prior to entering the runway, the Commander should consider runway condition and braking action, particularly when carrying out a take-off when the RVR is [VALUE].",
    "choices": [
      "less than 200 meters",
      "less than 150 meters",
      "less than 125 meters",
      "less than 100 meters"
    ],
    "correctIndex": 0,
    "explanation": "Prior to entering the runway, the Commander should consider runway condition and braking action, particularly when carrying out a take-off when the RVR is less than 200 meters.",
    "sourceQuote": "Prior to entering the runway, the Commander should consider runway condition and braking action, particularly when carrying out a take-off when the RVR is less than 200 meters.",
    "sourceRects": [
      [
        77.48,
        543.27,
        524.21,
        554.27
      ],
      [
        77.48,
        556.27,
        427.73,
        567.27
      ]
    ],
    "topic": "lvo",
    "id": "oma8-en-227",
    "familyId": "oma8-en-227"
  },
  {
    "section": "8.4.3.1",
    "manualPage": "8.4-41",
    "pdfPage": 327,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: ILS critical and sensitive areas must always be protected if the weather conditions are lower than [VALUE] cloud base or 600 meters RVR when instrument approach conditions are being carried out.",
    "choices": [
      "200 feet",
      "100 feet",
      "300 feet",
      "50 feet"
    ],
    "correctIndex": 0,
    "explanation": "ILS critical and sensitive areas must always be protected if the weather conditions are lower than 200 feet cloud base or 600 meters RVR when instrument approach conditions are being carried out.",
    "sourceQuote": "ILS critical and sensitive areas must always be protected if the weather conditions are lower than 200 feet cloud base or 600 meters RVR when instrument approach conditions are being carried out.",
    "sourceRects": [
      [
        105.82,
        545.26,
        552.67,
        556.26
      ],
      [
        105.82,
        558.26,
        552.77,
        569.26
      ],
      [
        105.82,
        571.26,
        552.67,
        582.26
      ],
      [
        105.82,
        583.27,
        552.71,
        595.26
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-228",
    "familyId": "oma8-en-228"
  },
  {
    "section": "8.4.1.6.5",
    "manualPage": "8.4-10",
    "pdfPage": 296,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "The PF performs the take-off briefing, however, Commander shall always perform the RTO procedure part of the take-off briefing irrespective of which pilot is operating the controls on take-off.",
    "sourceQuote": "The PF performs the take-off briefing, however, Commander shall always perform the RTO procedure part of the take-off briefing irrespective of which pilot is operating the controls on take-off.",
    "sourceRects": [
      [
        77.48,
        524.25,
        524.43,
        535.25
      ],
      [
        77.48,
        537.25,
        524.4,
        548.25
      ],
      [
        77.48,
        550.26,
        524.42,
        561.26
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-229",
    "familyId": "oma8-en-229"
  },
  {
    "section": "8.4.1.6.5",
    "manualPage": "8.4-11",
    "pdfPage": 297,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "Take-off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Take-off performance limitations Prevailing take-off performance limitation (runway, second segment, obstacle etc.) as well as any specific take-off performance limitation (minimum climb gradient during SID, non-standard turn, EFP etc.).",
    "sourceQuote": "Take-off performance limitations Prevailing take-off performance limitation (runway, second segment, obstacle etc.) as well as any specific take-off performance limitation (minimum climb gradient during SID, non-standard turn, EFP etc.).",
    "sourceRects": [
      [
        105.82,
        629.26,
        251.22,
        640.26
      ],
      [
        105.82,
        648.26,
        552.71,
        659.26
      ],
      [
        105.82,
        661.26,
        552.8,
        672.26
      ],
      [
        105.82,
        674.26,
        127.77,
        685.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-230",
    "familyId": "oma8-en-230"
  },
  {
    "section": "8.4.1.8.1",
    "manualPage": "8.4-13",
    "pdfPage": 299,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Before entering any runway ATC clearance must be obtained and the approaches and runway should be checked visually to ensure they are clear, also the strobe lights should be turned on.",
    "sourceQuote": "Before entering any runway ATC clearance must be obtained and the approaches and runway should be checked visually to ensure they are clear, also the strobe lights should be turned on.",
    "sourceRects": [
      [
        105.82,
        616.3,
        552.67,
        627.3
      ],
      [
        105.82,
        629.31,
        552.77,
        640.31
      ],
      [
        105.82,
        642.31,
        552.75,
        653.31
      ],
      [
        105.82,
        655.31,
        355.28,
        666.31
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-231",
    "familyId": "oma8-en-231"
  },
  {
    "section": "8.4.1.8.7",
    "manualPage": "8.4-15",
    "pdfPage": 301,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "take-off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "On a take-off where there is considerably more runway available than the emergency distance required, a rejected take-off should not present a serious problem.",
    "sourceQuote": "On a take-off where there is considerably more runway available than the emergency distance required, a rejected take-off should not present a serious problem.",
    "sourceRects": [
      [
        105.82,
        308.26,
        552.77,
        319.26
      ],
      [
        105.82,
        321.26,
        552.71,
        332.26
      ],
      [
        105.82,
        334.26,
        552.77,
        345.26
      ],
      [
        105.82,
        347.27,
        552.77,
        358.27
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-232",
    "familyId": "oma8-en-232"
  },
  {
    "section": "8.4.1.9.4",
    "manualPage": "8.4-18",
    "pdfPage": 304,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "take-off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "All flights must be operated at or above specified minimum altitudes unless necessary for take-off, initial climb, approach and landing.",
    "sourceQuote": "All flights must be operated at or above specified minimum altitudes unless necessary for take-off, initial climb, approach and landing.",
    "sourceRects": [
      [
        77.48,
        128.26,
        524.21,
        139.26
      ],
      [
        77.48,
        141.26,
        233.58,
        152.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-233",
    "familyId": "oma8-en-233"
  },
  {
    "section": "8.4.1.10.1",
    "manualPage": "8.4-23",
    "pdfPage": 309,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Planning for approach to land shall be done well in advance in order for the pilots to be well prepared for the expected approach procedure and that the approach chart is only required for quick reference.",
    "sourceQuote": "Planning for approach to land shall be done well in advance in order for the pilots to be well prepared for the expected approach procedure and that the approach chart is only required for quick reference.",
    "sourceRects": [
      [
        105.82,
        461.26,
        552.67,
        472.26
      ],
      [
        105.82,
        474.26,
        552.8,
        485.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-234",
    "familyId": "oma8-en-234"
  },
  {
    "section": "8.4.1.10.3",
    "manualPage": "8.4-24",
    "pdfPage": 310,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "The approach may be continued below DA(H) or MDA(H) and the landing may be completed provided that the required visual reference is established at the DA(H) or MDA(H) and is maintained.",
    "sourceQuote": "The approach may be continued below DA(H) or MDA(H) and the landing may be completed provided that the required visual reference is established at the DA(H) or MDA(H) and is maintained.",
    "sourceRects": [
      [
        77.48,
        339.26,
        524.36,
        350.26
      ],
      [
        77.48,
        352.26,
        510.05,
        363.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-235",
    "familyId": "oma8-en-235"
  },
  {
    "section": "8.4.3.1",
    "manualPage": "8.4-41",
    "pdfPage": 327,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "A specified height in the precision approach at which a missed approach must be initiated if the required visual reference to continue the approach has not been established.",
    "sourceQuote": "A specified height in the precision approach at which a missed approach must be initiated if the required visual reference to continue the approach has not been established.",
    "sourceRects": [
      [
        105.82,
        110.26,
        552.77,
        121.26
      ],
      [
        105.82,
        123.26,
        552.71,
        134.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-236",
    "familyId": "oma8-en-236"
  },
  {
    "section": "8.4.3.3.1",
    "manualPage": "8.4-43",
    "pdfPage": 329,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "For CAT II and CAT III approach the planning minima for the alternate airports shall be CAT I (RVR shall be the determining factor).",
    "sourceQuote": "For CAT II and CAT III approach the planning minima for the alternate airports shall be CAT I (RVR shall be the determining factor).",
    "sourceRects": [
      [
        105.82,
        652.49,
        552.58,
        663.49
      ],
      [
        105.82,
        665.49,
        293.13,
        676.49
      ]
    ],
    "topic": "lvo",
    "id": "oma8-en-237",
    "familyId": "oma8-en-237"
  },
  {
    "section": "8.4.3.3.4",
    "manualPage": "8.4-45",
    "pdfPage": 331,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Downgrading of the approach from a CAT lll to a CAT ll may be accomplished if the requirements for minimum equipment and the procedures for abnormal occurrences on the approach and the CAT ll/ CAT lll and MEL requirements are met.",
    "sourceQuote": "Downgrading of the approach from a CAT lll to a CAT ll may be accomplished if the requirements for minimum equipment and the procedures for abnormal occurrences on the approach and the CAT ll/ CAT lll and MEL requirements are met.",
    "sourceRects": [
      [
        105.82,
        587.26,
        552.75,
        598.26
      ],
      [
        105.82,
        600.26,
        552.62,
        611.26
      ],
      [
        105.82,
        613.26,
        280.65,
        624.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-238",
    "familyId": "oma8-en-238"
  },
  {
    "section": "8.4.3.3.5",
    "manualPage": "8.4-46",
    "pdfPage": 332,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Where the RVR is not reported, and the reported VIS is less than the applicable minimum, but the converted meteorological visibility (CMV) is equal or greater than the applicable minimum, then the instrument approach can be continued to the DA/H or MDA/H.",
    "sourceQuote": "Where the RVR is not reported, and the reported VIS is less than the applicable minimum, but the converted meteorological visibility (CMV) is equal or greater than the applicable minimum, then the instrument approach can be continued to the DA/H or MDA/H.",
    "sourceRects": [
      [
        77.48,
        562.27,
        524.42,
        573.27
      ],
      [
        77.48,
        575.27,
        524.42,
        586.27
      ],
      [
        77.48,
        588.27,
        355.74,
        599.27
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-239",
    "familyId": "oma8-en-239"
  },
  {
    "section": "8.4.1.10.9",
    "manualPage": "8.4-26",
    "pdfPage": 312,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Mandatory Missed Approach Criteria \"If stabilized approach criteria are not met at the required gate ([VALUE].",
    "choices": [
      "1000 ft",
      "700 ft",
      "500 ft",
      "1500 ft"
    ],
    "correctIndex": 0,
    "explanation": "Mandatory Missed Approach Criteria \"If stabilized approach criteria are not met at the required gate (1000 ft.",
    "sourceQuote": "Mandatory Missed Approach Criteria \"If stabilized approach criteria are not met at the required gate (1000 ft.",
    "sourceRects": [
      [
        77.48,
        606.55,
        255.77,
        617.55
      ],
      [
        77.48,
        625.31,
        503.27,
        636.54
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-240",
    "familyId": "oma8-en-240"
  },
  {
    "section": "8.4.1.10.14",
    "manualPage": "8.4-28",
    "pdfPage": 314,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: If touchdown cannot be accomplished within the touchdown zone, i.e. within the first [VALUE] (900 meters) of the landing runway, a go-around shall be initiated.",
    "choices": [
      "3000 feet",
      "2000 feet",
      "1500 feet",
      "1000 feet"
    ],
    "correctIndex": 0,
    "explanation": "If touchdown cannot be accomplished within the touchdown zone, i.e. within the first 3000 feet (900 meters) of the landing runway, a go-around shall be initiated.",
    "sourceQuote": "If touchdown cannot be accomplished within the touchdown zone, i.e. within the first 3000 feet (900 meters) of the landing runway, a go-around shall be initiated.",
    "sourceRects": [
      [
        77.48,
        204.25,
        524.32,
        215.25
      ],
      [
        77.48,
        217.26,
        524.32,
        228.26
      ],
      [
        77.48,
        230.26,
        524.32,
        241.26
      ],
      [
        77.48,
        243.26,
        522.29,
        254.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-241",
    "familyId": "oma8-en-241"
  },
  {
    "section": "8.4.2.5",
    "manualPage": "8.4-37",
    "pdfPage": 323,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Controller guidance terminates at between [VALUE] and 0.5 NM from touchdown, at which point the pilot must either be visual with the runway, or must go around.",
    "choices": [
      "2 NM",
      "1 NM",
      "3 NM",
      "5 NM"
    ],
    "correctIndex": 0,
    "explanation": "Controller guidance terminates at between 2 NM and 0.5 NM from touchdown, at which point the pilot must either be visual with the runway, or must go around.",
    "sourceQuote": "Controller guidance terminates at between 2 NM and 0.5 NM from touchdown, at which point the pilot must either be visual with the runway, or must go around.",
    "sourceRects": [
      [
        105.82,
        172.26,
        552.77,
        183.26
      ],
      [
        105.82,
        185.26,
        381.92,
        196.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-242",
    "familyId": "oma8-en-242"
  },
  {
    "section": "8.4.1.8.1",
    "manualPage": "8.4-13",
    "pdfPage": 299,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "take-off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Prior to take off, ATC take-off clearance must be obtained, the runway and its entry point identified and the takeoff and climb out path should be checked clear of traffic.",
    "sourceQuote": "Prior to take off, ATC take-off clearance must be obtained, the runway and its entry point identified and the takeoff and climb out path should be checked clear of traffic.",
    "sourceRects": [
      [
        105.82,
        616.3,
        552.67,
        627.3
      ],
      [
        105.82,
        629.31,
        552.77,
        640.31
      ],
      [
        105.82,
        642.31,
        552.75,
        653.31
      ],
      [
        105.82,
        655.31,
        355.28,
        666.31
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-243",
    "familyId": "oma8-en-243"
  },
  {
    "section": "8.4.1.8.2",
    "manualPage": "8.4-14",
    "pdfPage": 300,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "Take-off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Take-off must be made from the beginning of the runway or an authorized take-off point according to Run-way Analysis (OPT orperformance tables).",
    "sourceQuote": "Take-off must be made from the beginning of the runway or an authorized take-off point according to Run-way Analysis (OPT orperformance tables).",
    "sourceRects": [
      [
        77.48,
        173.26,
        524.32,
        184.26
      ],
      [
        77.48,
        186.26,
        524.3,
        197.26
      ],
      [
        77.48,
        199.26,
        524.4,
        210.26
      ],
      [
        77.48,
        212.26,
        163.98,
        223.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-244",
    "familyId": "oma8-en-244"
  },
  {
    "section": "8.4.1.8.7",
    "manualPage": "8.4-15",
    "pdfPage": 301,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "take-off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Only those malfunctions shall be called out during the take-off run which may have a direct bearing on the decision to reject the take-off.",
    "sourceQuote": "Only those malfunctions shall be called out during the take-off run which may have a direct bearing on the decision to reject the take-off.",
    "sourceRects": [
      [
        105.82,
        231.26,
        552.77,
        242.26
      ],
      [
        105.82,
        244.26,
        552.71,
        255.26
      ],
      [
        105.82,
        257.26,
        218.73,
        268.26
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-245",
    "familyId": "oma8-en-245"
  },
  {
    "section": "8.4.1.10.3",
    "manualPage": "8.4-24",
    "pdfPage": 310,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "landing",
      "take-off",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Refer to OM-B QRH Ops Info for aircraft minimum allowable landing minima and OM-C for applicable airport/runway landing minima.",
    "sourceQuote": "Refer to OM-B QRH Ops Info for aircraft minimum allowable landing minima and OM-C for applicable airport/runway landing minima.",
    "sourceRects": [
      [
        77.48,
        403.26,
        524.36,
        414.26
      ],
      [
        77.48,
        416.26,
        243.42,
        427.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-246",
    "familyId": "oma8-en-246"
  },
  {
    "section": "8.4.1.10.5",
    "manualPage": "8.4-24",
    "pdfPage": 310,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: reported parameter",
    "choices": [
      "visibility",
      "RVR",
      "ceiling",
      "wind"
    ],
    "correctIndex": 0,
    "explanation": "Reference should, therefore, continue to be made to the instruments by both pilots if possible, but monitoring by the PM must continue to touchdown particularly in low visibility when the PF may wish to maintain uninterrupted visual reference.",
    "sourceQuote": "Reference should, therefore, continue to be made to the instruments by both pilots if possible, but monitoring by the PM must continue to touchdown particularly in low visibility when the PF may wish to maintain uninterrupted visual reference.",
    "sourceRects": [
      [
        77.48,
        721.27,
        524.36,
        733.26
      ],
      [
        77.48,
        735.26,
        524.43,
        746.26
      ],
      [
        77.48,
        748.26,
        524.32,
        759.26
      ],
      [
        77.48,
        761.26,
        493.02,
        772.26
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-247",
    "familyId": "oma8-en-247"
  },
  {
    "section": "8.4.1.11.1",
    "manualPage": "8.4-30",
    "pdfPage": 316,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "In the event of malfunction (other than those listed above) the Commander must decide whether a landing shall be made at the nearest suitable airport or whether the flight can safely proceed.",
    "sourceQuote": "In the event of malfunction (other than those listed above) the Commander must decide whether a landing shall be made at the nearest suitable airport or whether the flight can safely proceed.",
    "sourceRects": [
      [
        77.48,
        129.26,
        524.42,
        140.26
      ],
      [
        77.48,
        142.26,
        483.17,
        153.26
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-248",
    "familyId": "oma8-en-248"
  },
  {
    "section": "8.4.1.11.2",
    "manualPage": "8.4-30",
    "pdfPage": 316,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "take-off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Accordingly, the following policy shall apply: Engine fire warning An engine fire warning during take-off must be handled operationally in the same way as an engine failure on take-off.",
    "sourceQuote": "Accordingly, the following policy shall apply: Engine fire warning An engine fire warning during take-off must be handled operationally in the same way as an engine failure on take-off.",
    "sourceRects": [
      [
        77.48,
        550.25,
        279.97,
        561.25
      ],
      [
        77.48,
        569.25,
        165.29,
        580.25
      ],
      [
        77.48,
        588.26,
        524.42,
        599.26
      ],
      [
        77.48,
        601.26,
        524.32,
        612.26
      ],
      [
        77.48,
        614.26,
        190.62,
        625.26
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-249",
    "familyId": "oma8-en-249"
  },
  {
    "section": "8.4.2.8",
    "manualPage": "8.4-39",
    "pdfPage": 325,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "A pilot on an instrument approach may revert to a visual approach: If it is required by ATC separation procedures.",
    "sourceQuote": "A pilot on an instrument approach may revert to a visual approach: If it is required by ATC separation procedures.",
    "sourceRects": [
      [
        105.82,
        571.26,
        399.75,
        582.26
      ],
      [
        105.82,
        590.48,
        549.96,
        601.48
      ],
      [
        121.84,
        605.26,
        350.05,
        616.26
      ],
      [
        105.82,
        619.27,
        542.4,
        631.49
      ],
      [
        121.84,
        635.26,
        233.52,
        646.26
      ],
      [
        105.82,
        656.26,
        552.77,
        667.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-250",
    "familyId": "oma8-en-250"
  },
  {
    "section": "8.4.3.3.8",
    "manualPage": "8.4-47",
    "pdfPage": 333,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Only those facilities mentioned in Table below should be acceptable to be used to determine the effect of temporarily failed of downgraded equipment on the required RVR for CAT II/III approach operations.",
    "sourceQuote": "Only those facilities mentioned in Table below should be acceptable to be used to determine the effect of temporarily failed of downgraded equipment on the required RVR for CAT II/III approach operations.",
    "sourceRects": [
      [
        105.82,
        406.26,
        552.63,
        417.26
      ],
      [
        105.82,
        418.27,
        552.71,
        430.26
      ]
    ],
    "topic": "lvo",
    "id": "oma8-en-251",
    "familyId": "oma8-en-251"
  },
  {
    "section": "8.4.1.6.5",
    "manualPage": "8.4-10",
    "pdfPage": 296,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "take-off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "A full take-off briefing should be conducted on the first sector of the day, subsequent briefings should be limited to the specific aspects of each individual airport, runway, take-off and SID conditions.",
    "sourceQuote": "A full take-off briefing should be conducted on the first sector of the day, subsequent briefings should be limited to the specific aspects of each individual airport, runway, take-off and SID conditions.",
    "sourceRects": [
      [
        77.48,
        582.26,
        524.32,
        593.26
      ],
      [
        77.48,
        595.26,
        502.85,
        606.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-252",
    "familyId": "oma8-en-252"
  },
  {
    "section": "8.4.2.7",
    "manualPage": "8.4-38",
    "pdfPage": 324,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: \"A minimum obstacle clearance (MOC) of [VALUE] above all obstacles within this area shall be maintained at all times.",
    "choices": [
      "400 ft",
      "300 ft",
      "500 ft",
      "200 ft"
    ],
    "correctIndex": 0,
    "explanation": "\"A minimum obstacle clearance (MOC) of 400 ft above all obstacles within this area shall be maintained at all times.",
    "sourceQuote": "\"A minimum obstacle clearance (MOC) of 400 ft above all obstacles within this area shall be maintained at all times.",
    "sourceRects": [
      [
        77.47,
        301.48,
        502.28,
        312.48
      ],
      [
        93.49,
        316.26,
        195.84,
        327.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-253",
    "familyId": "oma8-en-253"
  },
  {
    "section": "8.4.3.1",
    "manualPage": "8.4-41",
    "pdfPage": 327,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: ILS Categories SA CAT I is an operational credit applied to a CAT I operation that allows the instrument segment of a CAT I approach to be extended to a minimum DH of [VALUE].",
    "choices": [
      "150 ft",
      "100 ft",
      "200 ft",
      "50 ft"
    ],
    "correctIndex": 0,
    "explanation": "ILS Categories SA CAT I is an operational credit applied to a CAT I operation that allows the instrument segment of a CAT I approach to be extended to a minimum DH of 150 ft.",
    "sourceQuote": "ILS Categories SA CAT I is an operational credit applied to a CAT I operation that allows the instrument segment of a CAT I approach to be extended to a minimum DH of 150 ft.",
    "sourceRects": [
      [
        105.82,
        155.26,
        172.02,
        166.26
      ],
      [
        105.82,
        174.49,
        549.92,
        185.49
      ],
      [
        121.84,
        189.26,
        404.42,
        200.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-254",
    "familyId": "oma8-en-254"
  },
  {
    "section": "8.4.3.1",
    "manualPage": "8.4-41",
    "pdfPage": 327,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: This provides an aircraft with a maximum wingspan of [VALUE], which is aligned with the runway, a safety margin to go around from 100 feet and below.",
    "choices": [
      "65 meters",
      "75 meters",
      "100 meters",
      "125 meters"
    ],
    "correctIndex": 0,
    "explanation": "This provides an aircraft with a maximum wingspan of 65 meters, which is aligned with the runway, a safety margin to go around from 100 feet and below.",
    "sourceQuote": "This provides an aircraft with a maximum wingspan of 65 meters, which is aligned with the runway, a safety margin to go around from 100 feet and below.",
    "sourceRects": [
      [
        105.82,
        648.26,
        552.63,
        659.26
      ],
      [
        105.82,
        661.26,
        552.67,
        672.26
      ],
      [
        105.82,
        674.26,
        410.24,
        685.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-255",
    "familyId": "oma8-en-255"
  },
  {
    "section": "8.4.3.2.4",
    "manualPage": "8.4-43",
    "pdfPage": 329,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Retains Auto-Approach & Auto-land Performance Survey records and analysis reports for a minimum period of [VALUE].",
    "choices": [
      "5 year",
      "4 year",
      "6 year",
      "7 year"
    ],
    "correctIndex": 0,
    "explanation": "Retains Auto-Approach & Auto-land Performance Survey records and analysis reports for a minimum period of 5 year.",
    "sourceQuote": "Retains Auto-Approach & Auto-land Performance Survey records and analysis reports for a minimum period of 5 year.",
    "sourceRects": [
      [
        105.82,
        270.52,
        551.46,
        281.52
      ],
      [
        121.84,
        285.29,
        425.78,
        296.29
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-256",
    "familyId": "oma8-en-256"
  },
  {
    "section": "8.4.3.3.1",
    "manualPage": "8.4-43",
    "pdfPage": 329,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "Fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "Fuel If taking off with marginal destination weather, careful consideration should be given to loading extra fuel for holding purposes.",
    "sourceQuote": "Fuel If taking off with marginal destination weather, careful consideration should be given to loading extra fuel for holding purposes.",
    "sourceRects": [
      [
        105.82,
        754.26,
        125.44,
        765.26
      ],
      [
        105.82,
        773.26,
        552.77,
        784.26
      ],
      [
        105.82,
        786.26,
        552.65,
        797.26
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-257",
    "familyId": "oma8-en-257"
  },
  {
    "section": "8.4.3.3.8",
    "manualPage": "8.4-47",
    "pdfPage": 333,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "If failures are announced before such a late stage in the approach, their effect on the approach should be considered as described in table below, and the approach may have to be abandoned.",
    "sourceQuote": "If failures are announced before such a late stage in the approach, their effect on the approach should be considered as described in table below, and the approach may have to be abandoned.",
    "sourceRects": [
      [
        105.82,
        361.26,
        552.77,
        372.26
      ],
      [
        105.82,
        374.26,
        552.77,
        385.26
      ],
      [
        105.82,
        387.26,
        268.65,
        398.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-258",
    "familyId": "oma8-en-258"
  },
  {
    "section": "8.4.1.2.2",
    "manualPage": "8.4-2",
    "pdfPage": 288,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "flight crew",
      "Commander",
      "First Officer",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "A preflight inspection of systems and equipment shall be performed by the flight crew any time after an aircraft has been left unattended by a flight crew for any period of time.",
    "sourceQuote": "A preflight inspection of systems and equipment shall be performed by the flight crew any time after an aircraft has been left unattended by a flight crew for any period of time.",
    "sourceRects": [
      [
        77.48,
        645.26,
        524.4,
        656.26
      ],
      [
        77.48,
        658.26,
        405.41,
        669.26
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-259",
    "familyId": "oma8-en-259"
  },
  {
    "section": "8.4.1.5.3",
    "manualPage": "8.4-7",
    "pdfPage": 293,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "landing",
      "take-off",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Readback of an hold short, crossing, takeoff or landing instruction shall always include the runway designator.",
    "sourceQuote": "Readback of an hold short, crossing, takeoff or landing instruction shall always include the runway designator.",
    "sourceRects": [
      [
        105.82,
        495.29,
        552.67,
        506.29
      ],
      [
        105.82,
        508.29,
        153.69,
        519.29
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-260",
    "familyId": "oma8-en-260"
  },
  {
    "section": "8.4.1.6.5",
    "manualPage": "8.4-10",
    "pdfPage": 296,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "take-off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "The takeoff briefing shall include the RTO procedure, any unusual aspect concerning the take-off and shall be completed before push-back.",
    "sourceQuote": "The takeoff briefing shall include the RTO procedure, any unusual aspect concerning the take-off and shall be completed before push-back.",
    "sourceRects": [
      [
        77.48,
        524.25,
        524.43,
        535.25
      ],
      [
        77.48,
        537.25,
        524.4,
        548.25
      ],
      [
        77.48,
        550.26,
        524.42,
        561.26
      ],
      [
        77.48,
        563.26,
        204.54,
        574.26
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-261",
    "familyId": "oma8-en-261"
  },
  {
    "section": "8.4.1.8.3",
    "manualPage": "8.4-14",
    "pdfPage": 300,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "The Commander shall be responsible to ascertain the condition of the runway by every reasonable means at his disposal.",
    "sourceQuote": "The Commander shall be responsible to ascertain the condition of the runway by every reasonable means at his disposal.",
    "sourceRects": [
      [
        77.48,
        365.26,
        524.43,
        376.26
      ],
      [
        77.48,
        378.26,
        173.34,
        389.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-262",
    "familyId": "oma8-en-262"
  },
  {
    "section": "8.4.1.8.3",
    "manualPage": "8.4-14",
    "pdfPage": 300,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "When there is uncertainty as to the accuracy of depth measurements and/or reliability of information available regarding the state of the runway, the final decision shall rest with the Commander.",
    "sourceQuote": "When there is uncertainty as to the accuracy of depth measurements and/or reliability of information available regarding the state of the runway, the final decision shall rest with the Commander.",
    "sourceRects": [
      [
        77.48,
        397.26,
        524.32,
        408.26
      ],
      [
        77.48,
        410.26,
        485.09,
        421.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-263",
    "familyId": "oma8-en-263"
  },
  {
    "section": "8.4.1.8.8",
    "manualPage": "8.4-15",
    "pdfPage": 301,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "take-off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Commence turn as directed This completes the Standard Engine Failure Procedure for which obstacle clearance is guaranteed for the maximum take-off weight for the given runway.",
    "sourceQuote": "Commence turn as directed This completes the Standard Engine Failure Procedure for which obstacle clearance is guaranteed for the maximum take-off weight for the given runway.",
    "sourceRects": [
      [
        105.82,
        707.52,
        242.3,
        718.52
      ],
      [
        105.82,
        728.28,
        552.75,
        739.28
      ],
      [
        105.82,
        741.29,
        333.21,
        752.29
      ]
    ],
    "topic": "mass-balance",
    "id": "oma8-en-264",
    "familyId": "oma8-en-264"
  },
  {
    "section": "8.4.1.9.9",
    "manualPage": "8.4-22",
    "pdfPage": 308,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "During descent below the altitudes specified above, the rate of descent shall for safety reasons not exceed half of the height above ground level or as required by the approach profile, e.g.",
    "sourceQuote": "During descent below the altitudes specified above, the rate of descent shall for safety reasons not exceed half of the height above ground level or as required by the approach profile, e.g.",
    "sourceRects": [
      [
        77.47,
        639.25,
        524.27,
        650.25
      ],
      [
        77.47,
        652.25,
        524.27,
        663.25
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-265",
    "familyId": "oma8-en-265"
  },
  {
    "section": "8.4.1.10.10",
    "manualPage": "8.4-27",
    "pdfPage": 313,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "landing",
      "take-off",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "When the flaps are in a position different from that required for the planned landing, the reader will advise \"Flap required to complete the checklist\".",
    "sourceQuote": "When the flaps are in a position different from that required for the planned landing, the reader will advise \"Flap required to complete the checklist\".",
    "sourceRects": [
      [
        105.82,
        586.27,
        552.62,
        597.27
      ],
      [
        105.82,
        599.28,
        319.53,
        610.28
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-266",
    "familyId": "oma8-en-266"
  },
  {
    "section": "8.4.1.10.11",
    "manualPage": "8.4-27",
    "pdfPage": 313,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "At airports equipped with high intensity approach and/or runway lights, due regard shall be paid to the possibility of glare from the lighting system.",
    "sourceQuote": "At airports equipped with high intensity approach and/or runway lights, due regard shall be paid to the possibility of glare from the lighting system.",
    "sourceRects": [
      [
        105.82,
        636.27,
        552.77,
        647.27
      ],
      [
        105.82,
        649.27,
        552.77,
        660.27
      ],
      [
        105.82,
        662.27,
        176.97,
        673.27
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-267",
    "familyId": "oma8-en-267"
  },
  {
    "section": "8.4.1.11.1",
    "manualPage": "8.4-30",
    "pdfPage": 316,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "take-off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "This must be verified if the occurrence arises during taxi, take-off or landing.",
    "sourceQuote": "This must be verified if the occurrence arises during taxi, take-off or landing.",
    "sourceRects": [
      [
        77.48,
        391.26,
        524.36,
        402.26
      ],
      [
        77.48,
        404.26,
        339.9,
        415.26
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-268",
    "familyId": "oma8-en-268"
  },
  {
    "section": "8.4.1.12.2",
    "manualPage": "8.4-32",
    "pdfPage": 318,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "Normally the dumping of fuel shall be conducted within an area selected by ATC for this purpose on request of the Commander.",
    "sourceQuote": "Normally the dumping of fuel shall be conducted within an area selected by ATC for this purpose on request of the Commander.",
    "sourceRects": [
      [
        77.47,
        310.25,
        524.32,
        321.25
      ],
      [
        77.47,
        323.25,
        524.28,
        334.25
      ],
      [
        77.47,
        336.25,
        457.01,
        347.25
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-269",
    "familyId": "oma8-en-269"
  },
  {
    "section": "8.4.1.12.2",
    "manualPage": "8.4-32",
    "pdfPage": 318,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "Whenever such an area cannot be assigned by ATC, the Commander shall select an area for fuel dumping where no hazard to persons or property will be caused.",
    "sourceQuote": "Whenever such an area cannot be assigned by ATC, the Commander shall select an area for fuel dumping where no hazard to persons or property will be caused.",
    "sourceRects": [
      [
        77.47,
        310.25,
        524.32,
        321.25
      ],
      [
        77.47,
        323.25,
        524.28,
        334.25
      ],
      [
        77.47,
        336.25,
        457.01,
        347.25
      ]
    ],
    "topic": "fuel",
    "id": "oma8-en-270",
    "familyId": "oma8-en-270"
  },
  {
    "section": "8.4.1.13.1",
    "manualPage": "8.4-32",
    "pdfPage": 318,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "landing",
      "take-off",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Normally, the maximum certified landing weight shall not be exceeded.",
    "sourceQuote": "Normally, the maximum certified landing weight shall not be exceeded.",
    "sourceRects": [
      [
        77.47,
        487.26,
        524.36,
        499.25
      ],
      [
        77.47,
        527.26,
        169.98,
        538.26
      ]
    ],
    "topic": "mass-balance",
    "id": "oma8-en-271",
    "familyId": "oma8-en-271"
  },
  {
    "section": "8.4.3.2.1",
    "manualPage": "8.4-42",
    "pdfPage": 328,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "Before conducting Low Visibility Operations (LVO), the Commander shall satisfy himself that the airplane is certificated for the intended operation and has not been downgraded.",
    "sourceQuote": "Before conducting Low Visibility Operations (LVO), the Commander shall satisfy himself that the airplane is certificated for the intended operation and has not been downgraded.",
    "sourceRects": [
      [
        77.48,
        288.26,
        524.43,
        299.26
      ],
      [
        77.48,
        301.26,
        524.36,
        312.26
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-272",
    "familyId": "oma8-en-272"
  },
  {
    "section": "8.4.3.2.1",
    "manualPage": "8.4-42",
    "pdfPage": 328,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "After a CAT II, CAT III or Autoland, the Commander shall ensure that the approach has been properly reported in the Aircraft Technical Log Book or via ACARS.",
    "sourceQuote": "After a CAT II, CAT III or Autoland, the Commander shall ensure that the approach has been properly reported in the Aircraft Technical Log Book or via ACARS.",
    "sourceRects": [
      [
        77.48,
        333.26,
        524.32,
        344.26
      ],
      [
        77.48,
        346.26,
        524.36,
        357.26
      ],
      [
        77.48,
        359.26,
        524.28,
        370.26
      ],
      [
        77.48,
        372.26,
        524.4,
        383.26
      ]
    ],
    "topic": "lvo",
    "id": "oma8-en-273",
    "familyId": "oma8-en-273"
  },
  {
    "section": "8.4.3.2.3",
    "manualPage": "8.4-42",
    "pdfPage": 328,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "Take-Off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "An airport shall not be used for LVO unless Low Visibility Procedures (LVPs) have been established for CAT II and III approaches and Low Visibility Take-Offs.",
    "sourceQuote": "An airport shall not be used for LVO unless Low Visibility Procedures (LVPs) have been established for CAT II and III approaches and Low Visibility Take-Offs.",
    "sourceRects": [
      [
        77.48,
        690.26,
        524.32,
        701.26
      ],
      [
        77.48,
        703.26,
        342.54,
        714.26
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-274",
    "familyId": "oma8-en-274"
  },
  {
    "section": "8.4.3.3.1",
    "manualPage": "8.4-43",
    "pdfPage": 329,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "Alternate destination airport Normally, one alternate airport shall be specified in the operational flight plan.",
    "sourceQuote": "Alternate destination airport Normally, one alternate airport shall be specified in the operational flight plan.",
    "sourceRects": [
      [
        105.82,
        505.26,
        229.6,
        516.26
      ],
      [
        105.82,
        524.26,
        450.8,
        535.26
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-275",
    "familyId": "oma8-en-275"
  },
  {
    "section": "8.5.7.1",
    "manualPage": "8.5-16",
    "pdfPage": 353,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: type of aerodrome",
    "choices": [
      "en-route alternate",
      "destination alternate",
      "take-off alternate",
      "departure airport"
    ],
    "correctIndex": 0,
    "explanation": "ALTERNATE AERODROMES To conduct an ETOPS flight, the ETOPS en-route alternate aerodromes, shall meet the weather requirements of planning minima for an ETOPS en-route alternate aerodromes contained in this chapter.",
    "sourceQuote": "ALTERNATE AERODROMES To conduct an ETOPS flight, the ETOPS en-route alternate aerodromes, shall meet the weather requirements of planning minima for an ETOPS en-route alternate aerodromes contained in this chapter.",
    "sourceRects": [
      [
        77.48,
        437.85,
        226.15,
        448.85
      ],
      [
        77.48,
        456.62,
        524.4,
        467.62
      ],
      [
        77.48,
        468.63,
        524.36,
        480.62
      ],
      [
        77.48,
        482.62,
        524.43,
        493.62
      ]
    ],
    "topic": "etops",
    "id": "oma8-en-276",
    "familyId": "oma8-en-276"
  },
  {
    "section": "8.5.3.3",
    "manualPage": "8.5-6",
    "pdfPage": 343,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "flight crew",
      "Commander",
      "First Officer",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "The objective of the ETOPS check program shall ensure standardized flight crew practices and procedures and should also emphasize the special nature of ETOPS operations.",
    "sourceQuote": "The objective of the ETOPS check program shall ensure standardized flight crew practices and procedures and should also emphasize the special nature of ETOPS operations.",
    "sourceRects": [
      [
        77.47,
        127.25,
        524.36,
        138.25
      ],
      [
        77.47,
        139.27,
        524.36,
        151.26
      ],
      [
        77.47,
        153.26,
        524.4,
        164.26
      ],
      [
        77.47,
        166.26,
        487.4,
        177.26
      ]
    ],
    "topic": "etops",
    "id": "oma8-en-277",
    "familyId": "oma8-en-277"
  },
  {
    "section": "8.5.6.4.2",
    "manualPage": "8.5-10",
    "pdfPage": 347,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: reported parameter",
    "choices": [
      "wind",
      "RVR",
      "visibility",
      "ceiling"
    ],
    "correctIndex": 0,
    "explanation": "BECMG Deterioration of of of according with exceeding wind May wind of the (TAF be required start required start of OF the fully BECMG limits the the TAF should from be should of from (alone), TAF AND of prevailing disrethe policy TAF.",
    "sourceQuote": "BECMG Deterioration of of of according with exceeding wind May wind of the (TAF be required start required start of OF the fully BECMG limits the the TAF should from be should of from (alone), TAF AND of prevailing disrethe policy TAF.",
    "sourceRects": [
      [
        384.14,
        300.67,
        392.14,
        330.88
      ],
      [
        354.65,
        307.34,
        481.33,
        359.04
      ],
      [
        147.34,
        313.01,
        441.34,
        347.84
      ],
      [
        84.68,
        316.29,
        512.64,
        351.69
      ],
      [
        63.68,
        320.54,
        496.81,
        347.91
      ],
      [
        444.33,
        324.59,
        453.33,
        335.58
      ],
      [
        63.68,
        328.03,
        382.14,
        358.23
      ],
      [
        74.18,
        331.19,
        481.33,
        351.71
      ],
      [
        111.17,
        333.99,
        512.64,
        359.01
      ],
      [
        147.34,
        338.98,
        453.33,
        374.14
      ],
      [
        207.82,
        342.61,
        469.34,
        366.89
      ]
    ],
    "topic": "etops",
    "id": "oma8-en-278",
    "familyId": "oma8-en-278"
  },
  {
    "section": "8.5.5.2",
    "manualPage": "8.5-7",
    "pdfPage": 344,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: However, flight crews should be aware that Silk Way West Airlines ETOPS authorized aircraft have fire suppression for [VALUE] in the lower holds and the main deck is class E approved, a prompt decision regarding diversion is required.",
    "choices": [
      "195 minutes",
      "120 minutes",
      "90 minutes",
      "60 minutes"
    ],
    "correctIndex": 0,
    "explanation": "However, flight crews should be aware that Silk Way West Airlines ETOPS authorized aircraft have fire suppression for 195 minutes in the lower holds and the main deck is class E approved, a prompt decision regarding diversion is required.",
    "sourceQuote": "However, flight crews should be aware that Silk Way West Airlines ETOPS authorized aircraft have fire suppression for 195 minutes in the lower holds and the main deck is class E approved, a prompt decision regarding diversion is required.",
    "sourceRects": [
      [
        105.82,
        226.5,
        157.27,
        237.5
      ],
      [
        105.82,
        245.26,
        552.62,
        256.26
      ],
      [
        105.82,
        258.26,
        552.77,
        269.26
      ],
      [
        105.82,
        271.27,
        463.52,
        282.27
      ]
    ],
    "topic": "etops",
    "id": "oma8-en-279",
    "familyId": "oma8-en-279"
  },
  {
    "section": "8.5.1.2",
    "manualPage": "8.5-4",
    "pdfPage": 341,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "cruise",
      "take-off",
      "landing",
      "approach"
    ],
    "correctIndex": 0,
    "explanation": "ETOPS maximum diversion distance Is the approved ETOPS maximum diversion time at the approved OEI cruise speed, or in the case of aeroplanes with more than two engines the approved AEO cruise speed, used throughout the flight profile.",
    "sourceQuote": "ETOPS maximum diversion distance Is the approved ETOPS maximum diversion time at the approved OEI cruise speed, or in the case of aeroplanes with more than two engines the approved AEO cruise speed, used throughout the flight profile.",
    "sourceRects": [
      [
        77.48,
        110.49,
        250.84,
        121.49
      ],
      [
        77.48,
        129.26,
        524.4,
        140.26
      ],
      [
        77.48,
        142.26,
        524.28,
        153.26
      ],
      [
        77.48,
        155.26,
        109.51,
        166.26
      ]
    ],
    "topic": "etops",
    "id": "oma8-en-280",
    "familyId": "oma8-en-280"
  },
  {
    "section": "8.5.6.4.2",
    "manualPage": "8.5-10",
    "pdfPage": 347,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "TAKE-OFF",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "The applicability of forecast changes and trends shall be assessed in accordance with NATE ETOPS NATE TAKE-OFF at DEST.ALTERNATE NATE ENROUTE ±1 Destination APPLICATION Aerodrome TAF ETA HR Table 2 below.",
    "sourceQuote": "The applicability of forecast changes and trends shall be assessed in accordance with NATE ETOPS NATE TAKE-OFF at DEST.ALTERNATE NATE ENROUTE ±1 Destination APPLICATION Aerodrome TAF ETA HR Table 2 below.",
    "sourceRects": [
      [
        77.48,
        109.27,
        505.29,
        121.26
      ],
      [
        77.48,
        125.26,
        521.68,
        136.26
      ],
      [
        147.33,
        128.78,
        512.64,
        199.82
      ],
      [
        378.33,
        133.39,
        397.32,
        172.1
      ],
      [
        197.32,
        137.02,
        286.31,
        152.86
      ],
      [
        77.48,
        140.27,
        511.6,
        151.27
      ]
    ],
    "topic": "etops",
    "id": "oma8-en-281",
    "familyId": "oma8-en-281"
  },
  {
    "section": "8.5.7.1",
    "manualPage": "8.5-14",
    "pdfPage": 351,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "flight crew",
      "Commander",
      "First Officer",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "In order to dispatch ETOPS flight the following must be fulfilled: The flight crew must be qualified.",
    "sourceQuote": "In order to dispatch ETOPS flight the following must be fulfilled: The flight crew must be qualified.",
    "sourceRects": [
      [
        77.48,
        488.2,
        365.89,
        499.2
      ],
      [
        77.48,
        507.43,
        242.88,
        518.43
      ]
    ],
    "topic": "etops",
    "id": "oma8-en-282",
    "familyId": "oma8-en-282"
  },
  {
    "section": "8.5.6.1",
    "manualPage": "8.5-8",
    "pdfPage": 345,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "It is the commander's responsibility to confirm that ETOPS maintenance checks are completed and consider in particular any MEL items which may affect ETOPS flight planning.",
    "sourceQuote": "It is the commander's responsibility to confirm that ETOPS maintenance checks are completed and consider in particular any MEL items which may affect ETOPS flight planning.",
    "sourceRects": [
      [
        77.48,
        311.31,
        524.32,
        322.31
      ],
      [
        77.48,
        324.31,
        427.01,
        335.31
      ]
    ],
    "topic": "etops",
    "id": "oma8-en-283",
    "familyId": "oma8-en-283"
  },
  {
    "section": "8.5.7.1",
    "manualPage": "8.5-14",
    "pdfPage": 351,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: type of aerodrome",
    "choices": [
      "en-route alternate",
      "destination alternate",
      "take-off alternate",
      "departure airport"
    ],
    "correctIndex": 0,
    "explanation": "The appropriate sections of the applicable OM-B contains reference charts for fuel required versus gross weight and air distance to the en-route alternate.",
    "sourceQuote": "The appropriate sections of the applicable OM-B contains reference charts for fuel required versus gross weight and air distance to the en-route alternate.",
    "sourceRects": [
      [
        77.48,
        658.19,
        524.3,
        669.19
      ],
      [
        77.48,
        671.19,
        315.18,
        682.19
      ]
    ],
    "topic": "etops",
    "id": "oma8-en-284",
    "familyId": "oma8-en-284"
  },
  {
    "section": "8.5.7.1",
    "manualPage": "8.5-15",
    "pdfPage": 352,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "fuel",
      "oil",
      "oxygen",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "Note 3: If an APU is one of the required power sources, then its fuel consumption should be accounted for during the appropriate phases of flight.",
    "sourceQuote": "Note 3: If an APU is one of the required power sources, then its fuel consumption should be accounted for during the appropriate phases of flight.",
    "sourceRects": [
      [
        105.82,
        616.48,
        139.73,
        627.48
      ],
      [
        105.82,
        635.25,
        552.75,
        646.25
      ],
      [
        105.82,
        648.25,
        276.57,
        659.25
      ]
    ],
    "topic": "etops",
    "id": "oma8-en-285",
    "familyId": "oma8-en-285"
  },
  {
    "section": "8.5.7.2",
    "manualPage": "8.5-16",
    "pdfPage": 353,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "If it is not possible to obtain a route which remains within an ETOPS area, the flight must be delayed if planning via non ETOPS route is not possible.",
    "sourceQuote": "If it is not possible to obtain a route which remains within an ETOPS area, the flight must be delayed if planning via non ETOPS route is not possible.",
    "sourceRects": [
      [
        77.48,
        724.62,
        524.43,
        735.62
      ],
      [
        77.48,
        737.62,
        524.22,
        748.62
      ],
      [
        77.48,
        750.62,
        168.3,
        761.62
      ]
    ],
    "topic": "etops",
    "id": "oma8-en-286",
    "familyId": "oma8-en-286"
  },
  {
    "section": "8.5.7.4",
    "manualPage": "8.5-18",
    "pdfPage": 355,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: type of aerodrome",
    "choices": [
      "en-route alternate",
      "destination alternate",
      "take-off alternate",
      "departure airport"
    ],
    "correctIndex": 0,
    "explanation": "In the event this is not possible, the next nearest en-route alternate aerodrome should be selected provided the diversion time does not exceed the maximum approved diversion time.",
    "sourceQuote": "In the event this is not possible, the next nearest en-route alternate aerodrome should be selected provided the diversion time does not exceed the maximum approved diversion time.",
    "sourceRects": [
      [
        77.48,
        110.26,
        524.42,
        121.26
      ],
      [
        77.48,
        123.26,
        524.26,
        134.26
      ],
      [
        77.48,
        136.26,
        524.28,
        147.26
      ]
    ],
    "topic": "etops",
    "id": "oma8-en-287",
    "familyId": "oma8-en-287"
  },
  {
    "section": "8.5.7.1",
    "manualPage": "8.5-15",
    "pdfPage": 352,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Upon reaching the alternate, hold at [VALUE] above field elevation for 15 minutes and then conduct an instrument approach and landing.",
    "choices": [
      "1500 ft",
      "1000 ft",
      "2000 ft",
      "700 ft"
    ],
    "correctIndex": 0,
    "explanation": "Upon reaching the alternate, hold at 1500 ft above field elevation for 15 minutes and then conduct an instrument approach and landing.",
    "sourceQuote": "Upon reaching the alternate, hold at 1500 ft above field elevation for 15 minutes and then conduct an instrument approach and landing.",
    "sourceRects": [
      [
        105.82,
        180.25,
        552.67,
        191.25
      ],
      [
        105.82,
        193.25,
        252.81,
        204.25
      ]
    ],
    "topic": "etops",
    "id": "oma8-en-288",
    "familyId": "oma8-en-288"
  },
  {
    "section": "8.5.7.4",
    "manualPage": "8.5-18",
    "pdfPage": 355,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Fuel checks on burn-off and fuel remaining should be made at each waypoint, 10° LATITUDE or every [VALUE], whichever is shorter.",
    "choices": [
      "60 minutes",
      "45 minutes",
      "30 minutes",
      "90 minutes"
    ],
    "correctIndex": 0,
    "explanation": "Fuel checks on burn-off and fuel remaining should be made at each waypoint, 10° LATITUDE or every 60 minutes, whichever is shorter.",
    "sourceQuote": "Fuel checks on burn-off and fuel remaining should be made at each waypoint, 10° LATITUDE or every 60 minutes, whichever is shorter.",
    "sourceRects": [
      [
        77.48,
        547.3,
        524.41,
        558.3
      ],
      [
        77.48,
        560.3,
        249.9,
        571.3
      ]
    ],
    "topic": "etops",
    "id": "oma8-en-289",
    "familyId": "oma8-en-289"
  },
  {
    "section": "8.5.1.1",
    "manualPage": "8.5-1",
    "pdfPage": 338,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: That distance for B-777 is normally [VALUE] based on 310 tons diversion weight, MCT (maximum continuous thrust), IAS 322, FL180.",
    "choices": [
      "832 nm",
      "240 nm",
      "180 nm",
      "120 nm"
    ],
    "correctIndex": 0,
    "explanation": "That distance for B-777 is normally 832 nm based on 310 tons diversion weight, MCT (maximum continuous thrust), IAS 322, FL180.",
    "sourceQuote": "That distance for B-777 is normally 832 nm based on 310 tons diversion weight, MCT (maximum continuous thrust), IAS 322, FL180.",
    "sourceRects": [
      [
        105.82,
        263.25,
        552.6,
        274.25
      ],
      [
        105.82,
        276.25,
        265.52,
        287.25
      ]
    ],
    "topic": "etops",
    "id": "oma8-en-290",
    "familyId": "oma8-en-290"
  },
  {
    "section": "8.5.1.2",
    "manualPage": "8.5-5",
    "pdfPage": 342,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: The maximum threshold time approved by SCAA is [VALUE].",
    "choices": [
      "180 minutes",
      "120 minutes",
      "90 minutes",
      "60 minutes"
    ],
    "correctIndex": 0,
    "explanation": "The maximum threshold time approved by SCAA is 180 minutes.",
    "sourceQuote": "The maximum threshold time approved by SCAA is 180 minutes.",
    "sourceRects": [
      [
        105.82,
        244.27,
        552.71,
        256.26
      ],
      [
        105.82,
        258.26,
        417.44,
        269.26
      ]
    ],
    "topic": "etops",
    "id": "oma8-en-291",
    "familyId": "oma8-en-291"
  },
  {
    "section": "8.5.7.4",
    "manualPage": "8.5-17",
    "pdfPage": 354,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "flight crew",
      "Commander",
      "First Officer",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "During the flight, the flight crew should remain informed of any significant changes in conditions at designated ETOPS en-route alternate aerodromes.",
    "sourceQuote": "During the flight, the flight crew should remain informed of any significant changes in conditions at designated ETOPS en-route alternate aerodromes.",
    "sourceRects": [
      [
        105.82,
        708.24,
        552.62,
        719.24
      ],
      [
        105.82,
        721.24,
        552.63,
        732.24
      ],
      [
        105.82,
        747.25,
        552.71,
        758.25
      ]
    ],
    "topic": "etops",
    "id": "oma8-en-292",
    "familyId": "oma8-en-292"
  },
  {
    "section": "8.5.7.4",
    "manualPage": "8.5-17",
    "pdfPage": 354,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: type of aerodrome",
    "choices": [
      "en-route alternate",
      "destination alternate",
      "take-off alternate",
      "departure airport"
    ],
    "correctIndex": 0,
    "explanation": "Prior to the ETOPS Entry Point, the forecast weather, established aircraft status, fuel remaining, and where possible field conditions and aerodrome services and facilities at designated ETOPS en-route alternates are to be evaluated.",
    "sourceQuote": "Prior to the ETOPS Entry Point, the forecast weather, established aircraft status, fuel remaining, and where possible field conditions and aerodrome services and facilities at designated ETOPS en-route alternates are to be evaluated.",
    "sourceRects": [
      [
        105.82,
        708.24,
        552.62,
        719.24
      ],
      [
        105.82,
        721.24,
        552.63,
        732.24
      ],
      [
        105.82,
        733.26,
        552.71,
        745.25
      ],
      [
        105.82,
        747.25,
        552.71,
        758.25
      ]
    ],
    "topic": "etops",
    "id": "oma8-en-293",
    "familyId": "oma8-en-293"
  },
  {
    "section": "8.5.7.4",
    "manualPage": "8.5-18",
    "pdfPage": 355,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "Approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "ETOPS En-route Monitoring Procedure a) Approaching the ETOPS area: Check fuel remaining commensurate with the OFP fuel.",
    "sourceQuote": "ETOPS En-route Monitoring Procedure a) Approaching the ETOPS area: Check fuel remaining commensurate with the OFP fuel.",
    "sourceRects": [
      [
        77.48,
        168.26,
        252.04,
        179.26
      ],
      [
        77.48,
        187.26,
        237.79,
        198.49
      ],
      [
        77.48,
        208.49,
        338.87,
        219.49
      ]
    ],
    "topic": "etops",
    "id": "oma8-en-294",
    "familyId": "oma8-en-294"
  },
  {
    "section": "8.5.1.2",
    "manualPage": "8.5-1",
    "pdfPage": 338,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "The AEO speed may be different from the speed used for the maximum diversion time and threshold time.",
    "sourceQuote": "The AEO speed may be different from the speed used for the maximum diversion time and threshold time.",
    "sourceRects": [
      [
        105.82,
        569.26,
        552.77,
        580.26
      ],
      [
        105.82,
        582.26,
        552.6,
        593.26
      ],
      [
        105.82,
        595.27,
        402.08,
        606.27
      ]
    ],
    "topic": "etops",
    "id": "oma8-en-295",
    "familyId": "oma8-en-295"
  },
  {
    "section": "8.6.5",
    "manualPage": "8.6-2",
    "pdfPage": 361,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "flight crew",
      "Commander",
      "First Officer",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "Whenever flight crew is required to sign off a defect in accordance with the MEL they should sign off the defect in accordance with instructions from the Maintenance department.",
    "sourceQuote": "Whenever flight crew is required to sign off a defect in accordance with the MEL they should sign off the defect in accordance with instructions from the Maintenance department.",
    "sourceRects": [
      [
        77.51,
        707.26,
        524.44,
        718.26
      ],
      [
        77.51,
        720.26,
        414.81,
        731.26
      ]
    ],
    "topic": "mel",
    "id": "oma8-en-296",
    "familyId": "oma8-en-296"
  },
  {
    "section": "8.6.2",
    "manualPage": "8.6-1",
    "pdfPage": 360,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: MEL amendments shall be implemented within the timescale acceptable to the Authority, typically not later than [VALUE] from the date of the MMEL/DDG update unless otherwise directed.",
    "choices": [
      "90 days",
      "60 days",
      "30 days",
      "14 days"
    ],
    "correctIndex": 0,
    "explanation": "MEL amendments shall be implemented within the timescale acceptable to the Authority, typically not later than 90 days from the date of the MMEL/DDG update unless otherwise directed.",
    "sourceQuote": "MEL amendments shall be implemented within the timescale acceptable to the Authority, typically not later than 90 days from the date of the MMEL/DDG update unless otherwise directed.",
    "sourceRects": [
      [
        105.84,
        705.25,
        552.69,
        716.25
      ],
      [
        105.84,
        718.25,
        500.98,
        729.25
      ]
    ],
    "topic": "mel",
    "id": "oma8-en-297",
    "familyId": "oma8-en-297"
  },
  {
    "section": "8.6.2",
    "manualPage": "8.6-1",
    "pdfPage": 360,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "MEL Amendment Process and Control The Operator ensures that the MEL remains fully aligned with the current Master Minimum Equipment List (MMEL) and relevant Dispatch Deviation Guides (DDG).",
    "sourceQuote": "MEL Amendment Process and Control The Operator ensures that the MEL remains fully aligned with the current Master Minimum Equipment List (MMEL) and relevant Dispatch Deviation Guides (DDG).",
    "sourceRects": [
      [
        105.84,
        539.26,
        276.41,
        550.26
      ],
      [
        105.84,
        558.25,
        552.73,
        569.25
      ],
      [
        105.84,
        571.26,
        405.7,
        582.26
      ]
    ],
    "topic": "mel",
    "id": "oma8-en-298",
    "familyId": "oma8-en-298"
  },
  {
    "section": "8.6.2",
    "manualPage": "8.6-2",
    "pdfPage": 361,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "Interim use of generic or uncustomized MEL provisions is not permitted; all MEL entries must reflect Operator-specific operational and maintenance procedures.",
    "sourceQuote": "Interim use of generic or uncustomized MEL provisions is not permitted; all MEL entries must reflect Operator-specific operational and maintenance procedures.",
    "sourceRects": [
      [
        77.48,
        110.26,
        524.28,
        121.26
      ],
      [
        77.48,
        123.26,
        336.78,
        134.26
      ]
    ],
    "topic": "mel",
    "id": "oma8-en-299",
    "familyId": "oma8-en-299"
  },
  {
    "section": "8.6.3",
    "manualPage": "8.6-2",
    "pdfPage": 361,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "The MEL and CDL contain only those items required by Operating Regulations or those items of airworthiness significance which may be inoperative prior to dispatch, provided that appropriate limitations and procedures are observed.",
    "sourceQuote": "The MEL and CDL contain only those items required by Operating Regulations or those items of airworthiness significance which may be inoperative prior to dispatch, provided that appropriate limitations and procedures are observed.",
    "sourceRects": [
      [
        77.49,
        231.25,
        524.37,
        242.25
      ],
      [
        77.49,
        244.25,
        524.37,
        255.25
      ],
      [
        77.49,
        257.25,
        524.22,
        268.25
      ],
      [
        77.49,
        270.25,
        524.31,
        281.25
      ]
    ],
    "topic": "mel",
    "id": "oma8-en-300",
    "familyId": "oma8-en-300"
  },
  {
    "section": "8.6.4",
    "manualPage": "8.6-2",
    "pdfPage": 361,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "The Commander may request requirements above the minimum listed, whenever in his judgement such added equipment is essential to the safety of a particular flight under the special conditions prevailing at the time.",
    "sourceQuote": "The Commander may request requirements above the minimum listed, whenever in his judgement such added equipment is essential to the safety of a particular flight under the special conditions prevailing at the time.",
    "sourceRects": [
      [
        77.5,
        353.25,
        524.34,
        364.25
      ],
      [
        77.5,
        366.25,
        524.3,
        377.25
      ],
      [
        77.5,
        379.25,
        524.3,
        390.25
      ],
      [
        77.5,
        392.26,
        446.95,
        403.26
      ]
    ],
    "topic": "mel",
    "id": "oma8-en-301",
    "familyId": "oma8-en-301"
  },
  {
    "section": "8.6.5",
    "manualPage": "8.6-2",
    "pdfPage": 361,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "flight crew",
      "Commander",
      "First Officer",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "Whenever malfunctions are not cleared prior dispatch, the flight crew shall verify whether a dispatch is permitted according to MEL and possible operational impact.",
    "sourceQuote": "Whenever malfunctions are not cleared prior dispatch, the flight crew shall verify whether a dispatch is permitted according to MEL and possible operational impact.",
    "sourceRects": [
      [
        77.51,
        559.26,
        524.35,
        570.26
      ],
      [
        77.51,
        572.26,
        357.45,
        583.26
      ]
    ],
    "topic": "mel",
    "id": "oma8-en-302",
    "familyId": "oma8-en-302"
  },
  {
    "section": "8.6.6",
    "manualPage": "8.6-3",
    "pdfPage": 362,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "The Commander must be informed by maintenance as soon as practicable, should it be impossible to repair the inoperative item prior to departure.",
    "sourceQuote": "The Commander must be informed by maintenance as soon as practicable, should it be impossible to repair the inoperative item prior to departure.",
    "sourceRects": [
      [
        105.82,
        109.27,
        552.71,
        121.26
      ],
      [
        105.82,
        123.26,
        552.77,
        134.26
      ],
      [
        105.82,
        136.26,
        552.67,
        147.26
      ],
      [
        105.82,
        149.27,
        552.75,
        160.27
      ]
    ],
    "topic": "mel",
    "id": "oma8-en-303",
    "familyId": "oma8-en-303"
  },
  {
    "section": "8.6.10",
    "manualPage": "8.6-4",
    "pdfPage": 363,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: system selection",
    "choices": [
      "on",
      "OFF",
      "AUTO",
      "STANDBY"
    ],
    "correctIndex": 0,
    "explanation": "Inoperative items or components, deferred in accordance with the MEL, must be rectified at or prior to the rectification intervals established by the following letter designators given in the \"Interval\" column of the MEL.",
    "sourceQuote": "Inoperative items or components, deferred in accordance with the MEL, must be rectified at or prior to the rectification intervals established by the following letter designators given in the \"Interval\" column of the MEL.",
    "sourceRects": [
      [
        77.48,
        129.26,
        524.41,
        140.26
      ],
      [
        77.48,
        142.26,
        524.37,
        153.26
      ],
      [
        77.48,
        155.26,
        153.67,
        166.26
      ]
    ],
    "topic": "mel",
    "id": "oma8-en-304",
    "familyId": "oma8-en-304"
  },
  {
    "section": "8.6.10",
    "manualPage": "8.6-4",
    "pdfPage": 363,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Category B Items in this category shall be repaired within three (3) consecutive calendar days ([VALUE]), excluding the day of discovery.",
    "choices": [
      "72 hours",
      "48 hours",
      "36 hours",
      "24 hours"
    ],
    "correctIndex": 0,
    "explanation": "Category B Items in this category shall be repaired within three (3) consecutive calendar days (72 hours), excluding the day of discovery.",
    "sourceQuote": "Category B Items in this category shall be repaired within three (3) consecutive calendar days (72 hours), excluding the day of discovery.",
    "sourceRects": [
      [
        77.48,
        257.26,
        127.77,
        268.26
      ],
      [
        77.48,
        276.26,
        524.36,
        287.26
      ],
      [
        77.48,
        289.26,
        524.32,
        300.26
      ]
    ],
    "topic": "mel",
    "id": "oma8-en-305",
    "familyId": "oma8-en-305"
  },
  {
    "section": "8.6.10",
    "manualPage": "8.6-4",
    "pdfPage": 363,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Category C Items in this category shall be repaired within ten (10) consecutive calendar days ([VALUE]), excluding the day of discovery.",
    "choices": [
      "240 hours",
      "72 hours",
      "48 hours",
      "36 hours"
    ],
    "correctIndex": 0,
    "explanation": "Category C Items in this category shall be repaired within ten (10) consecutive calendar days (240 hours), excluding the day of discovery.",
    "sourceQuote": "Category C Items in this category shall be repaired within ten (10) consecutive calendar days (240 hours), excluding the day of discovery.",
    "sourceRects": [
      [
        77.48,
        321.26,
        127.77,
        332.26
      ],
      [
        77.48,
        340.26,
        524.36,
        351.26
      ],
      [
        77.48,
        352.27,
        524.36,
        364.26
      ]
    ],
    "topic": "mel",
    "id": "oma8-en-306",
    "familyId": "oma8-en-306"
  },
  {
    "section": "8.6.10",
    "manualPage": "8.6-4",
    "pdfPage": 363,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Category D Items in this category shall be repaired within one hundred and twenty (120) consecutive calendar days ([VALUE]), excluding the day of discovery.",
    "choices": [
      "2880 hours",
      "72 hours",
      "48 hours",
      "36 hours"
    ],
    "correctIndex": 0,
    "explanation": "Category D Items in this category shall be repaired within one hundred and twenty (120) consecutive calendar days (2880 hours), excluding the day of discovery.",
    "sourceQuote": "Category D Items in this category shall be repaired within one hundred and twenty (120) consecutive calendar days (2880 hours), excluding the day of discovery.",
    "sourceRects": [
      [
        77.48,
        385.26,
        128.38,
        396.26
      ],
      [
        77.48,
        404.26,
        524.4,
        415.26
      ],
      [
        77.48,
        417.26,
        299.82,
        428.26
      ]
    ],
    "topic": "mel",
    "id": "oma8-en-307",
    "familyId": "oma8-en-307"
  },
  {
    "section": "8.7.6.1",
    "manualPage": "8.7-2",
    "pdfPage": 367,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "flight crew",
      "Commander",
      "First Officer",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "The crew shall include only the minimum required flight crew of the stranded airplane and the ferry Commander if the stranded Commander does not have the required qualifications.",
    "sourceQuote": "The crew shall include only the minimum required flight crew of the stranded airplane and the ferry Commander if the stranded Commander does not have the required qualifications.",
    "sourceRects": [
      [
        77.48,
        620.26,
        101.26,
        631.26
      ],
      [
        77.48,
        639.26,
        524.42,
        650.26
      ],
      [
        77.48,
        652.26,
        524.36,
        663.26
      ],
      [
        77.48,
        664.27,
        524.36,
        676.26
      ],
      [
        77.48,
        678.26,
        294.3,
        689.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-308",
    "familyId": "oma8-en-308"
  },
  {
    "section": "8.7.2",
    "manualPage": "8.7-1",
    "pdfPage": 366,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Flight crew",
      "Commander",
      "First Officer",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "Flight crew qualification and training requirements may affect actual take-off and approach minimum.",
    "sourceQuote": "Flight crew qualification and training requirements may affect actual take-off and approach minimum.",
    "sourceRects": [
      [
        105.84,
        314.25,
        552.68,
        325.25
      ],
      [
        105.84,
        327.25,
        552.68,
        338.25
      ],
      [
        105.84,
        340.26,
        184.43,
        351.26
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-309",
    "familyId": "oma8-en-309"
  },
  {
    "section": "8.7.6.3",
    "manualPage": "8.7-3",
    "pdfPage": 368,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "take-off",
      "landing",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Weather and runway conditions (see below) Approval from authorities (see below) Time of take-off, night/day It shall be ascertained that no objections by the local authorities are raised to a one engine inoperative ferry take-off.",
    "sourceQuote": "Weather and runway conditions (see below) Approval from authorities (see below) Time of take-off, night/day It shall be ascertained that no objections by the local authorities are raised to a one engine inoperative ferry take-off.",
    "sourceRects": [
      [
        105.82,
        217.28,
        314.61,
        228.51
      ],
      [
        105.82,
        232.28,
        290.14,
        243.51
      ],
      [
        105.82,
        247.29,
        240.86,
        258.52
      ],
      [
        105.82,
        268.29,
        552.77,
        279.29
      ],
      [
        105.82,
        281.29,
        552.75,
        292.29
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-310",
    "familyId": "oma8-en-310"
  },
  {
    "section": "8.8.1",
    "manualPage": "8.8-1",
    "pdfPage": 372,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "flight crew",
      "Commander",
      "First Officer",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "Each member of the flight crew on flight deck duty shall have: An oxygen mask located within his immediate reach while at his duty station.",
    "sourceQuote": "Each member of the flight crew on flight deck duty shall have: An oxygen mask located within his immediate reach while at his duty station.",
    "sourceRects": [
      [
        105.83,
        186.26,
        381.28,
        197.26
      ],
      [
        105.83,
        205.48,
        537.71,
        216.48
      ],
      [
        121.85,
        220.26,
        441.6,
        231.26
      ],
      [
        105.83,
        235.49,
        542.29,
        246.49
      ]
    ],
    "topic": "oxygen",
    "id": "oma8-en-311",
    "familyId": "oma8-en-311"
  },
  {
    "section": "8.8.4",
    "manualPage": "8.8-1",
    "pdfPage": 372,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: aircraft resource",
    "choices": [
      "Oxygen",
      "fuel",
      "oil",
      "hydraulic fluid"
    ],
    "correctIndex": 0,
    "explanation": "For detailed description of the Oxygen Systems, PBE and Portable Oxygen Bottle refer to OM-B, FCOM Vol.",
    "sourceQuote": "For detailed description of the Oxygen Systems, PBE and Portable Oxygen Bottle refer to OM-B, FCOM Vol.",
    "sourceRects": [
      [
        105.87,
        693.32,
        552.84,
        704.32
      ],
      [
        105.87,
        706.32,
        409.08,
        717.32
      ]
    ],
    "topic": "oxygen",
    "id": "oma8-en-312",
    "familyId": "oma8-en-312"
  },
  {
    "section": "8.7.3",
    "manualPage": "8.7-1",
    "pdfPage": 366,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: Unless authorized by the NP Flight Operations, technical check flights involving circuit maneuvers only shall be restricted to ceiling of [VALUE] and 5 km visibility and technical check flights for high altitude maneuvers shall be operated in daylight only.",
    "choices": [
      "1500 feet",
      "1000 feet",
      "2000 feet",
      "700 feet"
    ],
    "correctIndex": 0,
    "explanation": "Unless authorized by the NP Flight Operations, technical check flights involving circuit maneuvers only shall be restricted to ceiling of 1500 feet and 5 km visibility and technical check flights for high altitude maneuvers shall be operated in daylight only.",
    "sourceQuote": "Unless authorized by the NP Flight Operations, technical check flights involving circuit maneuvers only shall be restricted to ceiling of 1500 feet and 5 km visibility and technical check flights for high altitude maneuvers shall be operated in daylight only.",
    "sourceRects": [
      [
        105.85,
        500.25,
        552.67,
        511.25
      ],
      [
        105.85,
        513.25,
        552.7,
        524.25
      ],
      [
        105.85,
        526.25,
        340.67,
        537.25
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-313",
    "familyId": "oma8-en-313"
  },
  {
    "section": "8.7.6.1",
    "manualPage": "8.7-2",
    "pdfPage": 367,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "Crew A one engine inoperative take-off may only be made by a Commander who has completed the required training program and is qualified to perform such duty.",
    "sourceQuote": "Crew A one engine inoperative take-off may only be made by a Commander who has completed the required training program and is qualified to perform such duty.",
    "sourceRects": [
      [
        77.48,
        620.26,
        101.26,
        631.26
      ],
      [
        77.48,
        639.26,
        524.42,
        650.26
      ],
      [
        77.48,
        652.26,
        524.36,
        663.26
      ],
      [
        77.48,
        664.27,
        524.36,
        676.26
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-314",
    "familyId": "oma8-en-314"
  },
  {
    "section": "8.4.3.3.1",
    "manualPage": "8.4-43",
    "pdfPage": 329,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "landing",
      "take-off",
      "approach",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "If the weather conditions at the destination airport is not forecast to be at or above the landing minima, the flight shall be planned with two destination alternates.",
    "sourceQuote": "If the weather conditions at the destination airport is not forecast to be at or above the landing minima, the flight shall be planned with two destination alternates.",
    "sourceRects": [
      [
        105.82,
        543.25,
        552.8,
        554.25
      ],
      [
        105.82,
        556.26,
        360.08,
        567.26
      ]
    ],
    "topic": "weather",
    "id": "oma8-en-315",
    "familyId": "oma8-en-315"
  },
  {
    "section": "8.4.3.3.4",
    "manualPage": "8.4-45",
    "pdfPage": 331,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: phase of flight",
    "choices": [
      "approach",
      "take-off",
      "landing",
      "cruise"
    ],
    "correctIndex": 0,
    "explanation": "Unserviceability In the event of unserviceable equipment on the airport or aboard the aircraft check the allowable equipment degradation for CAT II and CAT III in QRH and/or MEL for required equipment and how it affects the approach.",
    "sourceQuote": "Unserviceability In the event of unserviceable equipment on the airport or aboard the aircraft check the allowable equipment degradation for CAT II and CAT III in QRH and/or MEL for required equipment and how it affects the approach.",
    "sourceRects": [
      [
        105.82,
        523.26,
        178.52,
        534.26
      ],
      [
        105.82,
        542.26,
        552.77,
        553.26
      ],
      [
        105.82,
        555.26,
        552.71,
        566.26
      ],
      [
        105.82,
        568.26,
        205.77,
        579.26
      ]
    ],
    "topic": "lvo",
    "id": "oma8-en-316",
    "familyId": "oma8-en-316"
  },
  {
    "section": "8.7.6.2",
    "manualPage": "8.7-2",
    "pdfPage": 367,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: crew member or operational role",
    "choices": [
      "Commander",
      "First Officer",
      "flight crew",
      "Flight Dispatcher"
    ],
    "correctIndex": 0,
    "explanation": "In addition, a maximum of two Mechanics, necessary for the engine change at the spare station and the stranded Commander may be carried on the ferry flight.",
    "sourceQuote": "In addition, a maximum of two Mechanics, necessary for the engine change at the spare station and the stranded Commander may be carried on the ferry flight.",
    "sourceRects": [
      [
        77.48,
        714.26,
        524.32,
        725.26
      ],
      [
        77.48,
        727.26,
        524.42,
        738.26
      ],
      [
        77.48,
        740.26,
        295.26,
        751.26
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-317",
    "familyId": "oma8-en-317"
  },
  {
    "section": "8.4.1.4.3",
    "manualPage": "8.4-4",
    "pdfPage": 290,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: To prevent any rush in initiating the descent and the resulting increased workload in conducting the approach, the descent preparation and the approach and go-around briefings typically should be completed [VALUE] before reaching TOD.",
    "choices": [
      "10 minutes",
      "5 minutes",
      "15 minutes",
      "3 minutes"
    ],
    "correctIndex": 0,
    "explanation": "To prevent any rush in initiating the descent and the resulting increased workload in conducting the approach, the descent preparation and the approach and go-around briefings typically should be completed 10 minutes before reaching TOD.",
    "sourceQuote": "To prevent any rush in initiating the descent and the resulting increased workload in conducting the approach, the descent preparation and the approach and go-around briefings typically should be completed 10 minutes before reaching TOD.",
    "sourceRects": [
      [
        77.48,
        715.27,
        524.42,
        726.27
      ],
      [
        77.48,
        727.28,
        524.36,
        739.27
      ],
      [
        77.48,
        741.27,
        254.7,
        752.27
      ]
    ],
    "topic": "minima",
    "id": "oma8-en-318",
    "familyId": "oma8-en-318"
  },
  {
    "section": "8.4.1.9.8",
    "manualPage": "8.4-22",
    "pdfPage": 308,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: [VALUE]. the landing lights should be turned on and airspeed should normally be restricted to 250 knots unless otherwise requested by ATC.",
    "choices": [
      "Below 10,000 feet",
      "Below 50 feet",
      "Below 100 feet",
      "Below 200 feet"
    ],
    "correctIndex": 0,
    "explanation": "Below 10,000 feet. the landing lights should be turned on and airspeed should normally be restricted to 250 knots unless otherwise requested by ATC.",
    "sourceQuote": "Below 10,000 feet. the landing lights should be turned on and airspeed should normally be restricted to 250 knots unless otherwise requested by ATC.",
    "sourceRects": [
      [
        77.47,
        512.26,
        524.32,
        523.26
      ],
      [
        77.47,
        525.26,
        524.36,
        536.26
      ],
      [
        77.47,
        538.26,
        235.5,
        549.26
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-319",
    "familyId": "oma8-en-319"
  },
  {
    "section": "8.4.1.10.13",
    "manualPage": "8.4-28",
    "pdfPage": 314,
    "pageWidth": 595.27,
    "pageHeight": 841.89,
    "prompt": "REFERENCE ONLY: To accomplish a safe and smooth landing the height of the airplane over the landing threshold should be [VALUE].",
    "choices": [
      "approximately 50 feet",
      "approximately 100 feet",
      "approximately 200 feet",
      "approximately 300 feet"
    ],
    "correctIndex": 0,
    "explanation": "To accomplish a safe and smooth landing the height of the airplane over the landing threshold should be approximately 50 feet.",
    "sourceQuote": "To accomplish a safe and smooth landing the height of the airplane over the landing threshold should be approximately 50 feet.",
    "sourceRects": [
      [
        77.48,
        128.26,
        524.32,
        139.26
      ],
      [
        77.48,
        141.26,
        524.28,
        152.26
      ],
      [
        77.48,
        154.26,
        524.32,
        165.26
      ],
      [
        77.48,
        167.26,
        440.21,
        178.26
      ]
    ],
    "topic": "procedures",
    "id": "oma8-en-320",
    "familyId": "oma8-en-320"
  }
] satisfies Question[];

export const topicLabels = {
  "flight-planning": "Flight planning",
  "aerodromes": "Aerodromes",
  "minima": "Minima and runways",
  "fuel": "Fuel",
  "mass-balance": "Mass and balance",
  "ground": "Ground procedures",
  "navigation": "Navigation",
  "weather": "Weather and hazards",
  "procedures": "Flight procedures",
  "lvo": "LVO / CAT II-III",
  "etops": "ETOPS",
  "mel": "MEL / CDL",
  "oxygen": "Oxygen",
  "efb": "EFB"
} satisfies Record<Topic, string>;
